(function (exports) {
  'use strict';

  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod2) => function __require() {
    return mod2 || (0, cb[__getOwnPropNames(cb)[0]])((mod2 = { exports: {} }).exports, mod2), mod2.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod2, isNodeMode, target) => (target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(
    isNodeMode || !mod2 || !mod2.__esModule ? __defProp(target, "default", { value: mod2, enumerable: true }) : target,
    mod2
  ));

  // node_modules/object-assign/index.js
  var require_object_assign = __commonJS({
    "node_modules/object-assign/index.js"(exports, module) {
      init_react_import();
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;
      function toObject(val) {
        if (val === null || val === void 0) {
          throw new TypeError("Object.assign cannot be called with null or undefined");
        }
        return Object(val);
      }
      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }
          var test1 = new String("abc");
          test1[5] = "de";
          if (Object.getOwnPropertyNames(test1)[0] === "5") {
            return false;
          }
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2["_" + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
            return test2[n2];
          });
          if (order2.join("") !== "0123456789") {
            return false;
          }
          var test3 = {};
          "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
          });
          if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
            return false;
          }
          return true;
        } catch (err) {
          return false;
        }
      }
      module.exports = shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for (var s2 = 1; s2 < arguments.length; s2++) {
          from = Object(arguments[s2]);
          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }
          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }
        return to;
      };
    }
  });

  // node_modules/react/cjs/react.production.min.js
  var require_react_production_min = __commonJS({
    "node_modules/react/cjs/react.production.min.js"(exports) {
      init_react_import();
      var l = require_object_assign();
      var n2 = "function" === typeof Symbol && Symbol.for;
      var p = n2 ? Symbol.for("react.element") : 60103;
      var q = n2 ? Symbol.for("react.portal") : 60106;
      var r = n2 ? Symbol.for("react.fragment") : 60107;
      var t2 = n2 ? Symbol.for("react.strict_mode") : 60108;
      var u = n2 ? Symbol.for("react.profiler") : 60114;
      var v = n2 ? Symbol.for("react.provider") : 60109;
      var w = n2 ? Symbol.for("react.context") : 60110;
      var x = n2 ? Symbol.for("react.forward_ref") : 60112;
      var y = n2 ? Symbol.for("react.suspense") : 60113;
      var z = n2 ? Symbol.for("react.memo") : 60115;
      var A = n2 ? Symbol.for("react.lazy") : 60116;
      var B = "function" === typeof Symbol && Symbol.iterator;
      function C(a) {
        for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)
          b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      var D = { isMounted: function() {
        return false;
      }, enqueueForceUpdate: function() {
      }, enqueueReplaceState: function() {
      }, enqueueSetState: function() {
      } };
      var E = {};
      function F(a, b, c) {
        this.props = a;
        this.context = b;
        this.refs = E;
        this.updater = c || D;
      }
      F.prototype.isReactComponent = {};
      F.prototype.setState = function(a, b) {
        if ("object" !== typeof a && "function" !== typeof a && null != a)
          throw Error(C(85));
        this.updater.enqueueSetState(this, a, b, "setState");
      };
      F.prototype.forceUpdate = function(a) {
        this.updater.enqueueForceUpdate(this, a, "forceUpdate");
      };
      function G() {
      }
      G.prototype = F.prototype;
      function H(a, b, c) {
        this.props = a;
        this.context = b;
        this.refs = E;
        this.updater = c || D;
      }
      var I = H.prototype = new G();
      I.constructor = H;
      l(I, F.prototype);
      I.isPureReactComponent = true;
      var J = { current: null };
      var K = Object.prototype.hasOwnProperty;
      var L = { key: true, ref: true, __self: true, __source: true };
      function M(a, b, c) {
        var e2, d = {}, g = null, k = null;
        if (null != b)
          for (e2 in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)
            K.call(b, e2) && !L.hasOwnProperty(e2) && (d[e2] = b[e2]);
        var f2 = arguments.length - 2;
        if (1 === f2)
          d.children = c;
        else if (1 < f2) {
          for (var h = Array(f2), m = 0; m < f2; m++)
            h[m] = arguments[m + 2];
          d.children = h;
        }
        if (a && a.defaultProps)
          for (e2 in f2 = a.defaultProps, f2)
            void 0 === d[e2] && (d[e2] = f2[e2]);
        return { $$typeof: p, type: a, key: g, ref: k, props: d, _owner: J.current };
      }
      function N(a, b) {
        return { $$typeof: p, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
      }
      function O(a) {
        return "object" === typeof a && null !== a && a.$$typeof === p;
      }
      function escape(a) {
        var b = { "=": "=0", ":": "=2" };
        return "$" + ("" + a).replace(/[=:]/g, function(a2) {
          return b[a2];
        });
      }
      var P = /\/+/g;
      var Q = [];
      function R(a, b, c, e2) {
        if (Q.length) {
          var d = Q.pop();
          d.result = a;
          d.keyPrefix = b;
          d.func = c;
          d.context = e2;
          d.count = 0;
          return d;
        }
        return { result: a, keyPrefix: b, func: c, context: e2, count: 0 };
      }
      function S(a) {
        a.result = null;
        a.keyPrefix = null;
        a.func = null;
        a.context = null;
        a.count = 0;
        10 > Q.length && Q.push(a);
      }
      function T(a, b, c, e2) {
        var d = typeof a;
        if ("undefined" === d || "boolean" === d)
          a = null;
        var g = false;
        if (null === a)
          g = true;
        else
          switch (d) {
            case "string":
            case "number":
              g = true;
              break;
            case "object":
              switch (a.$$typeof) {
                case p:
                case q:
                  g = true;
              }
          }
        if (g)
          return c(e2, a, "" === b ? "." + U(a, 0) : b), 1;
        g = 0;
        b = "" === b ? "." : b + ":";
        if (Array.isArray(a))
          for (var k = 0; k < a.length; k++) {
            d = a[k];
            var f2 = b + U(d, k);
            g += T(d, f2, c, e2);
          }
        else if (null === a || "object" !== typeof a ? f2 = null : (f2 = B && a[B] || a["@@iterator"], f2 = "function" === typeof f2 ? f2 : null), "function" === typeof f2)
          for (a = f2.call(a), k = 0; !(d = a.next()).done; )
            d = d.value, f2 = b + U(d, k++), g += T(d, f2, c, e2);
        else if ("object" === d)
          throw c = "" + a, Error(C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
        return g;
      }
      function V(a, b, c) {
        return null == a ? 0 : T(a, "", b, c);
      }
      function U(a, b) {
        return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
      }
      function W(a, b) {
        a.func.call(a.context, b, a.count++);
      }
      function aa(a, b, c) {
        var e2 = a.result, d = a.keyPrefix;
        a = a.func.call(a.context, b, a.count++);
        Array.isArray(a) ? X(a, e2, c, function(a2) {
          return a2;
        }) : null != a && (O(a) && (a = N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + c)), e2.push(a));
      }
      function X(a, b, c, e2, d) {
        var g = "";
        null != c && (g = ("" + c).replace(P, "$&/") + "/");
        b = R(b, g, e2, d);
        V(a, aa, b);
        S(b);
      }
      var Y = { current: null };
      function Z() {
        var a = Y.current;
        if (null === a)
          throw Error(C(321));
        return a;
      }
      var ba = { ReactCurrentDispatcher: Y, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: J, IsSomeRendererActing: { current: false }, assign: l };
      exports.Children = { map: function(a, b, c) {
        if (null == a)
          return a;
        var e2 = [];
        X(a, e2, null, b, c);
        return e2;
      }, forEach: function(a, b, c) {
        if (null == a)
          return a;
        b = R(null, null, b, c);
        V(a, W, b);
        S(b);
      }, count: function(a) {
        return V(a, function() {
          return null;
        }, null);
      }, toArray: function(a) {
        var b = [];
        X(a, b, null, function(a2) {
          return a2;
        });
        return b;
      }, only: function(a) {
        if (!O(a))
          throw Error(C(143));
        return a;
      } };
      exports.Component = F;
      exports.Fragment = r;
      exports.Profiler = u;
      exports.PureComponent = H;
      exports.StrictMode = t2;
      exports.Suspense = y;
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
      exports.cloneElement = function(a, b, c) {
        if (null === a || void 0 === a)
          throw Error(C(267, a));
        var e2 = l({}, a.props), d = a.key, g = a.ref, k = a._owner;
        if (null != b) {
          void 0 !== b.ref && (g = b.ref, k = J.current);
          void 0 !== b.key && (d = "" + b.key);
          if (a.type && a.type.defaultProps)
            var f2 = a.type.defaultProps;
          for (h in b)
            K.call(b, h) && !L.hasOwnProperty(h) && (e2[h] = void 0 === b[h] && void 0 !== f2 ? f2[h] : b[h]);
        }
        var h = arguments.length - 2;
        if (1 === h)
          e2.children = c;
        else if (1 < h) {
          f2 = Array(h);
          for (var m = 0; m < h; m++)
            f2[m] = arguments[m + 2];
          e2.children = f2;
        }
        return {
          $$typeof: p,
          type: a.type,
          key: d,
          ref: g,
          props: e2,
          _owner: k
        };
      };
      exports.createContext = function(a, b) {
        void 0 === b && (b = null);
        a = { $$typeof: w, _calculateChangedBits: b, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null };
        a.Provider = { $$typeof: v, _context: a };
        return a.Consumer = a;
      };
      exports.createElement = M;
      exports.createFactory = function(a) {
        var b = M.bind(null, a);
        b.type = a;
        return b;
      };
      exports.createRef = function() {
        return { current: null };
      };
      exports.forwardRef = function(a) {
        return { $$typeof: x, render: a };
      };
      exports.isValidElement = O;
      exports.lazy = function(a) {
        return { $$typeof: A, _ctor: a, _status: -1, _result: null };
      };
      exports.memo = function(a, b) {
        return { $$typeof: z, type: a, compare: void 0 === b ? null : b };
      };
      exports.useCallback = function(a, b) {
        return Z().useCallback(a, b);
      };
      exports.useContext = function(a, b) {
        return Z().useContext(a, b);
      };
      exports.useDebugValue = function() {
      };
      exports.useEffect = function(a, b) {
        return Z().useEffect(a, b);
      };
      exports.useImperativeHandle = function(a, b, c) {
        return Z().useImperativeHandle(a, b, c);
      };
      exports.useLayoutEffect = function(a, b) {
        return Z().useLayoutEffect(a, b);
      };
      exports.useMemo = function(a, b) {
        return Z().useMemo(a, b);
      };
      exports.useReducer = function(a, b, c) {
        return Z().useReducer(a, b, c);
      };
      exports.useRef = function(a) {
        return Z().useRef(a);
      };
      exports.useState = function(a) {
        return Z().useState(a);
      };
      exports.version = "16.14.0";
    }
  });

  // node_modules/react/index.js
  var require_react = __commonJS({
    "node_modules/react/index.js"(exports, module) {
      init_react_import();
      {
        module.exports = require_react_production_min();
      }
    }
  });

  // src/react-import.js
  var import_react;
  var init_react_import = __esm({
    "src/react-import.js"() {
      import_react = __toESM(require_react());
    }
  });

  // node_modules/scheduler/cjs/scheduler.production.min.js
  var require_scheduler_production_min = __commonJS({
    "node_modules/scheduler/cjs/scheduler.production.min.js"(exports) {
      init_react_import();
      var f2;
      var g;
      var h;
      var k;
      var l;
      if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
        p = null, q = null, t2 = function() {
          if (null !== p)
            try {
              var a = exports.unstable_now();
              p(true, a);
              p = null;
            } catch (b) {
              throw setTimeout(t2, 0), b;
            }
        }, u = Date.now();
        exports.unstable_now = function() {
          return Date.now() - u;
        };
        f2 = function(a) {
          null !== p ? setTimeout(f2, 0, a) : (p = a, setTimeout(t2, 0));
        };
        g = function(a, b) {
          q = setTimeout(a, b);
        };
        h = function() {
          clearTimeout(q);
        };
        k = function() {
          return false;
        };
        l = exports.unstable_forceFrameRate = function() {
        };
      } else {
        w = window.performance, x = window.Date, y = window.setTimeout, z = window.clearTimeout;
        if ("undefined" !== typeof console) {
          A = window.cancelAnimationFrame;
          "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
          "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        }
        if ("object" === typeof w && "function" === typeof w.now)
          exports.unstable_now = function() {
            return w.now();
          };
        else {
          B = x.now();
          exports.unstable_now = function() {
            return x.now() - B;
          };
        }
        C = false, D = null, E = -1, F = 5, G = 0;
        k = function() {
          return exports.unstable_now() >= G;
        };
        l = function() {
        };
        exports.unstable_forceFrameRate = function(a) {
          0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1e3 / a) : 5;
        };
        H = new MessageChannel(), I = H.port2;
        H.port1.onmessage = function() {
          if (null !== D) {
            var a = exports.unstable_now();
            G = a + F;
            try {
              D(true, a) ? I.postMessage(null) : (C = false, D = null);
            } catch (b) {
              throw I.postMessage(null), b;
            }
          } else
            C = false;
        };
        f2 = function(a) {
          D = a;
          C || (C = true, I.postMessage(null));
        };
        g = function(a, b) {
          E = y(function() {
            a(exports.unstable_now());
          }, b);
        };
        h = function() {
          z(E);
          E = -1;
        };
      }
      var p;
      var q;
      var t2;
      var u;
      var w;
      var x;
      var y;
      var z;
      var A;
      var B;
      var C;
      var D;
      var E;
      var F;
      var G;
      var H;
      var I;
      function J(a, b) {
        var c = a.length;
        a.push(b);
        a:
          for (; ; ) {
            var d = c - 1 >>> 1, e2 = a[d];
            if (void 0 !== e2 && 0 < K(e2, b))
              a[d] = b, a[c] = e2, c = d;
            else
              break a;
          }
      }
      function L(a) {
        a = a[0];
        return void 0 === a ? null : a;
      }
      function M(a) {
        var b = a[0];
        if (void 0 !== b) {
          var c = a.pop();
          if (c !== b) {
            a[0] = c;
            a:
              for (var d = 0, e2 = a.length; d < e2; ) {
                var m = 2 * (d + 1) - 1, n2 = a[m], v = m + 1, r = a[v];
                if (void 0 !== n2 && 0 > K(n2, c))
                  void 0 !== r && 0 > K(r, n2) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n2, a[m] = c, d = m);
                else if (void 0 !== r && 0 > K(r, c))
                  a[d] = r, a[v] = c, d = v;
                else
                  break a;
              }
          }
          return b;
        }
        return null;
      }
      function K(a, b) {
        var c = a.sortIndex - b.sortIndex;
        return 0 !== c ? c : a.id - b.id;
      }
      var N = [];
      var O = [];
      var P = 1;
      var Q = null;
      var R = 3;
      var S = false;
      var T = false;
      var U = false;
      function V(a) {
        for (var b = L(O); null !== b; ) {
          if (null === b.callback)
            M(O);
          else if (b.startTime <= a)
            M(O), b.sortIndex = b.expirationTime, J(N, b);
          else
            break;
          b = L(O);
        }
      }
      function W(a) {
        U = false;
        V(a);
        if (!T)
          if (null !== L(N))
            T = true, f2(X);
          else {
            var b = L(O);
            null !== b && g(W, b.startTime - a);
          }
      }
      function X(a, b) {
        T = false;
        U && (U = false, h());
        S = true;
        var c = R;
        try {
          V(b);
          for (Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k()); ) {
            var d = Q.callback;
            if (null !== d) {
              Q.callback = null;
              R = Q.priorityLevel;
              var e2 = d(Q.expirationTime <= b);
              b = exports.unstable_now();
              "function" === typeof e2 ? Q.callback = e2 : Q === L(N) && M(N);
              V(b);
            } else
              M(N);
            Q = L(N);
          }
          if (null !== Q)
            var m = true;
          else {
            var n2 = L(O);
            null !== n2 && g(W, n2.startTime - b);
            m = false;
          }
          return m;
        } finally {
          Q = null, R = c, S = false;
        }
      }
      function Y(a) {
        switch (a) {
          case 1:
            return -1;
          case 2:
            return 250;
          case 5:
            return 1073741823;
          case 4:
            return 1e4;
          default:
            return 5e3;
        }
      }
      var Z = l;
      exports.unstable_IdlePriority = 5;
      exports.unstable_ImmediatePriority = 1;
      exports.unstable_LowPriority = 4;
      exports.unstable_NormalPriority = 3;
      exports.unstable_Profiling = null;
      exports.unstable_UserBlockingPriority = 2;
      exports.unstable_cancelCallback = function(a) {
        a.callback = null;
      };
      exports.unstable_continueExecution = function() {
        T || S || (T = true, f2(X));
      };
      exports.unstable_getCurrentPriorityLevel = function() {
        return R;
      };
      exports.unstable_getFirstCallbackNode = function() {
        return L(N);
      };
      exports.unstable_next = function(a) {
        switch (R) {
          case 1:
          case 2:
          case 3:
            var b = 3;
            break;
          default:
            b = R;
        }
        var c = R;
        R = b;
        try {
          return a();
        } finally {
          R = c;
        }
      };
      exports.unstable_pauseExecution = function() {
      };
      exports.unstable_requestPaint = Z;
      exports.unstable_runWithPriority = function(a, b) {
        switch (a) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            a = 3;
        }
        var c = R;
        R = a;
        try {
          return b();
        } finally {
          R = c;
        }
      };
      exports.unstable_scheduleCallback = function(a, b, c) {
        var d = exports.unstable_now();
        if ("object" === typeof c && null !== c) {
          var e2 = c.delay;
          e2 = "number" === typeof e2 && 0 < e2 ? d + e2 : d;
          c = "number" === typeof c.timeout ? c.timeout : Y(a);
        } else
          c = Y(a), e2 = d;
        c = e2 + c;
        a = { id: P++, callback: b, priorityLevel: a, startTime: e2, expirationTime: c, sortIndex: -1 };
        e2 > d ? (a.sortIndex = e2, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = true, g(W, e2 - d))) : (a.sortIndex = c, J(N, a), T || S || (T = true, f2(X)));
        return a;
      };
      exports.unstable_shouldYield = function() {
        var a = exports.unstable_now();
        V(a);
        var b = L(N);
        return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
      };
      exports.unstable_wrapCallback = function(a) {
        var b = R;
        return function() {
          var c = R;
          R = b;
          try {
            return a.apply(this, arguments);
          } finally {
            R = c;
          }
        };
      };
    }
  });

  // node_modules/scheduler/index.js
  var require_scheduler = __commonJS({
    "node_modules/scheduler/index.js"(exports, module) {
      init_react_import();
      {
        module.exports = require_scheduler_production_min();
      }
    }
  });

  // node_modules/react-dom/cjs/react-dom.production.min.js
  var require_react_dom_production_min = __commonJS({
    "node_modules/react-dom/cjs/react-dom.production.min.js"(exports) {
      init_react_import();
      var aa = require_react();
      var n2 = require_object_assign();
      var r = require_scheduler();
      function u(a) {
        for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)
          b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      if (!aa)
        throw Error(u(227));
      function ba(a, b, c, d, e2, f2, g, h, k) {
        var l = Array.prototype.slice.call(arguments, 3);
        try {
          b.apply(c, l);
        } catch (m) {
          this.onError(m);
        }
      }
      var da = false;
      var ea = null;
      var fa = false;
      var ha = null;
      var ia = { onError: function(a) {
        da = true;
        ea = a;
      } };
      function ja(a, b, c, d, e2, f2, g, h, k) {
        da = false;
        ea = null;
        ba.apply(ia, arguments);
      }
      function ka(a, b, c, d, e2, f2, g, h, k) {
        ja.apply(this, arguments);
        if (da) {
          if (da) {
            var l = ea;
            da = false;
            ea = null;
          } else
            throw Error(u(198));
          fa || (fa = true, ha = l);
        }
      }
      var la = null;
      var ma = null;
      var na = null;
      function oa(a, b, c) {
        var d = a.type || "unknown-event";
        a.currentTarget = na(c);
        ka(d, b, void 0, a);
        a.currentTarget = null;
      }
      var pa = null;
      var qa = {};
      function ra() {
        if (pa)
          for (var a in qa) {
            var b = qa[a], c = pa.indexOf(a);
            if (!(-1 < c))
              throw Error(u(96, a));
            if (!sa[c]) {
              if (!b.extractEvents)
                throw Error(u(97, a));
              sa[c] = b;
              c = b.eventTypes;
              for (var d in c) {
                var e2 = void 0;
                var f2 = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h))
                  throw Error(u(99, h));
                ta[h] = f2;
                var k = f2.phasedRegistrationNames;
                if (k) {
                  for (e2 in k)
                    k.hasOwnProperty(e2) && ua(k[e2], g, h);
                  e2 = true;
                } else
                  f2.registrationName ? (ua(f2.registrationName, g, h), e2 = true) : e2 = false;
                if (!e2)
                  throw Error(u(98, d, a));
              }
            }
          }
      }
      function ua(a, b, c) {
        if (va[a])
          throw Error(u(100, a));
        va[a] = b;
        wa[a] = b.eventTypes[c].dependencies;
      }
      var sa = [];
      var ta = {};
      var va = {};
      var wa = {};
      function xa(a) {
        var b = false, c;
        for (c in a)
          if (a.hasOwnProperty(c)) {
            var d = a[c];
            if (!qa.hasOwnProperty(c) || qa[c] !== d) {
              if (qa[c])
                throw Error(u(102, c));
              qa[c] = d;
              b = true;
            }
          }
        b && ra();
      }
      var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement);
      var za = null;
      var Aa = null;
      var Ba = null;
      function Ca(a) {
        if (a = ma(a)) {
          if ("function" !== typeof za)
            throw Error(u(280));
          var b = a.stateNode;
          b && (b = la(b), za(a.stateNode, a.type, b));
        }
      }
      function Da(a) {
        Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
      }
      function Ea() {
        if (Aa) {
          var a = Aa, b = Ba;
          Ba = Aa = null;
          Ca(a);
          if (b)
            for (a = 0; a < b.length; a++)
              Ca(b[a]);
        }
      }
      function Fa(a, b) {
        return a(b);
      }
      function Ga(a, b, c, d, e2) {
        return a(b, c, d, e2);
      }
      function Ha() {
      }
      var Ia = Fa;
      var Ja = false;
      var Ka = false;
      function La() {
        if (null !== Aa || null !== Ba)
          Ha(), Ea();
      }
      function Ma(a, b, c) {
        if (Ka)
          return a(b, c);
        Ka = true;
        try {
          return Ia(a, b, c);
        } finally {
          Ka = false, La();
        }
      }
      var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/;
      var Oa = Object.prototype.hasOwnProperty;
      var Pa = {};
      var Qa = {};
      function Ra(a) {
        if (Oa.call(Qa, a))
          return true;
        if (Oa.call(Pa, a))
          return false;
        if (Na.test(a))
          return Qa[a] = true;
        Pa[a] = true;
        return false;
      }
      function Sa(a, b, c, d) {
        if (null !== c && 0 === c.type)
          return false;
        switch (typeof b) {
          case "function":
          case "symbol":
            return true;
          case "boolean":
            if (d)
              return false;
            if (null !== c)
              return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
          default:
            return false;
        }
      }
      function Ta(a, b, c, d) {
        if (null === b || "undefined" === typeof b || Sa(a, b, c, d))
          return true;
        if (d)
          return false;
        if (null !== c)
          switch (c.type) {
            case 3:
              return !b;
            case 4:
              return false === b;
            case 5:
              return isNaN(b);
            case 6:
              return isNaN(b) || 1 > b;
          }
        return false;
      }
      function v(a, b, c, d, e2, f2) {
        this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
        this.attributeName = d;
        this.attributeNamespace = e2;
        this.mustUseProperty = c;
        this.propertyName = a;
        this.type = b;
        this.sanitizeURL = f2;
      }
      var C = {};
      "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
        C[a] = new v(a, 0, false, a, null, false);
      });
      [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
        var b = a[0];
        C[b] = new v(b, 1, false, a[1], null, false);
      });
      ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
        C[a] = new v(a, 2, false, a.toLowerCase(), null, false);
      });
      ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
        C[a] = new v(a, 2, false, a, null, false);
      });
      "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
        C[a] = new v(a, 3, false, a.toLowerCase(), null, false);
      });
      ["checked", "multiple", "muted", "selected"].forEach(function(a) {
        C[a] = new v(a, 3, true, a, null, false);
      });
      ["capture", "download"].forEach(function(a) {
        C[a] = new v(a, 4, false, a, null, false);
      });
      ["cols", "rows", "size", "span"].forEach(function(a) {
        C[a] = new v(a, 6, false, a, null, false);
      });
      ["rowSpan", "start"].forEach(function(a) {
        C[a] = new v(a, 5, false, a.toLowerCase(), null, false);
      });
      var Ua = /[\-:]([a-z])/g;
      function Va(a) {
        return a[1].toUpperCase();
      }
      "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
        var b = a.replace(
          Ua,
          Va
        );
        C[b] = new v(b, 1, false, a, null, false);
      });
      "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
        var b = a.replace(Ua, Va);
        C[b] = new v(b, 1, false, a, "http://www.w3.org/1999/xlink", false);
      });
      ["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
        var b = a.replace(Ua, Va);
        C[b] = new v(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false);
      });
      ["tabIndex", "crossOrigin"].forEach(function(a) {
        C[a] = new v(a, 1, false, a.toLowerCase(), null, false);
      });
      C.xlinkHref = new v("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true);
      ["src", "href", "action", "formAction"].forEach(function(a) {
        C[a] = new v(a, 1, false, a.toLowerCase(), null, true);
      });
      var Wa = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = { current: null });
      Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = { suspense: null });
      function Xa(a, b, c, d) {
        var e2 = C.hasOwnProperty(b) ? C[b] : null;
        var f2 = null !== e2 ? 0 === e2.type : d ? false : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? false : true;
        f2 || (Ta(b, c, e2, d) && (c = null), d || null === e2 ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e2.mustUseProperty ? a[e2.propertyName] = null === c ? 3 === e2.type ? false : "" : c : (b = e2.attributeName, d = e2.attributeNamespace, null === c ? a.removeAttribute(b) : (e2 = e2.type, c = 3 === e2 || 4 === e2 && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
      }
      var Ya = /^(.*)[\\\/]/;
      var E = "function" === typeof Symbol && Symbol.for;
      var Za = E ? Symbol.for("react.element") : 60103;
      var $a = E ? Symbol.for("react.portal") : 60106;
      var ab = E ? Symbol.for("react.fragment") : 60107;
      var bb = E ? Symbol.for("react.strict_mode") : 60108;
      var cb = E ? Symbol.for("react.profiler") : 60114;
      var db = E ? Symbol.for("react.provider") : 60109;
      var eb = E ? Symbol.for("react.context") : 60110;
      var fb = E ? Symbol.for("react.concurrent_mode") : 60111;
      var gb = E ? Symbol.for("react.forward_ref") : 60112;
      var hb = E ? Symbol.for("react.suspense") : 60113;
      var ib = E ? Symbol.for("react.suspense_list") : 60120;
      var jb = E ? Symbol.for("react.memo") : 60115;
      var kb = E ? Symbol.for("react.lazy") : 60116;
      var lb = E ? Symbol.for("react.block") : 60121;
      var mb = "function" === typeof Symbol && Symbol.iterator;
      function nb(a) {
        if (null === a || "object" !== typeof a)
          return null;
        a = mb && a[mb] || a["@@iterator"];
        return "function" === typeof a ? a : null;
      }
      function ob(a) {
        if (-1 === a._status) {
          a._status = 0;
          var b = a._ctor;
          b = b();
          a._result = b;
          b.then(function(b2) {
            0 === a._status && (b2 = b2.default, a._status = 1, a._result = b2);
          }, function(b2) {
            0 === a._status && (a._status = 2, a._result = b2);
          });
        }
      }
      function pb(a) {
        if (null == a)
          return null;
        if ("function" === typeof a)
          return a.displayName || a.name || null;
        if ("string" === typeof a)
          return a;
        switch (a) {
          case ab:
            return "Fragment";
          case $a:
            return "Portal";
          case cb:
            return "Profiler";
          case bb:
            return "StrictMode";
          case hb:
            return "Suspense";
          case ib:
            return "SuspenseList";
        }
        if ("object" === typeof a)
          switch (a.$$typeof) {
            case eb:
              return "Context.Consumer";
            case db:
              return "Context.Provider";
            case gb:
              var b = a.render;
              b = b.displayName || b.name || "";
              return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
            case jb:
              return pb(a.type);
            case lb:
              return pb(a.render);
            case kb:
              if (a = 1 === a._status ? a._result : null)
                return pb(a);
          }
        return null;
      }
      function qb(a) {
        var b = "";
        do {
          a:
            switch (a.tag) {
              case 3:
              case 4:
              case 6:
              case 7:
              case 10:
              case 9:
                var c = "";
                break a;
              default:
                var d = a._debugOwner, e2 = a._debugSource, f2 = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f2;
                f2 = "";
                e2 ? f2 = " (at " + e2.fileName.replace(Ya, "") + ":" + e2.lineNumber + ")" : c && (f2 = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f2;
            }
          b += c;
          a = a.return;
        } while (a);
        return b;
      }
      function rb(a) {
        switch (typeof a) {
          case "boolean":
          case "number":
          case "object":
          case "string":
          case "undefined":
            return a;
          default:
            return "";
        }
      }
      function sb(a) {
        var b = a.type;
        return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
      }
      function tb(a) {
        var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
        if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
          var e2 = c.get, f2 = c.set;
          Object.defineProperty(a, b, { configurable: true, get: function() {
            return e2.call(this);
          }, set: function(a2) {
            d = "" + a2;
            f2.call(this, a2);
          } });
          Object.defineProperty(a, b, { enumerable: c.enumerable });
          return { getValue: function() {
            return d;
          }, setValue: function(a2) {
            d = "" + a2;
          }, stopTracking: function() {
            a._valueTracker = null;
            delete a[b];
          } };
        }
      }
      function xb(a) {
        a._valueTracker || (a._valueTracker = tb(a));
      }
      function yb(a) {
        if (!a)
          return false;
        var b = a._valueTracker;
        if (!b)
          return true;
        var c = b.getValue();
        var d = "";
        a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
        a = d;
        return a !== c ? (b.setValue(a), true) : false;
      }
      function zb(a, b) {
        var c = b.checked;
        return n2({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
      }
      function Ab(a, b) {
        var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
        c = rb(null != b.value ? b.value : c);
        a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
      }
      function Bb(a, b) {
        b = b.checked;
        null != b && Xa(a, "checked", b, false);
      }
      function Cb(a, b) {
        Bb(a, b);
        var c = rb(b.value), d = b.type;
        if (null != c)
          if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c)
              a.value = "" + c;
          } else
            a.value !== "" + c && (a.value = "" + c);
        else if ("submit" === d || "reset" === d) {
          a.removeAttribute("value");
          return;
        }
        b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
        null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
      }
      function Eb(a, b, c) {
        if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
          var d = b.type;
          if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value))
            return;
          b = "" + a._wrapperState.initialValue;
          c || b === a.value || (a.value = b);
          a.defaultValue = b;
        }
        c = a.name;
        "" !== c && (a.name = "");
        a.defaultChecked = !!a._wrapperState.initialChecked;
        "" !== c && (a.name = c);
      }
      function Db(a, b, c) {
        if ("number" !== b || a.ownerDocument.activeElement !== a)
          null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
      }
      function Fb(a) {
        var b = "";
        aa.Children.forEach(a, function(a2) {
          null != a2 && (b += a2);
        });
        return b;
      }
      function Gb(a, b) {
        a = n2({ children: void 0 }, b);
        if (b = Fb(b.children))
          a.children = b;
        return a;
      }
      function Hb(a, b, c, d) {
        a = a.options;
        if (b) {
          b = {};
          for (var e2 = 0; e2 < c.length; e2++)
            b["$" + c[e2]] = true;
          for (c = 0; c < a.length; c++)
            e2 = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e2 && (a[c].selected = e2), e2 && d && (a[c].defaultSelected = true);
        } else {
          c = "" + rb(c);
          b = null;
          for (e2 = 0; e2 < a.length; e2++) {
            if (a[e2].value === c) {
              a[e2].selected = true;
              d && (a[e2].defaultSelected = true);
              return;
            }
            null !== b || a[e2].disabled || (b = a[e2]);
          }
          null !== b && (b.selected = true);
        }
      }
      function Ib(a, b) {
        if (null != b.dangerouslySetInnerHTML)
          throw Error(u(91));
        return n2({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
      }
      function Jb(a, b) {
        var c = b.value;
        if (null == c) {
          c = b.children;
          b = b.defaultValue;
          if (null != c) {
            if (null != b)
              throw Error(u(92));
            if (Array.isArray(c)) {
              if (!(1 >= c.length))
                throw Error(u(93));
              c = c[0];
            }
            b = c;
          }
          null == b && (b = "");
          c = b;
        }
        a._wrapperState = { initialValue: rb(c) };
      }
      function Kb(a, b) {
        var c = rb(b.value), d = rb(b.defaultValue);
        null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
        null != d && (a.defaultValue = "" + d);
      }
      function Lb(a) {
        var b = a.textContent;
        b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
      }
      var Mb = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
      function Nb(a) {
        switch (a) {
          case "svg":
            return "http://www.w3.org/2000/svg";
          case "math":
            return "http://www.w3.org/1998/Math/MathML";
          default:
            return "http://www.w3.org/1999/xhtml";
        }
      }
      function Ob(a, b) {
        return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
      }
      var Pb;
      var Qb = function(a) {
        return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e2) {
          MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e2);
          });
        } : a;
      }(function(a, b) {
        if (a.namespaceURI !== Mb.svg || "innerHTML" in a)
          a.innerHTML = b;
        else {
          Pb = Pb || document.createElement("div");
          Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
          for (b = Pb.firstChild; a.firstChild; )
            a.removeChild(a.firstChild);
          for (; b.firstChild; )
            a.appendChild(b.firstChild);
        }
      });
      function Rb(a, b) {
        if (b) {
          var c = a.firstChild;
          if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
          }
        }
        a.textContent = b;
      }
      function Sb(a, b) {
        var c = {};
        c[a.toLowerCase()] = b.toLowerCase();
        c["Webkit" + a] = "webkit" + b;
        c["Moz" + a] = "moz" + b;
        return c;
      }
      var Tb = { animationend: Sb("Animation", "AnimationEnd"), animationiteration: Sb("Animation", "AnimationIteration"), animationstart: Sb("Animation", "AnimationStart"), transitionend: Sb("Transition", "TransitionEnd") };
      var Ub = {};
      var Vb = {};
      ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
      function Wb(a) {
        if (Ub[a])
          return Ub[a];
        if (!Tb[a])
          return a;
        var b = Tb[a], c;
        for (c in b)
          if (b.hasOwnProperty(c) && c in Vb)
            return Ub[a] = b[c];
        return a;
      }
      var Xb = Wb("animationend");
      var Yb = Wb("animationiteration");
      var Zb = Wb("animationstart");
      var $b = Wb("transitionend");
      var ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
      var bc = new ("function" === typeof WeakMap ? WeakMap : Map)();
      function cc(a) {
        var b = bc.get(a);
        void 0 === b && (b = /* @__PURE__ */ new Map(), bc.set(a, b));
        return b;
      }
      function dc(a) {
        var b = a, c = a;
        if (a.alternate)
          for (; b.return; )
            b = b.return;
        else {
          a = b;
          do
            b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
          while (a);
        }
        return 3 === b.tag ? c : null;
      }
      function ec(a) {
        if (13 === a.tag) {
          var b = a.memoizedState;
          null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
          if (null !== b)
            return b.dehydrated;
        }
        return null;
      }
      function fc(a) {
        if (dc(a) !== a)
          throw Error(u(188));
      }
      function gc(a) {
        var b = a.alternate;
        if (!b) {
          b = dc(a);
          if (null === b)
            throw Error(u(188));
          return b !== a ? null : a;
        }
        for (var c = a, d = b; ; ) {
          var e2 = c.return;
          if (null === e2)
            break;
          var f2 = e2.alternate;
          if (null === f2) {
            d = e2.return;
            if (null !== d) {
              c = d;
              continue;
            }
            break;
          }
          if (e2.child === f2.child) {
            for (f2 = e2.child; f2; ) {
              if (f2 === c)
                return fc(e2), a;
              if (f2 === d)
                return fc(e2), b;
              f2 = f2.sibling;
            }
            throw Error(u(188));
          }
          if (c.return !== d.return)
            c = e2, d = f2;
          else {
            for (var g = false, h = e2.child; h; ) {
              if (h === c) {
                g = true;
                c = e2;
                d = f2;
                break;
              }
              if (h === d) {
                g = true;
                d = e2;
                c = f2;
                break;
              }
              h = h.sibling;
            }
            if (!g) {
              for (h = f2.child; h; ) {
                if (h === c) {
                  g = true;
                  c = f2;
                  d = e2;
                  break;
                }
                if (h === d) {
                  g = true;
                  d = f2;
                  c = e2;
                  break;
                }
                h = h.sibling;
              }
              if (!g)
                throw Error(u(189));
            }
          }
          if (c.alternate !== d)
            throw Error(u(190));
        }
        if (3 !== c.tag)
          throw Error(u(188));
        return c.stateNode.current === c ? a : b;
      }
      function hc(a) {
        a = gc(a);
        if (!a)
          return null;
        for (var b = a; ; ) {
          if (5 === b.tag || 6 === b.tag)
            return b;
          if (b.child)
            b.child.return = b, b = b.child;
          else {
            if (b === a)
              break;
            for (; !b.sibling; ) {
              if (!b.return || b.return === a)
                return null;
              b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
          }
        }
        return null;
      }
      function ic(a, b) {
        if (null == b)
          throw Error(u(30));
        if (null == a)
          return b;
        if (Array.isArray(a)) {
          if (Array.isArray(b))
            return a.push.apply(a, b), a;
          a.push(b);
          return a;
        }
        return Array.isArray(b) ? [a].concat(b) : [a, b];
      }
      function jc(a, b, c) {
        Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
      }
      var kc = null;
      function lc(a) {
        if (a) {
          var b = a._dispatchListeners, c = a._dispatchInstances;
          if (Array.isArray(b))
            for (var d = 0; d < b.length && !a.isPropagationStopped(); d++)
              oa(a, b[d], c[d]);
          else
            b && oa(a, b, c);
          a._dispatchListeners = null;
          a._dispatchInstances = null;
          a.isPersistent() || a.constructor.release(a);
        }
      }
      function mc(a) {
        null !== a && (kc = ic(kc, a));
        a = kc;
        kc = null;
        if (a) {
          jc(a, lc);
          if (kc)
            throw Error(u(95));
          if (fa)
            throw a = ha, fa = false, ha = null, a;
        }
      }
      function nc(a) {
        a = a.target || a.srcElement || window;
        a.correspondingUseElement && (a = a.correspondingUseElement);
        return 3 === a.nodeType ? a.parentNode : a;
      }
      function oc(a) {
        if (!ya)
          return false;
        a = "on" + a;
        var b = a in document;
        b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
        return b;
      }
      var pc = [];
      function qc(a) {
        a.topLevelType = null;
        a.nativeEvent = null;
        a.targetInst = null;
        a.ancestors.length = 0;
        10 > pc.length && pc.push(a);
      }
      function rc(a, b, c, d) {
        if (pc.length) {
          var e2 = pc.pop();
          e2.topLevelType = a;
          e2.eventSystemFlags = d;
          e2.nativeEvent = b;
          e2.targetInst = c;
          return e2;
        }
        return { topLevelType: a, eventSystemFlags: d, nativeEvent: b, targetInst: c, ancestors: [] };
      }
      function sc(a) {
        var b = a.targetInst, c = b;
        do {
          if (!c) {
            a.ancestors.push(c);
            break;
          }
          var d = c;
          if (3 === d.tag)
            d = d.stateNode.containerInfo;
          else {
            for (; d.return; )
              d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
          }
          if (!d)
            break;
          b = c.tag;
          5 !== b && 6 !== b || a.ancestors.push(c);
          c = tc(d);
        } while (c);
        for (c = 0; c < a.ancestors.length; c++) {
          b = a.ancestors[c];
          var e2 = nc(a.nativeEvent);
          d = a.topLevelType;
          var f2 = a.nativeEvent, g = a.eventSystemFlags;
          0 === c && (g |= 64);
          for (var h = null, k = 0; k < sa.length; k++) {
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f2, e2, g)) && (h = ic(h, l));
          }
          mc(h);
        }
      }
      function uc(a, b, c) {
        if (!c.has(a)) {
          switch (a) {
            case "scroll":
              vc(b, "scroll", true);
              break;
            case "focus":
            case "blur":
              vc(b, "focus", true);
              vc(b, "blur", true);
              c.set("blur", null);
              c.set("focus", null);
              break;
            case "cancel":
            case "close":
              oc(a) && vc(b, a, true);
              break;
            case "invalid":
            case "submit":
            case "reset":
              break;
            default:
              -1 === ac.indexOf(a) && F(a, b);
          }
          c.set(a, null);
        }
      }
      var wc;
      var xc;
      var yc;
      var zc = false;
      var Ac = [];
      var Bc = null;
      var Cc = null;
      var Dc = null;
      var Ec = /* @__PURE__ */ new Map();
      var Fc = /* @__PURE__ */ new Map();
      var Gc = [];
      var Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" ");
      var Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
      function Jc(a, b) {
        var c = cc(b);
        Hc.forEach(function(a2) {
          uc(a2, b, c);
        });
        Ic.forEach(function(a2) {
          uc(a2, b, c);
        });
      }
      function Kc(a, b, c, d, e2) {
        return { blockedOn: a, topLevelType: b, eventSystemFlags: c | 32, nativeEvent: e2, container: d };
      }
      function Lc(a, b) {
        switch (a) {
          case "focus":
          case "blur":
            Bc = null;
            break;
          case "dragenter":
          case "dragleave":
            Cc = null;
            break;
          case "mouseover":
          case "mouseout":
            Dc = null;
            break;
          case "pointerover":
          case "pointerout":
            Ec.delete(b.pointerId);
            break;
          case "gotpointercapture":
          case "lostpointercapture":
            Fc.delete(b.pointerId);
        }
      }
      function Mc(a, b, c, d, e2, f2) {
        if (null === a || a.nativeEvent !== f2)
          return a = Kc(b, c, d, e2, f2), null !== b && (b = Nc(b), null !== b && xc(b)), a;
        a.eventSystemFlags |= d;
        return a;
      }
      function Oc(a, b, c, d, e2) {
        switch (b) {
          case "focus":
            return Bc = Mc(Bc, a, b, c, d, e2), true;
          case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e2), true;
          case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e2), true;
          case "pointerover":
            var f2 = e2.pointerId;
            Ec.set(f2, Mc(Ec.get(f2) || null, a, b, c, d, e2));
            return true;
          case "gotpointercapture":
            return f2 = e2.pointerId, Fc.set(f2, Mc(Fc.get(f2) || null, a, b, c, d, e2)), true;
        }
        return false;
      }
      function Pc(a) {
        var b = tc(a.target);
        if (null !== b) {
          var c = dc(b);
          if (null !== c) {
            if (b = c.tag, 13 === b) {
              if (b = ec(c), null !== b) {
                a.blockedOn = b;
                r.unstable_runWithPriority(a.priority, function() {
                  yc(c);
                });
                return;
              }
            } else if (3 === b && c.stateNode.hydrate) {
              a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
              return;
            }
          }
        }
        a.blockedOn = null;
      }
      function Qc(a) {
        if (null !== a.blockedOn)
          return false;
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        if (null !== b) {
          var c = Nc(b);
          null !== c && xc(c);
          a.blockedOn = b;
          return false;
        }
        return true;
      }
      function Sc(a, b, c) {
        Qc(a) && c.delete(b);
      }
      function Tc() {
        for (zc = false; 0 < Ac.length; ) {
          var a = Ac[0];
          if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
          }
          var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
          null !== b ? a.blockedOn = b : Ac.shift();
        }
        null !== Bc && Qc(Bc) && (Bc = null);
        null !== Cc && Qc(Cc) && (Cc = null);
        null !== Dc && Qc(Dc) && (Dc = null);
        Ec.forEach(Sc);
        Fc.forEach(Sc);
      }
      function Uc(a, b) {
        a.blockedOn === b && (a.blockedOn = null, zc || (zc = true, r.unstable_scheduleCallback(r.unstable_NormalPriority, Tc)));
      }
      function Vc(a) {
        function b(b2) {
          return Uc(b2, a);
        }
        if (0 < Ac.length) {
          Uc(Ac[0], a);
          for (var c = 1; c < Ac.length; c++) {
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
          }
        }
        null !== Bc && Uc(Bc, a);
        null !== Cc && Uc(Cc, a);
        null !== Dc && Uc(Dc, a);
        Ec.forEach(b);
        Fc.forEach(b);
        for (c = 0; c < Gc.length; c++)
          d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
        for (; 0 < Gc.length && (c = Gc[0], null === c.blockedOn); )
          Pc(c), null === c.blockedOn && Gc.shift();
      }
      var Wc = {};
      var Yc = /* @__PURE__ */ new Map();
      var Zc = /* @__PURE__ */ new Map();
      var $c = [
        "abort",
        "abort",
        Xb,
        "animationEnd",
        Yb,
        "animationIteration",
        Zb,
        "animationStart",
        "canplay",
        "canPlay",
        "canplaythrough",
        "canPlayThrough",
        "durationchange",
        "durationChange",
        "emptied",
        "emptied",
        "encrypted",
        "encrypted",
        "ended",
        "ended",
        "error",
        "error",
        "gotpointercapture",
        "gotPointerCapture",
        "load",
        "load",
        "loadeddata",
        "loadedData",
        "loadedmetadata",
        "loadedMetadata",
        "loadstart",
        "loadStart",
        "lostpointercapture",
        "lostPointerCapture",
        "playing",
        "playing",
        "progress",
        "progress",
        "seeking",
        "seeking",
        "stalled",
        "stalled",
        "suspend",
        "suspend",
        "timeupdate",
        "timeUpdate",
        $b,
        "transitionEnd",
        "waiting",
        "waiting"
      ];
      function ad(a, b) {
        for (var c = 0; c < a.length; c += 2) {
          var d = a[c], e2 = a[c + 1], f2 = "on" + (e2[0].toUpperCase() + e2.slice(1));
          f2 = { phasedRegistrationNames: { bubbled: f2, captured: f2 + "Capture" }, dependencies: [d], eventPriority: b };
          Zc.set(d, b);
          Yc.set(d, f2);
          Wc[e2] = f2;
        }
      }
      ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
      ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
      ad($c, 2);
      for (bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)
        Zc.set(bd[cd], 0);
      var bd;
      var cd;
      var dd = r.unstable_UserBlockingPriority;
      var ed = r.unstable_runWithPriority;
      var fd = true;
      function F(a, b) {
        vc(b, a, false);
      }
      function vc(a, b, c) {
        var d = Zc.get(b);
        switch (void 0 === d ? 2 : d) {
          case 0:
            d = gd.bind(null, b, 1, a);
            break;
          case 1:
            d = hd.bind(null, b, 1, a);
            break;
          default:
            d = id.bind(null, b, 1, a);
        }
        c ? a.addEventListener(b, d, true) : a.addEventListener(b, d, false);
      }
      function gd(a, b, c, d) {
        Ja || Ha();
        var e2 = id, f2 = Ja;
        Ja = true;
        try {
          Ga(e2, a, b, c, d);
        } finally {
          (Ja = f2) || La();
        }
      }
      function hd(a, b, c, d) {
        ed(dd, id.bind(null, a, b, c, d));
      }
      function id(a, b, c, d) {
        if (fd)
          if (0 < Ac.length && -1 < Hc.indexOf(a))
            a = Kc(null, a, b, c, d), Ac.push(a);
          else {
            var e2 = Rc(a, b, c, d);
            if (null === e2)
              Lc(a, d);
            else if (-1 < Hc.indexOf(a))
              a = Kc(e2, a, b, c, d), Ac.push(a);
            else if (!Oc(e2, a, b, c, d)) {
              Lc(a, d);
              a = rc(a, d, null, b);
              try {
                Ma(sc, a);
              } finally {
                qc(a);
              }
            }
          }
      }
      function Rc(a, b, c, d) {
        c = nc(d);
        c = tc(c);
        if (null !== c) {
          var e2 = dc(c);
          if (null === e2)
            c = null;
          else {
            var f2 = e2.tag;
            if (13 === f2) {
              c = ec(e2);
              if (null !== c)
                return c;
              c = null;
            } else if (3 === f2) {
              if (e2.stateNode.hydrate)
                return 3 === e2.tag ? e2.stateNode.containerInfo : null;
              c = null;
            } else
              e2 !== c && (c = null);
          }
        }
        a = rc(a, d, c, b);
        try {
          Ma(sc, a);
        } finally {
          qc(a);
        }
        return null;
      }
      var jd = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };
      var kd = ["Webkit", "ms", "Moz", "O"];
      Object.keys(jd).forEach(function(a) {
        kd.forEach(function(b) {
          b = b + a.charAt(0).toUpperCase() + a.substring(1);
          jd[b] = jd[a];
        });
      });
      function ld(a, b, c) {
        return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
      }
      function md(a, b) {
        a = a.style;
        for (var c in b)
          if (b.hasOwnProperty(c)) {
            var d = 0 === c.indexOf("--"), e2 = ld(c, b[c], d);
            "float" === c && (c = "cssFloat");
            d ? a.setProperty(c, e2) : a[c] = e2;
          }
      }
      var nd = n2({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
      function od(a, b) {
        if (b) {
          if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML))
            throw Error(u(137, a, ""));
          if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children)
              throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML))
              throw Error(u(61));
          }
          if (null != b.style && "object" !== typeof b.style)
            throw Error(u(62, ""));
        }
      }
      function pd(a, b) {
        if (-1 === a.indexOf("-"))
          return "string" === typeof b.is;
        switch (a) {
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return false;
          default:
            return true;
        }
      }
      var qd = Mb.html;
      function rd(a, b) {
        a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
        var c = cc(a);
        b = wa[b];
        for (var d = 0; d < b.length; d++)
          uc(b[d], a, c);
      }
      function sd() {
      }
      function td(a) {
        a = a || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof a)
          return null;
        try {
          return a.activeElement || a.body;
        } catch (b) {
          return a.body;
        }
      }
      function ud(a) {
        for (; a && a.firstChild; )
          a = a.firstChild;
        return a;
      }
      function vd(a, b) {
        var c = ud(a);
        a = 0;
        for (var d; c; ) {
          if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b)
              return { node: c, offset: b - a };
            a = d;
          }
          a: {
            for (; c; ) {
              if (c.nextSibling) {
                c = c.nextSibling;
                break a;
              }
              c = c.parentNode;
            }
            c = void 0;
          }
          c = ud(c);
        }
      }
      function wd(a, b) {
        return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
      }
      function xd() {
        for (var a = window, b = td(); b instanceof a.HTMLIFrameElement; ) {
          try {
            var c = "string" === typeof b.contentWindow.location.href;
          } catch (d) {
            c = false;
          }
          if (c)
            a = b.contentWindow;
          else
            break;
          b = td(a.document);
        }
        return b;
      }
      function yd(a) {
        var b = a && a.nodeName && a.nodeName.toLowerCase();
        return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
      }
      var zd = "$";
      var Ad = "/$";
      var Bd = "$?";
      var Cd = "$!";
      var Dd = null;
      var Ed = null;
      function Fd(a, b) {
        switch (a) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            return !!b.autoFocus;
        }
        return false;
      }
      function Gd(a, b) {
        return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
      }
      var Hd = "function" === typeof setTimeout ? setTimeout : void 0;
      var Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
      function Jd(a) {
        for (; null != a; a = a.nextSibling) {
          var b = a.nodeType;
          if (1 === b || 3 === b)
            break;
        }
        return a;
      }
      function Kd(a) {
        a = a.previousSibling;
        for (var b = 0; a; ) {
          if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
              if (0 === b)
                return a;
              b--;
            } else
              c === Ad && b++;
          }
          a = a.previousSibling;
        }
        return null;
      }
      var Ld = Math.random().toString(36).slice(2);
      var Md = "__reactInternalInstance$" + Ld;
      var Nd = "__reactEventHandlers$" + Ld;
      var Od = "__reactContainere$" + Ld;
      function tc(a) {
        var b = a[Md];
        if (b)
          return b;
        for (var c = a.parentNode; c; ) {
          if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child)
              for (a = Kd(a); null !== a; ) {
                if (c = a[Md])
                  return c;
                a = Kd(a);
              }
            return b;
          }
          a = c;
          c = a.parentNode;
        }
        return null;
      }
      function Nc(a) {
        a = a[Md] || a[Od];
        return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
      }
      function Pd(a) {
        if (5 === a.tag || 6 === a.tag)
          return a.stateNode;
        throw Error(u(33));
      }
      function Qd(a) {
        return a[Nd] || null;
      }
      function Rd(a) {
        do
          a = a.return;
        while (a && 5 !== a.tag);
        return a ? a : null;
      }
      function Sd(a, b) {
        var c = a.stateNode;
        if (!c)
          return null;
        var d = la(c);
        if (!d)
          return null;
        c = d[b];
        a:
          switch (b) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
              a = !d;
              break a;
            default:
              a = false;
          }
        if (a)
          return null;
        if (c && "function" !== typeof c)
          throw Error(u(
            231,
            b,
            typeof c
          ));
        return c;
      }
      function Td(a, b, c) {
        if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b]))
          c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
      }
      function Ud(a) {
        if (a && a.dispatchConfig.phasedRegistrationNames) {
          for (var b = a._targetInst, c = []; b; )
            c.push(b), b = Rd(b);
          for (b = c.length; 0 < b--; )
            Td(c[b], "captured", a);
          for (b = 0; b < c.length; b++)
            Td(c[b], "bubbled", a);
        }
      }
      function Vd(a, b, c) {
        a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
      }
      function Wd(a) {
        a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
      }
      function Xd(a) {
        jc(a, Ud);
      }
      var Yd = null;
      var Zd = null;
      var $d = null;
      function ae() {
        if ($d)
          return $d;
        var a, b = Zd, c = b.length, d, e2 = "value" in Yd ? Yd.value : Yd.textContent, f2 = e2.length;
        for (a = 0; a < c && b[a] === e2[a]; a++)
          ;
        var g = c - a;
        for (d = 1; d <= g && b[c - d] === e2[f2 - d]; d++)
          ;
        return $d = e2.slice(a, 1 < d ? 1 - d : void 0);
      }
      function be() {
        return true;
      }
      function ce() {
        return false;
      }
      function G(a, b, c, d) {
        this.dispatchConfig = a;
        this._targetInst = b;
        this.nativeEvent = c;
        a = this.constructor.Interface;
        for (var e2 in a)
          a.hasOwnProperty(e2) && ((b = a[e2]) ? this[e2] = b(c) : "target" === e2 ? this.target = d : this[e2] = c[e2]);
        this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : false === c.returnValue) ? be : ce;
        this.isPropagationStopped = ce;
        return this;
      }
      n2(G.prototype, { preventDefault: function() {
        this.defaultPrevented = true;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = false), this.isDefaultPrevented = be);
      }, stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = true), this.isPropagationStopped = be);
      }, persist: function() {
        this.isPersistent = be;
      }, isPersistent: ce, destructor: function() {
        var a = this.constructor.Interface, b;
        for (b in a)
          this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
      } });
      G.Interface = { type: null, target: null, currentTarget: function() {
        return null;
      }, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function(a) {
        return a.timeStamp || Date.now();
      }, defaultPrevented: null, isTrusted: null };
      G.extend = function(a) {
        function b() {
        }
        function c() {
          return d.apply(this, arguments);
        }
        var d = this;
        b.prototype = d.prototype;
        var e2 = new b();
        n2(e2, c.prototype);
        c.prototype = e2;
        c.prototype.constructor = c;
        c.Interface = n2({}, d.Interface, a);
        c.extend = d.extend;
        de(c);
        return c;
      };
      de(G);
      function ee(a, b, c, d) {
        if (this.eventPool.length) {
          var e2 = this.eventPool.pop();
          this.call(e2, a, b, c, d);
          return e2;
        }
        return new this(a, b, c, d);
      }
      function fe(a) {
        if (!(a instanceof this))
          throw Error(u(279));
        a.destructor();
        10 > this.eventPool.length && this.eventPool.push(a);
      }
      function de(a) {
        a.eventPool = [];
        a.getPooled = ee;
        a.release = fe;
      }
      var ge = G.extend({ data: null });
      var he = G.extend({ data: null });
      var ie = [9, 13, 27, 32];
      var je = ya && "CompositionEvent" in window;
      var ke = null;
      ya && "documentMode" in document && (ke = document.documentMode);
      var le = ya && "TextEvent" in window && !ke;
      var me = ya && (!je || ke && 8 < ke && 11 >= ke);
      var ne = String.fromCharCode(32);
      var oe = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } };
      var pe = false;
      function qe(a, b) {
        switch (a) {
          case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
          case "keydown":
            return 229 !== b.keyCode;
          case "keypress":
          case "mousedown":
          case "blur":
            return true;
          default:
            return false;
        }
      }
      function re(a) {
        a = a.detail;
        return "object" === typeof a && "data" in a ? a.data : null;
      }
      var se = false;
      function te(a, b) {
        switch (a) {
          case "compositionend":
            return re(b);
          case "keypress":
            if (32 !== b.which)
              return null;
            pe = true;
            return ne;
          case "textInput":
            return a = b.data, a === ne && pe ? null : a;
          default:
            return null;
        }
      }
      function ue(a, b) {
        if (se)
          return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = false, a) : null;
        switch (a) {
          case "paste":
            return null;
          case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
              if (b.char && 1 < b.char.length)
                return b.char;
              if (b.which)
                return String.fromCharCode(b.which);
            }
            return null;
          case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
          default:
            return null;
        }
      }
      var ve = { eventTypes: oe, extractEvents: function(a, b, c, d) {
        var e2;
        if (je)
          b: {
            switch (a) {
              case "compositionstart":
                var f2 = oe.compositionStart;
                break b;
              case "compositionend":
                f2 = oe.compositionEnd;
                break b;
              case "compositionupdate":
                f2 = oe.compositionUpdate;
                break b;
            }
            f2 = void 0;
          }
        else
          se ? qe(a, c) && (f2 = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f2 = oe.compositionStart);
        f2 ? (me && "ko" !== c.locale && (se || f2 !== oe.compositionStart ? f2 === oe.compositionEnd && se && (e2 = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = true)), f2 = ge.getPooled(
          f2,
          b,
          c,
          d
        ), e2 ? f2.data = e2 : (e2 = re(c), null !== e2 && (f2.data = e2)), Xd(f2), e2 = f2) : e2 = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e2 ? b : null === b ? e2 : [e2, b];
      } };
      var we = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
      function xe(a) {
        var b = a && a.nodeName && a.nodeName.toLowerCase();
        return "input" === b ? !!we[a.type] : "textarea" === b ? true : false;
      }
      var ye = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };
      function ze(a, b, c) {
        a = G.getPooled(ye.change, a, b, c);
        a.type = "change";
        Da(c);
        Xd(a);
        return a;
      }
      var Ae = null;
      var Be = null;
      function Ce(a) {
        mc(a);
      }
      function De(a) {
        var b = Pd(a);
        if (yb(b))
          return a;
      }
      function Ee(a, b) {
        if ("change" === a)
          return b;
      }
      var Fe = false;
      ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
      function Ge() {
        Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
      }
      function He(a) {
        if ("value" === a.propertyName && De(Be))
          if (a = ze(Be, a, nc(a)), Ja)
            mc(a);
          else {
            Ja = true;
            try {
              Fa(Ce, a);
            } finally {
              Ja = false, La();
            }
          }
      }
      function Ie(a, b, c) {
        "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
      }
      function Je(a) {
        if ("selectionchange" === a || "keyup" === a || "keydown" === a)
          return De(Be);
      }
      function Ke(a, b) {
        if ("click" === a)
          return De(b);
      }
      function Le(a, b) {
        if ("input" === a || "change" === a)
          return De(b);
      }
      var Me = { eventTypes: ye, _isInputEventSupported: Fe, extractEvents: function(a, b, c, d) {
        var e2 = b ? Pd(b) : window, f2 = e2.nodeName && e2.nodeName.toLowerCase();
        if ("select" === f2 || "input" === f2 && "file" === e2.type)
          var g = Ee;
        else if (xe(e2))
          if (Fe)
            g = Le;
          else {
            g = Je;
            var h = Ie;
          }
        else
          (f2 = e2.nodeName) && "input" === f2.toLowerCase() && ("checkbox" === e2.type || "radio" === e2.type) && (g = Ke);
        if (g && (g = g(a, b)))
          return ze(g, c, d);
        h && h(a, e2, b);
        "blur" === a && (a = e2._wrapperState) && a.controlled && "number" === e2.type && Db(e2, "number", e2.value);
      } };
      var Ne = G.extend({ view: null, detail: null });
      var Oe = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
      function Pe(a) {
        var b = this.nativeEvent;
        return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : false;
      }
      function Qe() {
        return Pe;
      }
      var Re = 0;
      var Se = 0;
      var Te = false;
      var Ue = false;
      var Ve = Ne.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Qe, button: null, buttons: null, relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
      }, movementX: function(a) {
        if ("movementX" in a)
          return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = true, 0);
      }, movementY: function(a) {
        if ("movementY" in a)
          return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = true, 0);
      } });
      var We = Ve.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null });
      var Xe = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: ["pointerout", "pointerover"]
      } };
      var Ye = { eventTypes: Xe, extractEvents: function(a, b, c, d, e2) {
        var f2 = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f2 && 0 === (e2 & 32) && (c.relatedTarget || c.fromElement) || !g && !f2)
          return null;
        f2 = d.window === d ? d : (f2 = d.ownerDocument) ? f2.defaultView || f2.parentWindow : window;
        if (g) {
          if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
            var h = dc(b);
            if (b !== h || 5 !== b.tag && 6 !== b.tag)
              b = null;
          }
        } else
          g = null;
        if (g === b)
          return null;
        if ("mouseout" === a || "mouseover" === a) {
          var k = Ve;
          var l = Xe.mouseLeave;
          var m = Xe.mouseEnter;
          var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a)
          k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f2 : Pd(g);
        f2 = null == b ? f2 : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f2;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f2;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p)
          a: {
            k = d;
            m = p;
            g = 0;
            for (a = k; a; a = Rd(a))
              g++;
            a = 0;
            for (b = m; b; b = Rd(b))
              a++;
            for (; 0 < g - a; )
              k = Rd(k), g--;
            for (; 0 < a - g; )
              m = Rd(m), a--;
            for (; g--; ) {
              if (k === m || k === m.alternate)
                break a;
              k = Rd(k);
              m = Rd(m);
            }
            k = null;
          }
        else
          k = null;
        m = k;
        for (k = []; d && d !== m; ) {
          g = d.alternate;
          if (null !== g && g === m)
            break;
          k.push(d);
          d = Rd(d);
        }
        for (d = []; p && p !== m; ) {
          g = p.alternate;
          if (null !== g && g === m)
            break;
          d.push(p);
          p = Rd(p);
        }
        for (p = 0; p < k.length; p++)
          Vd(k[p], "bubbled", l);
        for (p = d.length; 0 < p--; )
          Vd(d[p], "captured", c);
        return 0 === (e2 & 64) ? [l] : [l, c];
      } };
      function Ze(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
      }
      var $e = "function" === typeof Object.is ? Object.is : Ze;
      var af = Object.prototype.hasOwnProperty;
      function bf(a, b) {
        if ($e(a, b))
          return true;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b)
          return false;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length)
          return false;
        for (d = 0; d < c.length; d++)
          if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]]))
            return false;
        return true;
      }
      var cf = ya && "documentMode" in document && 11 >= document.documentMode;
      var df = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } };
      var ef = null;
      var ff = null;
      var gf = null;
      var hf = false;
      function jf(a, b) {
        var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
        if (hf || null == ef || ef !== td(c))
          return null;
        c = ef;
        "selectionStart" in c && yd(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });
        return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
      }
      var kf = { eventTypes: df, extractEvents: function(a, b, c, d, e2, f2) {
        e2 = f2 || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f2 = !e2)) {
          a: {
            e2 = cc(e2);
            f2 = wa.onSelect;
            for (var g = 0; g < f2.length; g++)
              if (!e2.has(f2[g])) {
                e2 = false;
                break a;
              }
            e2 = true;
          }
          f2 = !e2;
        }
        if (f2)
          return null;
        e2 = b ? Pd(b) : window;
        switch (a) {
          case "focus":
            if (xe(e2) || "true" === e2.contentEditable)
              ef = e2, ff = b, gf = null;
            break;
          case "blur":
            gf = ff = ef = null;
            break;
          case "mousedown":
            hf = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            return hf = false, jf(c, d);
          case "selectionchange":
            if (cf)
              break;
          case "keydown":
          case "keyup":
            return jf(c, d);
        }
        return null;
      } };
      var lf = G.extend({ animationName: null, elapsedTime: null, pseudoElement: null });
      var mf = G.extend({ clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
      } });
      var nf = Ne.extend({ relatedTarget: null });
      function of(a) {
        var b = a.keyCode;
        "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
        10 === a && (a = 13);
        return 32 <= a || 13 === a ? a : 0;
      }
      var pf = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" };
      var qf = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
      var rf = Ne.extend({ key: function(a) {
        if (a.key) {
          var b = pf[a.key] || a.key;
          if ("Unidentified" !== b)
            return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
      }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Qe, charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
      }, keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
      }, which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
      } });
      var sf = Ve.extend({ dataTransfer: null });
      var tf = Ne.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Qe });
      var uf = G.extend({ propertyName: null, elapsedTime: null, pseudoElement: null });
      var vf = Ve.extend({ deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
      }, deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
      }, deltaZ: null, deltaMode: null });
      var wf = { eventTypes: Wc, extractEvents: function(a, b, c, d) {
        var e2 = Yc.get(a);
        if (!e2)
          return null;
        switch (a) {
          case "keypress":
            if (0 === of(c))
              return null;
          case "keydown":
          case "keyup":
            a = rf;
            break;
          case "blur":
          case "focus":
            a = nf;
            break;
          case "click":
            if (2 === c.button)
              return null;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            a = Ve;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            a = sf;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            a = tf;
            break;
          case Xb:
          case Yb:
          case Zb:
            a = lf;
            break;
          case $b:
            a = uf;
            break;
          case "scroll":
            a = Ne;
            break;
          case "wheel":
            a = vf;
            break;
          case "copy":
          case "cut":
          case "paste":
            a = mf;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            a = We;
            break;
          default:
            a = G;
        }
        b = a.getPooled(e2, b, c, d);
        Xd(b);
        return b;
      } };
      if (pa)
        throw Error(u(101));
      pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
      ra();
      var xf = Nc;
      la = Qd;
      ma = xf;
      na = Pd;
      xa({ SimpleEventPlugin: wf, EnterLeaveEventPlugin: Ye, ChangeEventPlugin: Me, SelectEventPlugin: kf, BeforeInputEventPlugin: ve });
      var yf = [];
      var zf = -1;
      function H(a) {
        0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
      }
      function I(a, b) {
        zf++;
        yf[zf] = a.current;
        a.current = b;
      }
      var Af = {};
      var J = { current: Af };
      var K = { current: false };
      var Bf = Af;
      function Cf(a, b) {
        var c = a.type.contextTypes;
        if (!c)
          return Af;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b)
          return d.__reactInternalMemoizedMaskedChildContext;
        var e2 = {}, f2;
        for (f2 in c)
          e2[f2] = b[f2];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e2);
        return e2;
      }
      function L(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
      }
      function Df() {
        H(K);
        H(J);
      }
      function Ef(a, b, c) {
        if (J.current !== Af)
          throw Error(u(168));
        I(J, b);
        I(K, c);
      }
      function Ff(a, b, c) {
        var d = a.stateNode;
        a = b.childContextTypes;
        if ("function" !== typeof d.getChildContext)
          return c;
        d = d.getChildContext();
        for (var e2 in d)
          if (!(e2 in a))
            throw Error(u(108, pb(b) || "Unknown", e2));
        return n2({}, c, {}, d);
      }
      function Gf(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
        Bf = J.current;
        I(J, a);
        I(K, K.current);
        return true;
      }
      function Hf(a, b, c) {
        var d = a.stateNode;
        if (!d)
          throw Error(u(169));
        c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
        I(K, c);
      }
      var If = r.unstable_runWithPriority;
      var Jf = r.unstable_scheduleCallback;
      var Kf = r.unstable_cancelCallback;
      var Lf = r.unstable_requestPaint;
      var Mf = r.unstable_now;
      var Nf = r.unstable_getCurrentPriorityLevel;
      var Of = r.unstable_ImmediatePriority;
      var Pf = r.unstable_UserBlockingPriority;
      var Qf = r.unstable_NormalPriority;
      var Rf = r.unstable_LowPriority;
      var Sf = r.unstable_IdlePriority;
      var Tf = {};
      var Uf = r.unstable_shouldYield;
      var Vf = void 0 !== Lf ? Lf : function() {
      };
      var Wf = null;
      var Xf = null;
      var Yf = false;
      var Zf = Mf();
      var $f = 1e4 > Zf ? Mf : function() {
        return Mf() - Zf;
      };
      function ag() {
        switch (Nf()) {
          case Of:
            return 99;
          case Pf:
            return 98;
          case Qf:
            return 97;
          case Rf:
            return 96;
          case Sf:
            return 95;
          default:
            throw Error(u(332));
        }
      }
      function bg(a) {
        switch (a) {
          case 99:
            return Of;
          case 98:
            return Pf;
          case 97:
            return Qf;
          case 96:
            return Rf;
          case 95:
            return Sf;
          default:
            throw Error(u(332));
        }
      }
      function cg(a, b) {
        a = bg(a);
        return If(a, b);
      }
      function dg(a, b, c) {
        a = bg(a);
        return Jf(a, b, c);
      }
      function eg(a) {
        null === Wf ? (Wf = [a], Xf = Jf(Of, fg)) : Wf.push(a);
        return Tf;
      }
      function gg() {
        if (null !== Xf) {
          var a = Xf;
          Xf = null;
          Kf(a);
        }
        fg();
      }
      function fg() {
        if (!Yf && null !== Wf) {
          Yf = true;
          var a = 0;
          try {
            var b = Wf;
            cg(99, function() {
              for (; a < b.length; a++) {
                var c = b[a];
                do
                  c = c(true);
                while (null !== c);
              }
            });
            Wf = null;
          } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
          } finally {
            Yf = false;
          }
        }
      }
      function hg(a, b, c) {
        c /= 10;
        return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
      }
      function ig(a, b) {
        if (a && a.defaultProps) {
          b = n2({}, b);
          a = a.defaultProps;
          for (var c in a)
            void 0 === b[c] && (b[c] = a[c]);
        }
        return b;
      }
      var jg = { current: null };
      var kg = null;
      var lg = null;
      var mg = null;
      function ng() {
        mg = lg = kg = null;
      }
      function og(a) {
        var b = jg.current;
        H(jg);
        a.type._context._currentValue = b;
      }
      function pg(a, b) {
        for (; null !== a; ) {
          var c = a.alternate;
          if (a.childExpirationTime < b)
            a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
          else if (null !== c && c.childExpirationTime < b)
            c.childExpirationTime = b;
          else
            break;
          a = a.return;
        }
      }
      function qg(a, b) {
        kg = a;
        mg = lg = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = true), a.firstContext = null);
      }
      function sg(a, b) {
        if (mg !== a && false !== b && 0 !== b) {
          if ("number" !== typeof b || 1073741823 === b)
            mg = a, b = 1073741823;
          b = { context: a, observedBits: b, next: null };
          if (null === lg) {
            if (null === kg)
              throw Error(u(308));
            lg = b;
            kg.dependencies = { expirationTime: 0, firstContext: b, responders: null };
          } else
            lg = lg.next = b;
        }
        return a._currentValue;
      }
      var tg = false;
      function ug(a) {
        a.updateQueue = { baseState: a.memoizedState, baseQueue: null, shared: { pending: null }, effects: null };
      }
      function vg(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, baseQueue: a.baseQueue, shared: a.shared, effects: a.effects });
      }
      function wg(a, b) {
        a = { expirationTime: a, suspenseConfig: b, tag: 0, payload: null, callback: null, next: null };
        return a.next = a;
      }
      function xg(a, b) {
        a = a.updateQueue;
        if (null !== a) {
          a = a.shared;
          var c = a.pending;
          null === c ? b.next = b : (b.next = c.next, c.next = b);
          a.pending = b;
        }
      }
      function yg(a, b) {
        var c = a.alternate;
        null !== c && vg(c, a);
        a = a.updateQueue;
        c = a.baseQueue;
        null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
      }
      function zg(a, b, c, d) {
        var e2 = a.updateQueue;
        tg = false;
        var f2 = e2.baseQueue, g = e2.shared.pending;
        if (null !== g) {
          if (null !== f2) {
            var h = f2.next;
            f2.next = g.next;
            g.next = h;
          }
          f2 = g;
          e2.shared.pending = null;
          h = a.alternate;
          null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
        }
        if (null !== f2) {
          h = f2.next;
          var k = e2.baseState, l = 0, m = null, p = null, x = null;
          if (null !== h) {
            var z = h;
            do {
              g = z.expirationTime;
              if (g < d) {
                var ca = { expirationTime: z.expirationTime, suspenseConfig: z.suspenseConfig, tag: z.tag, payload: z.payload, callback: z.callback, next: null };
                null === x ? (p = x = ca, m = k) : x = x.next = ca;
                g > l && (l = g);
              } else {
                null !== x && (x = x.next = { expirationTime: 1073741823, suspenseConfig: z.suspenseConfig, tag: z.tag, payload: z.payload, callback: z.callback, next: null });
                Ag(g, z.suspenseConfig);
                a: {
                  var D = a, t2 = z;
                  g = b;
                  ca = c;
                  switch (t2.tag) {
                    case 1:
                      D = t2.payload;
                      if ("function" === typeof D) {
                        k = D.call(ca, k, g);
                        break a;
                      }
                      k = D;
                      break a;
                    case 3:
                      D.effectTag = D.effectTag & -4097 | 64;
                    case 0:
                      D = t2.payload;
                      g = "function" === typeof D ? D.call(ca, k, g) : D;
                      if (null === g || void 0 === g)
                        break a;
                      k = n2({}, k, g);
                      break a;
                    case 2:
                      tg = true;
                  }
                }
                null !== z.callback && (a.effectTag |= 32, g = e2.effects, null === g ? e2.effects = [z] : g.push(z));
              }
              z = z.next;
              if (null === z || z === h)
                if (g = e2.shared.pending, null === g)
                  break;
                else
                  z = f2.next = g.next, g.next = h, e2.baseQueue = f2 = g, e2.shared.pending = null;
            } while (1);
          }
          null === x ? m = k : x.next = p;
          e2.baseState = m;
          e2.baseQueue = x;
          Bg(l);
          a.expirationTime = l;
          a.memoizedState = k;
        }
      }
      function Cg(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a)
          for (b = 0; b < a.length; b++) {
            var d = a[b], e2 = d.callback;
            if (null !== e2) {
              d.callback = null;
              d = e2;
              e2 = c;
              if ("function" !== typeof d)
                throw Error(u(191, d));
              d.call(e2);
            }
          }
      }
      var Dg = Wa.ReactCurrentBatchConfig;
      var Eg = new aa.Component().refs;
      function Fg(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : n2({}, b, c);
        a.memoizedState = c;
        0 === a.expirationTime && (a.updateQueue.baseState = c);
      }
      var Jg = { isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : false;
      }, enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e2 = Dg.suspense;
        d = Hg(d, a, e2);
        e2 = wg(d, e2);
        e2.payload = b;
        void 0 !== c && null !== c && (e2.callback = c);
        xg(a, e2);
        Ig(a, d);
      }, enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e2 = Dg.suspense;
        d = Hg(d, a, e2);
        e2 = wg(d, e2);
        e2.tag = 1;
        e2.payload = b;
        void 0 !== c && null !== c && (e2.callback = c);
        xg(a, e2);
        Ig(a, d);
      }, enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
      } };
      function Kg(a, b, c, d, e2, f2, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f2, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e2, f2) : true;
      }
      function Lg(a, b, c) {
        var d = false, e2 = Af;
        var f2 = b.contextType;
        "object" === typeof f2 && null !== f2 ? f2 = sg(f2) : (e2 = L(b) ? Bf : J.current, d = b.contextTypes, f2 = (d = null !== d && void 0 !== d) ? Cf(a, e2) : Af);
        b = new b(c, f2);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Jg;
        a.stateNode = b;
        b._reactInternalFiber = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e2, a.__reactInternalMemoizedMaskedChildContext = f2);
        return b;
      }
      function Mg(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
      }
      function Ng(a, b, c, d) {
        var e2 = a.stateNode;
        e2.props = c;
        e2.state = a.memoizedState;
        e2.refs = Eg;
        ug(a);
        var f2 = b.contextType;
        "object" === typeof f2 && null !== f2 ? e2.context = sg(f2) : (f2 = L(b) ? Bf : J.current, e2.context = Cf(a, f2));
        zg(a, c, e2, d);
        e2.state = a.memoizedState;
        f2 = b.getDerivedStateFromProps;
        "function" === typeof f2 && (Fg(a, b, f2, c), e2.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e2.getSnapshotBeforeUpdate || "function" !== typeof e2.UNSAFE_componentWillMount && "function" !== typeof e2.componentWillMount || (b = e2.state, "function" === typeof e2.componentWillMount && e2.componentWillMount(), "function" === typeof e2.UNSAFE_componentWillMount && e2.UNSAFE_componentWillMount(), b !== e2.state && Jg.enqueueReplaceState(e2, e2.state, null), zg(a, c, e2, d), e2.state = a.memoizedState);
        "function" === typeof e2.componentDidMount && (a.effectTag |= 4);
      }
      var Og = Array.isArray;
      function Pg(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
          if (c._owner) {
            c = c._owner;
            if (c) {
              if (1 !== c.tag)
                throw Error(u(309));
              var d = c.stateNode;
            }
            if (!d)
              throw Error(u(147, a));
            var e2 = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e2)
              return b.ref;
            b = function(a2) {
              var b2 = d.refs;
              b2 === Eg && (b2 = d.refs = {});
              null === a2 ? delete b2[e2] : b2[e2] = a2;
            };
            b._stringRef = e2;
            return b;
          }
          if ("string" !== typeof a)
            throw Error(u(284));
          if (!c._owner)
            throw Error(u(290, a));
        }
        return a;
      }
      function Qg(a, b) {
        if ("textarea" !== a.type)
          throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
      }
      function Rg(a) {
        function b(b2, c2) {
          if (a) {
            var d2 = b2.lastEffect;
            null !== d2 ? (d2.nextEffect = c2, b2.lastEffect = c2) : b2.firstEffect = b2.lastEffect = c2;
            c2.nextEffect = null;
            c2.effectTag = 8;
          }
        }
        function c(c2, d2) {
          if (!a)
            return null;
          for (; null !== d2; )
            b(c2, d2), d2 = d2.sibling;
          return null;
        }
        function d(a2, b2) {
          for (a2 = /* @__PURE__ */ new Map(); null !== b2; )
            null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
          return a2;
        }
        function e2(a2, b2) {
          a2 = Sg(a2, b2);
          a2.index = 0;
          a2.sibling = null;
          return a2;
        }
        function f2(b2, c2, d2) {
          b2.index = d2;
          if (!a)
            return c2;
          d2 = b2.alternate;
          if (null !== d2)
            return d2 = d2.index, d2 < c2 ? (b2.effectTag = 2, c2) : d2;
          b2.effectTag = 2;
          return c2;
        }
        function g(b2) {
          a && null === b2.alternate && (b2.effectTag = 2);
          return b2;
        }
        function h(a2, b2, c2, d2) {
          if (null === b2 || 6 !== b2.tag)
            return b2 = Tg(c2, a2.mode, d2), b2.return = a2, b2;
          b2 = e2(b2, c2);
          b2.return = a2;
          return b2;
        }
        function k(a2, b2, c2, d2) {
          if (null !== b2 && b2.elementType === c2.type)
            return d2 = e2(b2, c2.props), d2.ref = Pg(a2, b2, c2), d2.return = a2, d2;
          d2 = Ug(c2.type, c2.key, c2.props, null, a2.mode, d2);
          d2.ref = Pg(a2, b2, c2);
          d2.return = a2;
          return d2;
        }
        function l(a2, b2, c2, d2) {
          if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation)
            return b2 = Vg(c2, a2.mode, d2), b2.return = a2, b2;
          b2 = e2(b2, c2.children || []);
          b2.return = a2;
          return b2;
        }
        function m(a2, b2, c2, d2, f3) {
          if (null === b2 || 7 !== b2.tag)
            return b2 = Wg(c2, a2.mode, d2, f3), b2.return = a2, b2;
          b2 = e2(b2, c2);
          b2.return = a2;
          return b2;
        }
        function p(a2, b2, c2) {
          if ("string" === typeof b2 || "number" === typeof b2)
            return b2 = Tg("" + b2, a2.mode, c2), b2.return = a2, b2;
          if ("object" === typeof b2 && null !== b2) {
            switch (b2.$$typeof) {
              case Za:
                return c2 = Ug(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Pg(a2, null, b2), c2.return = a2, c2;
              case $a:
                return b2 = Vg(b2, a2.mode, c2), b2.return = a2, b2;
            }
            if (Og(b2) || nb(b2))
              return b2 = Wg(b2, a2.mode, c2, null), b2.return = a2, b2;
            Qg(a2, b2);
          }
          return null;
        }
        function x(a2, b2, c2, d2) {
          var e3 = null !== b2 ? b2.key : null;
          if ("string" === typeof c2 || "number" === typeof c2)
            return null !== e3 ? null : h(a2, b2, "" + c2, d2);
          if ("object" === typeof c2 && null !== c2) {
            switch (c2.$$typeof) {
              case Za:
                return c2.key === e3 ? c2.type === ab ? m(a2, b2, c2.props.children, d2, e3) : k(a2, b2, c2, d2) : null;
              case $a:
                return c2.key === e3 ? l(a2, b2, c2, d2) : null;
            }
            if (Og(c2) || nb(c2))
              return null !== e3 ? null : m(a2, b2, c2, d2, null);
            Qg(a2, c2);
          }
          return null;
        }
        function z(a2, b2, c2, d2, e3) {
          if ("string" === typeof d2 || "number" === typeof d2)
            return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e3);
          if ("object" === typeof d2 && null !== d2) {
            switch (d2.$$typeof) {
              case Za:
                return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, d2.type === ab ? m(b2, a2, d2.props.children, e3, d2.key) : k(b2, a2, d2, e3);
              case $a:
                return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l(b2, a2, d2, e3);
            }
            if (Og(d2) || nb(d2))
              return a2 = a2.get(c2) || null, m(b2, a2, d2, e3, null);
            Qg(b2, d2);
          }
          return null;
        }
        function ca(e3, g2, h2, k2) {
          for (var l2 = null, t2 = null, m2 = g2, y = g2 = 0, A = null; null !== m2 && y < h2.length; y++) {
            m2.index > y ? (A = m2, m2 = null) : A = m2.sibling;
            var q = x(e3, m2, h2[y], k2);
            if (null === q) {
              null === m2 && (m2 = A);
              break;
            }
            a && m2 && null === q.alternate && b(e3, m2);
            g2 = f2(q, g2, y);
            null === t2 ? l2 = q : t2.sibling = q;
            t2 = q;
            m2 = A;
          }
          if (y === h2.length)
            return c(e3, m2), l2;
          if (null === m2) {
            for (; y < h2.length; y++)
              m2 = p(e3, h2[y], k2), null !== m2 && (g2 = f2(m2, g2, y), null === t2 ? l2 = m2 : t2.sibling = m2, t2 = m2);
            return l2;
          }
          for (m2 = d(e3, m2); y < h2.length; y++)
            A = z(m2, e3, y, h2[y], k2), null !== A && (a && null !== A.alternate && m2.delete(null === A.key ? y : A.key), g2 = f2(A, g2, y), null === t2 ? l2 = A : t2.sibling = A, t2 = A);
          a && m2.forEach(function(a2) {
            return b(e3, a2);
          });
          return l2;
        }
        function D(e3, g2, h2, l2) {
          var k2 = nb(h2);
          if ("function" !== typeof k2)
            throw Error(u(150));
          h2 = k2.call(h2);
          if (null == h2)
            throw Error(u(151));
          for (var m2 = k2 = null, t2 = g2, y = g2 = 0, A = null, q = h2.next(); null !== t2 && !q.done; y++, q = h2.next()) {
            t2.index > y ? (A = t2, t2 = null) : A = t2.sibling;
            var D2 = x(e3, t2, q.value, l2);
            if (null === D2) {
              null === t2 && (t2 = A);
              break;
            }
            a && t2 && null === D2.alternate && b(e3, t2);
            g2 = f2(D2, g2, y);
            null === m2 ? k2 = D2 : m2.sibling = D2;
            m2 = D2;
            t2 = A;
          }
          if (q.done)
            return c(e3, t2), k2;
          if (null === t2) {
            for (; !q.done; y++, q = h2.next())
              q = p(e3, q.value, l2), null !== q && (g2 = f2(q, g2, y), null === m2 ? k2 = q : m2.sibling = q, m2 = q);
            return k2;
          }
          for (t2 = d(e3, t2); !q.done; y++, q = h2.next())
            q = z(t2, e3, y, q.value, l2), null !== q && (a && null !== q.alternate && t2.delete(null === q.key ? y : q.key), g2 = f2(q, g2, y), null === m2 ? k2 = q : m2.sibling = q, m2 = q);
          a && t2.forEach(function(a2) {
            return b(e3, a2);
          });
          return k2;
        }
        return function(a2, d2, f3, h2) {
          var k2 = "object" === typeof f3 && null !== f3 && f3.type === ab && null === f3.key;
          k2 && (f3 = f3.props.children);
          var l2 = "object" === typeof f3 && null !== f3;
          if (l2)
            switch (f3.$$typeof) {
              case Za:
                a: {
                  l2 = f3.key;
                  for (k2 = d2; null !== k2; ) {
                    if (k2.key === l2) {
                      switch (k2.tag) {
                        case 7:
                          if (f3.type === ab) {
                            c(a2, k2.sibling);
                            d2 = e2(k2, f3.props.children);
                            d2.return = a2;
                            a2 = d2;
                            break a;
                          }
                          break;
                        default:
                          if (k2.elementType === f3.type) {
                            c(
                              a2,
                              k2.sibling
                            );
                            d2 = e2(k2, f3.props);
                            d2.ref = Pg(a2, k2, f3);
                            d2.return = a2;
                            a2 = d2;
                            break a;
                          }
                      }
                      c(a2, k2);
                      break;
                    } else
                      b(a2, k2);
                    k2 = k2.sibling;
                  }
                  f3.type === ab ? (d2 = Wg(f3.props.children, a2.mode, h2, f3.key), d2.return = a2, a2 = d2) : (h2 = Ug(f3.type, f3.key, f3.props, null, a2.mode, h2), h2.ref = Pg(a2, d2, f3), h2.return = a2, a2 = h2);
                }
                return g(a2);
              case $a:
                a: {
                  for (k2 = f3.key; null !== d2; ) {
                    if (d2.key === k2)
                      if (4 === d2.tag && d2.stateNode.containerInfo === f3.containerInfo && d2.stateNode.implementation === f3.implementation) {
                        c(a2, d2.sibling);
                        d2 = e2(d2, f3.children || []);
                        d2.return = a2;
                        a2 = d2;
                        break a;
                      } else {
                        c(a2, d2);
                        break;
                      }
                    else
                      b(a2, d2);
                    d2 = d2.sibling;
                  }
                  d2 = Vg(f3, a2.mode, h2);
                  d2.return = a2;
                  a2 = d2;
                }
                return g(a2);
            }
          if ("string" === typeof f3 || "number" === typeof f3)
            return f3 = "" + f3, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e2(d2, f3), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Tg(f3, a2.mode, h2), d2.return = a2, a2 = d2), g(a2);
          if (Og(f3))
            return ca(a2, d2, f3, h2);
          if (nb(f3))
            return D(a2, d2, f3, h2);
          l2 && Qg(a2, f3);
          if ("undefined" === typeof f3 && !k2)
            switch (a2.tag) {
              case 1:
              case 0:
                throw a2 = a2.type, Error(u(152, a2.displayName || a2.name || "Component"));
            }
          return c(a2, d2);
        };
      }
      var Xg = Rg(true);
      var Yg = Rg(false);
      var Zg = {};
      var $g = { current: Zg };
      var ah = { current: Zg };
      var bh = { current: Zg };
      function ch(a) {
        if (a === Zg)
          throw Error(u(174));
        return a;
      }
      function dh(a, b) {
        I(bh, b);
        I(ah, a);
        I($g, Zg);
        a = b.nodeType;
        switch (a) {
          case 9:
          case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
          default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
        }
        H($g);
        I($g, b);
      }
      function eh() {
        H($g);
        H(ah);
        H(bh);
      }
      function fh(a) {
        ch(bh.current);
        var b = ch($g.current);
        var c = Ob(b, a.type);
        b !== c && (I(ah, a), I($g, c));
      }
      function gh(a) {
        ah.current === a && (H($g), H(ah));
      }
      var M = { current: 0 };
      function hh(a) {
        for (var b = a; null !== b; ) {
          if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd))
              return b;
          } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64))
              return b;
          } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
          }
          if (b === a)
            break;
          for (; null === b.sibling; ) {
            if (null === b.return || b.return === a)
              return null;
            b = b.return;
          }
          b.sibling.return = b.return;
          b = b.sibling;
        }
        return null;
      }
      function ih(a, b) {
        return { responder: a, props: b };
      }
      var jh = Wa.ReactCurrentDispatcher;
      var kh = Wa.ReactCurrentBatchConfig;
      var lh = 0;
      var N = null;
      var O = null;
      var P = null;
      var mh = false;
      function Q() {
        throw Error(u(321));
      }
      function nh(a, b) {
        if (null === b)
          return false;
        for (var c = 0; c < b.length && c < a.length; c++)
          if (!$e(a[c], b[c]))
            return false;
        return true;
      }
      function oh(a, b, c, d, e2, f2) {
        lh = f2;
        N = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.expirationTime = 0;
        jh.current = null === a || null === a.memoizedState ? ph : qh;
        a = c(d, e2);
        if (b.expirationTime === lh) {
          f2 = 0;
          do {
            b.expirationTime = 0;
            if (!(25 > f2))
              throw Error(u(301));
            f2 += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e2);
          } while (b.expirationTime === lh);
        }
        jh.current = sh;
        b = null !== O && null !== O.next;
        lh = 0;
        P = O = N = null;
        mh = false;
        if (b)
          throw Error(u(300));
        return a;
      }
      function th() {
        var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
        null === P ? N.memoizedState = P = a : P = P.next = a;
        return P;
      }
      function uh() {
        if (null === O) {
          var a = N.alternate;
          a = null !== a ? a.memoizedState : null;
        } else
          a = O.next;
        var b = null === P ? N.memoizedState : P.next;
        if (null !== b)
          P = b, O = a;
        else {
          if (null === a)
            throw Error(u(310));
          O = a;
          a = { memoizedState: O.memoizedState, baseState: O.baseState, baseQueue: O.baseQueue, queue: O.queue, next: null };
          null === P ? N.memoizedState = P = a : P = P.next = a;
        }
        return P;
      }
      function vh(a, b) {
        return "function" === typeof b ? b(a) : b;
      }
      function wh(a) {
        var b = uh(), c = b.queue;
        if (null === c)
          throw Error(u(311));
        c.lastRenderedReducer = a;
        var d = O, e2 = d.baseQueue, f2 = c.pending;
        if (null !== f2) {
          if (null !== e2) {
            var g = e2.next;
            e2.next = f2.next;
            f2.next = g;
          }
          d.baseQueue = e2 = f2;
          c.pending = null;
        }
        if (null !== e2) {
          e2 = e2.next;
          d = d.baseState;
          var h = g = f2 = null, k = e2;
          do {
            var l = k.expirationTime;
            if (l < lh) {
              var m = { expirationTime: k.expirationTime, suspenseConfig: k.suspenseConfig, action: k.action, eagerReducer: k.eagerReducer, eagerState: k.eagerState, next: null };
              null === h ? (g = h = m, f2 = d) : h = h.next = m;
              l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else
              null !== h && (h = h.next = { expirationTime: 1073741823, suspenseConfig: k.suspenseConfig, action: k.action, eagerReducer: k.eagerReducer, eagerState: k.eagerState, next: null }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
          } while (null !== k && k !== e2);
          null === h ? f2 = d : h.next = g;
          $e(d, b.memoizedState) || (rg = true);
          b.memoizedState = d;
          b.baseState = f2;
          b.baseQueue = h;
          c.lastRenderedState = d;
        }
        return [b.memoizedState, c.dispatch];
      }
      function xh(a) {
        var b = uh(), c = b.queue;
        if (null === c)
          throw Error(u(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e2 = c.pending, f2 = b.memoizedState;
        if (null !== e2) {
          c.pending = null;
          var g = e2 = e2.next;
          do
            f2 = a(f2, g.action), g = g.next;
          while (g !== e2);
          $e(f2, b.memoizedState) || (rg = true);
          b.memoizedState = f2;
          null === b.baseQueue && (b.baseState = f2);
          c.lastRenderedState = f2;
        }
        return [f2, d];
      }
      function yh(a) {
        var b = th();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = { pending: null, dispatch: null, lastRenderedReducer: vh, lastRenderedState: a };
        a = a.dispatch = zh.bind(null, N, a);
        return [b.memoizedState, a];
      }
      function Ah(a, b, c, d) {
        a = { tag: a, create: b, destroy: c, deps: d, next: null };
        b = N.updateQueue;
        null === b ? (b = { lastEffect: null }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
      }
      function Bh() {
        return uh().memoizedState;
      }
      function Ch(a, b, c, d) {
        var e2 = th();
        N.effectTag |= a;
        e2.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
      }
      function Dh(a, b, c, d) {
        var e2 = uh();
        d = void 0 === d ? null : d;
        var f2 = void 0;
        if (null !== O) {
          var g = O.memoizedState;
          f2 = g.destroy;
          if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f2, d);
            return;
          }
        }
        N.effectTag |= a;
        e2.memoizedState = Ah(1 | b, c, f2, d);
      }
      function Eh(a, b) {
        return Ch(516, 4, a, b);
      }
      function Fh(a, b) {
        return Dh(516, 4, a, b);
      }
      function Gh(a, b) {
        return Dh(4, 2, a, b);
      }
      function Hh(a, b) {
        if ("function" === typeof b)
          return a = a(), b(a), function() {
            b(null);
          };
        if (null !== b && void 0 !== b)
          return a = a(), b.current = a, function() {
            b.current = null;
          };
      }
      function Ih(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([a]) : null;
        return Dh(4, 2, Hh.bind(null, b, a), c);
      }
      function Jh() {
      }
      function Kh(a, b) {
        th().memoizedState = [a, void 0 === b ? null : b];
        return a;
      }
      function Lh(a, b) {
        var c = uh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && nh(b, d[1]))
          return d[0];
        c.memoizedState = [a, b];
        return a;
      }
      function Mh(a, b) {
        var c = uh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && nh(b, d[1]))
          return d[0];
        a = a();
        c.memoizedState = [a, b];
        return a;
      }
      function Nh(a, b, c) {
        var d = ag();
        cg(98 > d ? 98 : d, function() {
          a(true);
        });
        cg(97 < d ? 97 : d, function() {
          var d2 = kh.suspense;
          kh.suspense = void 0 === b ? null : b;
          try {
            a(false), c();
          } finally {
            kh.suspense = d2;
          }
        });
      }
      function zh(a, b, c) {
        var d = Gg(), e2 = Dg.suspense;
        d = Hg(d, a, e2);
        e2 = { expirationTime: d, suspenseConfig: e2, action: c, eagerReducer: null, eagerState: null, next: null };
        var f2 = b.pending;
        null === f2 ? e2.next = e2 : (e2.next = f2.next, f2.next = e2);
        b.pending = e2;
        f2 = a.alternate;
        if (a === N || null !== f2 && f2 === N)
          mh = true, e2.expirationTime = lh, N.expirationTime = lh;
        else {
          if (0 === a.expirationTime && (null === f2 || 0 === f2.expirationTime) && (f2 = b.lastRenderedReducer, null !== f2))
            try {
              var g = b.lastRenderedState, h = f2(g, c);
              e2.eagerReducer = f2;
              e2.eagerState = h;
              if ($e(h, g))
                return;
            } catch (k) {
            } finally {
            }
          Ig(
            a,
            d
          );
        }
      }
      var sh = { readContext: sg, useCallback: Q, useContext: Q, useEffect: Q, useImperativeHandle: Q, useLayoutEffect: Q, useMemo: Q, useReducer: Q, useRef: Q, useState: Q, useDebugValue: Q, useResponder: Q, useDeferredValue: Q, useTransition: Q };
      var ph = { readContext: sg, useCallback: Kh, useContext: sg, useEffect: Eh, useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([a]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
      }, useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
      }, useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
          a,
          b
        ];
        return a;
      }, useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = { pending: null, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
        a = a.dispatch = zh.bind(null, N, a);
        return [d.memoizedState, a];
      }, useRef: function(a) {
        var b = th();
        a = { current: a };
        return b.memoizedState = a;
      }, useState: yh, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e2 = c[1];
        Eh(function() {
          var c2 = kh.suspense;
          kh.suspense = void 0 === b ? null : b;
          try {
            e2(a);
          } finally {
            kh.suspense = c2;
          }
        }, [a, b]);
        return d;
      }, useTransition: function(a) {
        var b = yh(false), c = b[0];
        b = b[1];
        return [Kh(Nh.bind(null, b, a), [b, a]), c];
      } };
      var qh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: wh, useRef: Bh, useState: function() {
        return wh(vh);
      }, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e2 = c[1];
        Fh(function() {
          var c2 = kh.suspense;
          kh.suspense = void 0 === b ? null : b;
          try {
            e2(a);
          } finally {
            kh.suspense = c2;
          }
        }, [a, b]);
        return d;
      }, useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [Lh(Nh.bind(null, b, a), [b, a]), c];
      } };
      var rh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: xh, useRef: Bh, useState: function() {
        return xh(vh);
      }, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e2 = c[1];
        Fh(function() {
          var c2 = kh.suspense;
          kh.suspense = void 0 === b ? null : b;
          try {
            e2(a);
          } finally {
            kh.suspense = c2;
          }
        }, [a, b]);
        return d;
      }, useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [Lh(Nh.bind(
          null,
          b,
          a
        ), [b, a]), c];
      } };
      var Oh = null;
      var Ph = null;
      var Qh = false;
      function Rh(a, b) {
        var c = Sh(5, null, null, 0);
        c.elementType = "DELETED";
        c.type = "DELETED";
        c.stateNode = b;
        c.return = a;
        c.effectTag = 8;
        null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
      }
      function Th(a, b) {
        switch (a.tag) {
          case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, true) : false;
          case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, true) : false;
          case 13:
            return false;
          default:
            return false;
        }
      }
      function Uh(a) {
        if (Qh) {
          var b = Ph;
          if (b) {
            var c = b;
            if (!Th(a, b)) {
              b = Jd(c.nextSibling);
              if (!b || !Th(a, b)) {
                a.effectTag = a.effectTag & -1025 | 2;
                Qh = false;
                Oh = a;
                return;
              }
              Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
          } else
            a.effectTag = a.effectTag & -1025 | 2, Qh = false, Oh = a;
        }
      }
      function Vh(a) {
        for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; )
          a = a.return;
        Oh = a;
      }
      function Wh(a) {
        if (a !== Oh)
          return false;
        if (!Qh)
          return Vh(a), Qh = true, false;
        var b = a.type;
        if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps))
          for (b = Ph; b; )
            Rh(a, b), b = Jd(b.nextSibling);
        Vh(a);
        if (13 === a.tag) {
          a = a.memoizedState;
          a = null !== a ? a.dehydrated : null;
          if (!a)
            throw Error(u(317));
          a: {
            a = a.nextSibling;
            for (b = 0; a; ) {
              if (8 === a.nodeType) {
                var c = a.data;
                if (c === Ad) {
                  if (0 === b) {
                    Ph = Jd(a.nextSibling);
                    break a;
                  }
                  b--;
                } else
                  c !== zd && c !== Cd && c !== Bd || b++;
              }
              a = a.nextSibling;
            }
            Ph = null;
          }
        } else
          Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
        return true;
      }
      function Xh() {
        Ph = Oh = null;
        Qh = false;
      }
      var Yh = Wa.ReactCurrentOwner;
      var rg = false;
      function R(a, b, c, d) {
        b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
      }
      function Zh(a, b, c, d, e2) {
        c = c.render;
        var f2 = b.ref;
        qg(b, e2);
        d = oh(a, b, c, d, f2, e2);
        if (null !== a && !rg)
          return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e2 && (a.expirationTime = 0), $h(a, b, e2);
        b.effectTag |= 1;
        R(a, b, d, e2);
        return b.child;
      }
      function ai(a, b, c, d, e2, f2) {
        if (null === a) {
          var g = c.type;
          if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps)
            return b.tag = 15, b.type = g, ci(a, b, g, d, e2, f2);
          a = Ug(c.type, null, d, null, b.mode, f2);
          a.ref = b.ref;
          a.return = b;
          return b.child = a;
        }
        g = a.child;
        if (e2 < f2 && (e2 = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e2, d) && a.ref === b.ref))
          return $h(a, b, f2);
        b.effectTag |= 1;
        a = Sg(g, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
      }
      function ci(a, b, c, d, e2, f2) {
        return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = false, e2 < f2) ? (b.expirationTime = a.expirationTime, $h(a, b, f2)) : di(a, b, c, d, f2);
      }
      function ei(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c)
          b.effectTag |= 128;
      }
      function di(a, b, c, d, e2) {
        var f2 = L(c) ? Bf : J.current;
        f2 = Cf(b, f2);
        qg(b, e2);
        c = oh(a, b, c, d, f2, e2);
        if (null !== a && !rg)
          return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e2 && (a.expirationTime = 0), $h(a, b, e2);
        b.effectTag |= 1;
        R(a, b, c, e2);
        return b.child;
      }
      function fi(a, b, c, d, e2) {
        if (L(c)) {
          var f2 = true;
          Gf(b);
        } else
          f2 = false;
        qg(b, e2);
        if (null === b.stateNode)
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e2), d = true;
        else if (null === a) {
          var g = b.stateNode, h = b.memoizedProps;
          g.props = h;
          var k = g.context, l = c.contextType;
          "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
          var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
          p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
          tg = false;
          var x = b.memoizedState;
          g.state = x;
          zg(b, d, g, e2);
          k = b.memoizedState;
          h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = false);
        } else
          g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = false, k = b.memoizedState, g.state = k, zg(b, d, g, e2), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(
            d,
            x,
            l
          ), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = false);
        return gi(a, b, c, d, f2, e2);
      }
      function gi(a, b, c, d, e2, f2) {
        ei(a, b);
        var g = 0 !== (b.effectTag & 64);
        if (!d && !g)
          return e2 && Hf(b, c, false), $h(a, b, f2);
        d = b.stateNode;
        Yh.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.effectTag |= 1;
        null !== a && g ? (b.child = Xg(b, a.child, null, f2), b.child = Xg(b, null, h, f2)) : R(a, b, h, f2);
        b.memoizedState = d.state;
        e2 && Hf(b, c, true);
        return b.child;
      }
      function hi(a) {
        var b = a.stateNode;
        b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, false);
        dh(a, b.containerInfo);
      }
      var ii = { dehydrated: null, retryTime: 0 };
      function ji(a, b, c) {
        var d = b.mode, e2 = b.pendingProps, f2 = M.current, g = false, h;
        (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f2 & 2) && (null === a || null !== a.memoizedState));
        h ? (g = true, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e2.fallback || true === e2.unstable_avoidThisFallback || (f2 |= 1);
        I(M, f2 & 1);
        if (null === a) {
          void 0 !== e2.fallback && Uh(b);
          if (g) {
            g = e2.fallback;
            e2 = Wg(null, d, 0, null);
            e2.return = b;
            if (0 === (b.mode & 2))
              for (a = null !== b.memoizedState ? b.child.child : b.child, e2.child = a; null !== a; )
                a.return = e2, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e2.sibling = c;
            b.memoizedState = ii;
            b.child = e2;
            return c;
          }
          d = e2.children;
          b.memoizedState = null;
          return b.child = Yg(b, null, d, c);
        }
        if (null !== a.memoizedState) {
          a = a.child;
          d = a.sibling;
          if (g) {
            e2 = e2.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child))
              for (c.child = g; null !== g; )
                g.return = c, g = g.sibling;
            d = Sg(d, e2);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
          }
          c = Xg(b, a.child, e2.children, c);
          b.memoizedState = null;
          return b.child = c;
        }
        a = a.child;
        if (g) {
          g = e2.fallback;
          e2 = Wg(null, d, 0, null);
          e2.return = b;
          e2.child = a;
          null !== a && (a.return = e2);
          if (0 === (b.mode & 2))
            for (a = null !== b.memoizedState ? b.child.child : b.child, e2.child = a; null !== a; )
              a.return = e2, a = a.sibling;
          c = Wg(g, d, c, null);
          c.return = b;
          e2.sibling = c;
          c.effectTag |= 2;
          e2.childExpirationTime = 0;
          b.memoizedState = ii;
          b.child = e2;
          return c;
        }
        b.memoizedState = null;
        return b.child = Xg(b, a, e2.children, c);
      }
      function ki(a, b) {
        a.expirationTime < b && (a.expirationTime = b);
        var c = a.alternate;
        null !== c && c.expirationTime < b && (c.expirationTime = b);
        pg(a.return, b);
      }
      function li(a, b, c, d, e2, f2) {
        var g = a.memoizedState;
        null === g ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailExpiration: 0, tailMode: e2, lastEffect: f2 } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e2, g.lastEffect = f2);
      }
      function mi(a, b, c) {
        var d = b.pendingProps, e2 = d.revealOrder, f2 = d.tail;
        R(a, b, d.children, c);
        d = M.current;
        if (0 !== (d & 2))
          d = d & 1 | 2, b.effectTag |= 64;
        else {
          if (null !== a && 0 !== (a.effectTag & 64))
            a:
              for (a = b.child; null !== a; ) {
                if (13 === a.tag)
                  null !== a.memoizedState && ki(a, c);
                else if (19 === a.tag)
                  ki(a, c);
                else if (null !== a.child) {
                  a.child.return = a;
                  a = a.child;
                  continue;
                }
                if (a === b)
                  break a;
                for (; null === a.sibling; ) {
                  if (null === a.return || a.return === b)
                    break a;
                  a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
              }
          d &= 1;
        }
        I(M, d);
        if (0 === (b.mode & 2))
          b.memoizedState = null;
        else
          switch (e2) {
            case "forwards":
              c = b.child;
              for (e2 = null; null !== c; )
                a = c.alternate, null !== a && null === hh(a) && (e2 = c), c = c.sibling;
              c = e2;
              null === c ? (e2 = b.child, b.child = null) : (e2 = c.sibling, c.sibling = null);
              li(b, false, e2, c, f2, b.lastEffect);
              break;
            case "backwards":
              c = null;
              e2 = b.child;
              for (b.child = null; null !== e2; ) {
                a = e2.alternate;
                if (null !== a && null === hh(a)) {
                  b.child = e2;
                  break;
                }
                a = e2.sibling;
                e2.sibling = c;
                c = e2;
                e2 = a;
              }
              li(b, true, c, null, f2, b.lastEffect);
              break;
            case "together":
              li(b, false, null, null, void 0, b.lastEffect);
              break;
            default:
              b.memoizedState = null;
          }
        return b.child;
      }
      function $h(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        var d = b.expirationTime;
        0 !== d && Bg(d);
        if (b.childExpirationTime < c)
          return null;
        if (null !== a && b.child !== a.child)
          throw Error(u(153));
        if (null !== b.child) {
          a = b.child;
          c = Sg(a, a.pendingProps);
          b.child = c;
          for (c.return = b; null !== a.sibling; )
            a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
          c.sibling = null;
        }
        return b.child;
      }
      var ni;
      var oi;
      var pi;
      var qi;
      ni = function(a, b) {
        for (var c = b.child; null !== c; ) {
          if (5 === c.tag || 6 === c.tag)
            a.appendChild(c.stateNode);
          else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
          }
          if (c === b)
            break;
          for (; null === c.sibling; ) {
            if (null === c.return || c.return === b)
              return;
            c = c.return;
          }
          c.sibling.return = c.return;
          c = c.sibling;
        }
      };
      oi = function() {
      };
      pi = function(a, b, c, d, e2) {
        var f2 = a.memoizedProps;
        if (f2 !== d) {
          var g = b.stateNode;
          ch($g.current);
          a = null;
          switch (c) {
            case "input":
              f2 = zb(g, f2);
              d = zb(g, d);
              a = [];
              break;
            case "option":
              f2 = Gb(g, f2);
              d = Gb(g, d);
              a = [];
              break;
            case "select":
              f2 = n2({}, f2, { value: void 0 });
              d = n2({}, d, { value: void 0 });
              a = [];
              break;
            case "textarea":
              f2 = Ib(g, f2);
              d = Ib(g, d);
              a = [];
              break;
            default:
              "function" !== typeof f2.onClick && "function" === typeof d.onClick && (g.onclick = sd);
          }
          od(c, d);
          var h, k;
          c = null;
          for (h in f2)
            if (!d.hasOwnProperty(h) && f2.hasOwnProperty(h) && null != f2[h])
              if ("style" === h)
                for (k in g = f2[h], g)
                  g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
              else
                "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
          for (h in d) {
            var l = d[h];
            g = null != f2 ? f2[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g))
              if ("style" === h)
                if (g) {
                  for (k in g)
                    !g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                  for (k in l)
                    l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                } else
                  c || (a || (a = []), a.push(h, c)), c = l;
              else
                "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e2, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
          }
          c && (a = a || []).push("style", c);
          e2 = a;
          if (b.updateQueue = e2)
            b.effectTag |= 4;
        }
      };
      qi = function(a, b, c, d) {
        c !== d && (b.effectTag |= 4);
      };
      function ri(a, b) {
        switch (a.tailMode) {
          case "hidden":
            b = a.tail;
            for (var c = null; null !== b; )
              null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
          case "collapsed":
            c = a.tail;
            for (var d = null; null !== c; )
              null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
      }
      function si(a, b, c) {
        var d = b.pendingProps;
        switch (b.tag) {
          case 2:
          case 16:
          case 15:
          case 0:
          case 11:
          case 7:
          case 8:
          case 12:
          case 9:
          case 14:
            return null;
          case 1:
            return L(b.type) && Df(), null;
          case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
          case 5:
            gh(b);
            c = ch(bh.current);
            var e2 = b.type;
            if (null !== a && null != b.stateNode)
              pi(a, b, e2, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
              if (!d) {
                if (null === b.stateNode)
                  throw Error(u(166));
                return null;
              }
              a = ch($g.current);
              if (Wh(b)) {
                d = b.stateNode;
                e2 = b.type;
                var f2 = b.memoizedProps;
                d[Md] = b;
                d[Nd] = f2;
                switch (e2) {
                  case "iframe":
                  case "object":
                  case "embed":
                    F("load", d);
                    break;
                  case "video":
                  case "audio":
                    for (a = 0; a < ac.length; a++)
                      F(ac[a], d);
                    break;
                  case "source":
                    F("error", d);
                    break;
                  case "img":
                  case "image":
                  case "link":
                    F("error", d);
                    F("load", d);
                    break;
                  case "form":
                    F("reset", d);
                    F("submit", d);
                    break;
                  case "details":
                    F("toggle", d);
                    break;
                  case "input":
                    Ab(d, f2);
                    F("invalid", d);
                    rd(c, "onChange");
                    break;
                  case "select":
                    d._wrapperState = { wasMultiple: !!f2.multiple };
                    F("invalid", d);
                    rd(c, "onChange");
                    break;
                  case "textarea":
                    Jb(d, f2), F("invalid", d), rd(c, "onChange");
                }
                od(e2, f2);
                a = null;
                for (var g in f2)
                  if (f2.hasOwnProperty(g)) {
                    var h = f2[g];
                    "children" === g ? "string" === typeof h ? d.textContent !== h && (a = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (a = ["children", "" + h]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                  }
                switch (e2) {
                  case "input":
                    xb(d);
                    Eb(d, f2, true);
                    break;
                  case "textarea":
                    xb(d);
                    Lb(d);
                    break;
                  case "select":
                  case "option":
                    break;
                  default:
                    "function" === typeof f2.onClick && (d.onclick = sd);
                }
                c = a;
                b.updateQueue = c;
                null !== c && (b.effectTag |= 4);
              } else {
                g = 9 === c.nodeType ? c : c.ownerDocument;
                a === qd && (a = Nb(e2));
                a === qd ? "script" === e2 ? (a = g.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e2, { is: d.is }) : (a = g.createElement(e2), "select" === e2 && (g = a, d.multiple ? g.multiple = true : d.size && (g.size = d.size))) : a = g.createElementNS(a, e2);
                a[Md] = b;
                a[Nd] = d;
                ni(a, b, false, false);
                b.stateNode = a;
                g = pd(e2, d);
                switch (e2) {
                  case "iframe":
                  case "object":
                  case "embed":
                    F(
                      "load",
                      a
                    );
                    h = d;
                    break;
                  case "video":
                  case "audio":
                    for (h = 0; h < ac.length; h++)
                      F(ac[h], a);
                    h = d;
                    break;
                  case "source":
                    F("error", a);
                    h = d;
                    break;
                  case "img":
                  case "image":
                  case "link":
                    F("error", a);
                    F("load", a);
                    h = d;
                    break;
                  case "form":
                    F("reset", a);
                    F("submit", a);
                    h = d;
                    break;
                  case "details":
                    F("toggle", a);
                    h = d;
                    break;
                  case "input":
                    Ab(a, d);
                    h = zb(a, d);
                    F("invalid", a);
                    rd(c, "onChange");
                    break;
                  case "option":
                    h = Gb(a, d);
                    break;
                  case "select":
                    a._wrapperState = { wasMultiple: !!d.multiple };
                    h = n2({}, d, { value: void 0 });
                    F("invalid", a);
                    rd(c, "onChange");
                    break;
                  case "textarea":
                    Jb(
                      a,
                      d
                    );
                    h = Ib(a, d);
                    F("invalid", a);
                    rd(c, "onChange");
                    break;
                  default:
                    h = d;
                }
                od(e2, h);
                var k = h;
                for (f2 in k)
                  if (k.hasOwnProperty(f2)) {
                    var l = k[f2];
                    "style" === f2 ? md(a, l) : "dangerouslySetInnerHTML" === f2 ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f2 ? "string" === typeof l ? ("textarea" !== e2 || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (va.hasOwnProperty(f2) ? null != l && rd(c, f2) : null != l && Xa(a, f2, l, g));
                  }
                switch (e2) {
                  case "input":
                    xb(a);
                    Eb(a, d, false);
                    break;
                  case "textarea":
                    xb(a);
                    Lb(a);
                    break;
                  case "option":
                    null != d.value && a.setAttribute("value", "" + rb(d.value));
                    break;
                  case "select":
                    a.multiple = !!d.multiple;
                    c = d.value;
                    null != c ? Hb(a, !!d.multiple, c, false) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, true);
                    break;
                  default:
                    "function" === typeof h.onClick && (a.onclick = sd);
                }
                Fd(e2, d) && (b.effectTag |= 4);
              }
              null !== b.ref && (b.effectTag |= 128);
            }
            return null;
          case 6:
            if (a && null != b.stateNode)
              qi(a, b, a.memoizedProps, d);
            else {
              if ("string" !== typeof d && null === b.stateNode)
                throw Error(u(166));
              c = ch(bh.current);
              ch($g.current);
              Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
          case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64))
              return b.expirationTime = c, b;
            c = null !== d;
            d = false;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e2 = a.memoizedState, d = null !== e2, c || null === e2 || (e2 = a.child.sibling, null !== e2 && (f2 = b.firstEffect, null !== f2 ? (b.firstEffect = e2, e2.nextEffect = f2) : (b.firstEffect = b.lastEffect = e2, e2.nextEffect = null), e2.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2))
              if (null === a && true !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1))
                S === ti && (S = ui);
              else {
                if (S === ti || S === ui)
                  S = vi;
                0 !== wi && null !== T && (xi(T, U), yi(T, wi));
              }
            if (c || d)
              b.effectTag |= 4;
            return null;
          case 4:
            return eh(), oi(b), null;
          case 10:
            return og(b), null;
          case 17:
            return L(b.type) && Df(), null;
          case 19:
            H(M);
            d = b.memoizedState;
            if (null === d)
              return null;
            e2 = 0 !== (b.effectTag & 64);
            f2 = d.rendering;
            if (null === f2)
              if (e2)
                ri(d, false);
              else {
                if (S !== ti || null !== a && 0 !== (a.effectTag & 64))
                  for (f2 = b.child; null !== f2; ) {
                    a = hh(f2);
                    if (null !== a) {
                      b.effectTag |= 64;
                      ri(d, false);
                      e2 = a.updateQueue;
                      null !== e2 && (b.updateQueue = e2, b.effectTag |= 4);
                      null === d.lastEffect && (b.firstEffect = null);
                      b.lastEffect = d.lastEffect;
                      for (d = b.child; null !== d; )
                        e2 = d, f2 = c, e2.effectTag &= 2, e2.nextEffect = null, e2.firstEffect = null, e2.lastEffect = null, a = e2.alternate, null === a ? (e2.childExpirationTime = 0, e2.expirationTime = f2, e2.child = null, e2.memoizedProps = null, e2.memoizedState = null, e2.updateQueue = null, e2.dependencies = null) : (e2.childExpirationTime = a.childExpirationTime, e2.expirationTime = a.expirationTime, e2.child = a.child, e2.memoizedProps = a.memoizedProps, e2.memoizedState = a.memoizedState, e2.updateQueue = a.updateQueue, f2 = a.dependencies, e2.dependencies = null === f2 ? null : { expirationTime: f2.expirationTime, firstContext: f2.firstContext, responders: f2.responders }), d = d.sibling;
                      I(M, M.current & 1 | 2);
                      return b.child;
                    }
                    f2 = f2.sibling;
                  }
              }
            else {
              if (!e2)
                if (a = hh(f2), null !== a) {
                  if (b.effectTag |= 64, e2 = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, true), null === d.tail && "hidden" === d.tailMode && !f2.alternate)
                    return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                } else
                  2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e2 = true, ri(d, false), b.expirationTime = b.childExpirationTime = c - 1);
              d.isBackwards ? (f2.sibling = b.child, b.child = f2) : (c = d.last, null !== c ? c.sibling = f2 : b.child = f2, d.last = f2);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e2 ? b & 1 | 2 : b & 1), c) : null;
        }
        throw Error(u(
          156,
          b.tag
        ));
      }
      function zi(a) {
        switch (a.tag) {
          case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
          case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64))
              throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
          case 5:
            return gh(a), null;
          case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
          case 19:
            return H(M), null;
          case 4:
            return eh(), null;
          case 10:
            return og(a), null;
          default:
            return null;
        }
      }
      function Ai(a, b) {
        return { value: a, source: b, stack: qb(b) };
      }
      var Bi = "function" === typeof WeakSet ? WeakSet : Set;
      function Ci(a, b) {
        var c = b.source, d = b.stack;
        null === d && null !== c && (d = qb(c));
        null !== c && pb(c.type);
        b = b.value;
        null !== a && 1 === a.tag && pb(a.type);
        try {
          console.error(b);
        } catch (e2) {
          setTimeout(function() {
            throw e2;
          });
        }
      }
      function Di(a, b) {
        try {
          b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
        } catch (c) {
          Ei(a, c);
        }
      }
      function Fi(a) {
        var b = a.ref;
        if (null !== b)
          if ("function" === typeof b)
            try {
              b(null);
            } catch (c) {
              Ei(a, c);
            }
          else
            b.current = null;
      }
      function Gi(a, b) {
        switch (b.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            return;
          case 1:
            if (b.effectTag & 256 && null !== a) {
              var c = a.memoizedProps, d = a.memoizedState;
              a = b.stateNode;
              b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
              a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
          case 3:
          case 5:
          case 6:
          case 4:
          case 17:
            return;
        }
        throw Error(u(163));
      }
      function Hi(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
          var c = b = b.next;
          do {
            if ((c.tag & a) === a) {
              var d = c.destroy;
              c.destroy = void 0;
              void 0 !== d && d();
            }
            c = c.next;
          } while (c !== b);
        }
      }
      function Ii(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
          var c = b = b.next;
          do {
            if ((c.tag & a) === a) {
              var d = c.create;
              c.destroy = d();
            }
            c = c.next;
          } while (c !== b);
        }
      }
      function Ji(a, b, c) {
        switch (c.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            Ii(3, c);
            return;
          case 1:
            a = c.stateNode;
            if (c.effectTag & 4)
              if (null === b)
                a.componentDidMount();
              else {
                var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
              }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
          case 3:
            b = c.updateQueue;
            if (null !== b) {
              a = null;
              if (null !== c.child)
                switch (c.child.tag) {
                  case 5:
                    a = c.child.stateNode;
                    break;
                  case 1:
                    a = c.child.stateNode;
                }
              Cg(c, b, a);
            }
            return;
          case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
          case 6:
            return;
          case 4:
            return;
          case 12:
            return;
          case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
          case 19:
          case 17:
          case 20:
          case 21:
            return;
        }
        throw Error(u(163));
      }
      function Ki(a, b, c) {
        "function" === typeof Li && Li(b);
        switch (b.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
          case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
              var d = a.next;
              cg(97 < c ? 97 : c, function() {
                var a2 = d;
                do {
                  var c2 = a2.destroy;
                  if (void 0 !== c2) {
                    var g = b;
                    try {
                      c2();
                    } catch (h) {
                      Ei(g, h);
                    }
                  }
                  a2 = a2.next;
                } while (a2 !== d);
              });
            }
            break;
          case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
          case 5:
            Fi(b);
            break;
          case 4:
            Mi(a, b, c);
        }
      }
      function Ni(a) {
        var b = a.alternate;
        a.return = null;
        a.child = null;
        a.memoizedState = null;
        a.updateQueue = null;
        a.dependencies = null;
        a.alternate = null;
        a.firstEffect = null;
        a.lastEffect = null;
        a.pendingProps = null;
        a.memoizedProps = null;
        a.stateNode = null;
        null !== b && Ni(b);
      }
      function Oi(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
      }
      function Pi(a) {
        a: {
          for (var b = a.return; null !== b; ) {
            if (Oi(b)) {
              var c = b;
              break a;
            }
            b = b.return;
          }
          throw Error(u(160));
        }
        b = c.stateNode;
        switch (c.tag) {
          case 5:
            var d = false;
            break;
          case 3:
            b = b.containerInfo;
            d = true;
            break;
          case 4:
            b = b.containerInfo;
            d = true;
            break;
          default:
            throw Error(u(161));
        }
        c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
        a:
          b:
            for (c = a; ; ) {
              for (; null === c.sibling; ) {
                if (null === c.return || Oi(c.return)) {
                  c = null;
                  break a;
                }
                c = c.return;
              }
              c.sibling.return = c.return;
              for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag; ) {
                if (c.effectTag & 2)
                  continue b;
                if (null === c.child || 4 === c.tag)
                  continue b;
                else
                  c.child.return = c, c = c.child;
              }
              if (!(c.effectTag & 2)) {
                c = c.stateNode;
                break a;
              }
            }
        d ? Qi(a, c, b) : Ri(a, c, b);
      }
      function Qi(a, b, c) {
        var d = a.tag, e2 = 5 === d || 6 === d;
        if (e2)
          a = e2 ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
        else if (4 !== d && (a = a.child, null !== a))
          for (Qi(a, b, c), a = a.sibling; null !== a; )
            Qi(a, b, c), a = a.sibling;
      }
      function Ri(a, b, c) {
        var d = a.tag, e2 = 5 === d || 6 === d;
        if (e2)
          a = e2 ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
        else if (4 !== d && (a = a.child, null !== a))
          for (Ri(a, b, c), a = a.sibling; null !== a; )
            Ri(a, b, c), a = a.sibling;
      }
      function Mi(a, b, c) {
        for (var d = b, e2 = false, f2, g; ; ) {
          if (!e2) {
            e2 = d.return;
            a:
              for (; ; ) {
                if (null === e2)
                  throw Error(u(160));
                f2 = e2.stateNode;
                switch (e2.tag) {
                  case 5:
                    g = false;
                    break a;
                  case 3:
                    f2 = f2.containerInfo;
                    g = true;
                    break a;
                  case 4:
                    f2 = f2.containerInfo;
                    g = true;
                    break a;
                }
                e2 = e2.return;
              }
            e2 = true;
          }
          if (5 === d.tag || 6 === d.tag) {
            a:
              for (var h = a, k = d, l = c, m = k; ; )
                if (Ki(h, m, l), null !== m.child && 4 !== m.tag)
                  m.child.return = m, m = m.child;
                else {
                  if (m === k)
                    break a;
                  for (; null === m.sibling; ) {
                    if (null === m.return || m.return === k)
                      break a;
                    m = m.return;
                  }
                  m.sibling.return = m.return;
                  m = m.sibling;
                }
            g ? (h = f2, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f2.removeChild(d.stateNode);
          } else if (4 === d.tag) {
            if (null !== d.child) {
              f2 = d.stateNode.containerInfo;
              g = true;
              d.child.return = d;
              d = d.child;
              continue;
            }
          } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
          }
          if (d === b)
            break;
          for (; null === d.sibling; ) {
            if (null === d.return || d.return === b)
              return;
            d = d.return;
            4 === d.tag && (e2 = false);
          }
          d.sibling.return = d.return;
          d = d.sibling;
        }
      }
      function Si(a, b) {
        switch (b.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
          case 22:
            Hi(3, b);
            return;
          case 1:
            return;
          case 5:
            var c = b.stateNode;
            if (null != c) {
              var d = b.memoizedProps, e2 = null !== a ? a.memoizedProps : d;
              a = b.type;
              var f2 = b.updateQueue;
              b.updateQueue = null;
              if (null !== f2) {
                c[Nd] = d;
                "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                pd(a, e2);
                b = pd(a, d);
                for (e2 = 0; e2 < f2.length; e2 += 2) {
                  var g = f2[e2], h = f2[e2 + 1];
                  "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                }
                switch (a) {
                  case "input":
                    Cb(c, d);
                    break;
                  case "textarea":
                    Kb(c, d);
                    break;
                  case "select":
                    b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, false) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, true) : Hb(c, !!d.multiple, d.multiple ? [] : "", false));
                }
              }
            }
            return;
          case 6:
            if (null === b.stateNode)
              throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
          case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = false, Vc(b.containerInfo));
            return;
          case 12:
            return;
          case 13:
            c = b;
            null === b.memoizedState ? d = false : (d = true, c = b.child, Ti = $f());
            if (null !== c)
              a:
                for (a = c; ; ) {
                  if (5 === a.tag)
                    f2 = a.stateNode, d ? (f2 = f2.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (f2 = a.stateNode, e2 = a.memoizedProps.style, e2 = void 0 !== e2 && null !== e2 && e2.hasOwnProperty("display") ? e2.display : null, f2.style.display = ld("display", e2));
                  else if (6 === a.tag)
                    a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                  else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f2 = a.child.sibling;
                    f2.return = a;
                    a = f2;
                    continue;
                  } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                  }
                  if (a === c)
                    break;
                  for (; null === a.sibling; ) {
                    if (null === a.return || a.return === c)
                      break a;
                    a = a.return;
                  }
                  a.sibling.return = a.return;
                  a = a.sibling;
                }
            Ui(b);
            return;
          case 19:
            Ui(b);
            return;
          case 17:
            return;
        }
        throw Error(u(163));
      }
      function Ui(a) {
        var b = a.updateQueue;
        if (null !== b) {
          a.updateQueue = null;
          var c = a.stateNode;
          null === c && (c = a.stateNode = new Bi());
          b.forEach(function(b2) {
            var d = Vi.bind(null, a, b2);
            c.has(b2) || (c.add(b2), b2.then(d, d));
          });
        }
      }
      var Wi = "function" === typeof WeakMap ? WeakMap : Map;
      function Xi(a, b, c) {
        c = wg(c, null);
        c.tag = 3;
        c.payload = { element: null };
        var d = b.value;
        c.callback = function() {
          Yi || (Yi = true, Zi = d);
          Ci(a, b);
        };
        return c;
      }
      function $i(a, b, c) {
        c = wg(c, null);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
          var e2 = b.value;
          c.payload = function() {
            Ci(a, b);
            return d(e2);
          };
        }
        var f2 = a.stateNode;
        null !== f2 && "function" === typeof f2.componentDidCatch && (c.callback = function() {
          "function" !== typeof d && (null === aj ? aj = /* @__PURE__ */ new Set([this]) : aj.add(this), Ci(a, b));
          var c2 = b.stack;
          this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
        });
        return c;
      }
      var bj = Math.ceil;
      var cj = Wa.ReactCurrentDispatcher;
      var dj = Wa.ReactCurrentOwner;
      var V = 0;
      var ej = 8;
      var fj = 16;
      var gj = 32;
      var ti = 0;
      var hj = 1;
      var ij = 2;
      var ui = 3;
      var vi = 4;
      var jj = 5;
      var W = V;
      var T = null;
      var X = null;
      var U = 0;
      var S = ti;
      var kj = null;
      var lj = 1073741823;
      var mj = 1073741823;
      var nj = null;
      var wi = 0;
      var oj = false;
      var Ti = 0;
      var pj = 500;
      var Y = null;
      var Yi = false;
      var Zi = null;
      var aj = null;
      var qj = false;
      var rj = null;
      var sj = 90;
      var tj = null;
      var uj = 0;
      var vj = null;
      var wj = 0;
      function Gg() {
        return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
      }
      function Hg(a, b, c) {
        b = b.mode;
        if (0 === (b & 2))
          return 1073741823;
        var d = ag();
        if (0 === (b & 4))
          return 99 === d ? 1073741823 : 1073741822;
        if ((W & fj) !== V)
          return U;
        if (null !== c)
          a = hg(a, c.timeoutMs | 0 || 5e3, 250);
        else
          switch (d) {
            case 99:
              a = 1073741823;
              break;
            case 98:
              a = hg(a, 150, 100);
              break;
            case 97:
            case 96:
              a = hg(a, 5e3, 250);
              break;
            case 95:
              a = 2;
              break;
            default:
              throw Error(u(326));
          }
        null !== T && a === U && --a;
        return a;
      }
      function Ig(a, b) {
        if (50 < uj)
          throw uj = 0, vj = null, Error(u(185));
        a = xj(a, b);
        if (null !== a) {
          var c = ag();
          1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
          (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = /* @__PURE__ */ new Map([[a, b]]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
        }
      }
      function xj(a, b) {
        a.expirationTime < b && (a.expirationTime = b);
        var c = a.alternate;
        null !== c && c.expirationTime < b && (c.expirationTime = b);
        var d = a.return, e2 = null;
        if (null === d && 3 === a.tag)
          e2 = a.stateNode;
        else
          for (; null !== d; ) {
            c = d.alternate;
            d.childExpirationTime < b && (d.childExpirationTime = b);
            null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
            if (null === d.return && 3 === d.tag) {
              e2 = d.stateNode;
              break;
            }
            d = d.return;
          }
        null !== e2 && (T === e2 && (Bg(b), S === vi && xi(e2, U)), yi(e2, b));
        return e2;
      }
      function zj(a) {
        var b = a.lastExpiredTime;
        if (0 !== b)
          return b;
        b = a.firstPendingTime;
        if (!Aj(a, b))
          return b;
        var c = a.lastPingedTime;
        a = a.nextKnownPendingLevel;
        a = c > a ? c : a;
        return 2 >= a && b !== a ? 0 : a;
      }
      function Z(a) {
        if (0 !== a.lastExpiredTime)
          a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
        else {
          var b = zj(a), c = a.callbackNode;
          if (0 === b)
            null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
          else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
              var e2 = a.callbackPriority;
              if (a.callbackExpirationTime === b && e2 >= d)
                return;
              c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), { timeout: 10 * (1073741821 - b) - $f() });
            a.callbackNode = b;
          }
        }
      }
      function Bj(a, b) {
        wj = 0;
        if (b)
          return b = Gg(), Cj(a, b), Z(a), null;
        var c = zj(a);
        if (0 !== c) {
          b = a.callbackNode;
          if ((W & (fj | gj)) !== V)
            throw Error(u(327));
          Dj();
          a === T && c === U || Ej(a, c);
          if (null !== X) {
            var d = W;
            W |= fj;
            var e2 = Fj();
            do
              try {
                Gj();
                break;
              } catch (h) {
                Hj(a, h);
              }
            while (1);
            ng();
            W = d;
            cj.current = e2;
            if (S === hj)
              throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X)
              switch (e2 = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d) {
                case ti:
                case hj:
                  throw Error(u(345));
                case ij:
                  Cj(a, 2 < c ? 2 : c);
                  break;
                case ui:
                  xi(a, c);
                  d = a.lastSuspendedTime;
                  c === d && (a.nextKnownPendingLevel = Ij(e2));
                  if (1073741823 === lj && (e2 = Ti + pj - $f(), 10 < e2)) {
                    if (oj) {
                      var f2 = a.lastPingedTime;
                      if (0 === f2 || f2 >= c) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                      }
                    }
                    f2 = zj(a);
                    if (0 !== f2 && f2 !== c)
                      break;
                    if (0 !== d && d !== c) {
                      a.lastPingedTime = d;
                      break;
                    }
                    a.timeoutHandle = Hd(Jj.bind(null, a), e2);
                    break;
                  }
                  Jj(a);
                  break;
                case vi:
                  xi(a, c);
                  d = a.lastSuspendedTime;
                  c === d && (a.nextKnownPendingLevel = Ij(e2));
                  if (oj && (e2 = a.lastPingedTime, 0 === e2 || e2 >= c)) {
                    a.lastPingedTime = c;
                    Ej(a, c);
                    break;
                  }
                  e2 = zj(a);
                  if (0 !== e2 && e2 !== c)
                    break;
                  if (0 !== d && d !== c) {
                    a.lastPingedTime = d;
                    break;
                  }
                  1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5e3, e2 = $f(), c = 10 * (1073741821 - c) - e2, d = e2 - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                  if (10 < d) {
                    a.timeoutHandle = Hd(Jj.bind(null, a), d);
                    break;
                  }
                  Jj(a);
                  break;
                case jj:
                  if (1073741823 !== lj && null !== nj) {
                    f2 = lj;
                    var g = nj;
                    d = g.busyMinDurationMs | 0;
                    0 >= d ? d = 0 : (e2 = g.busyDelayMs | 0, f2 = $f() - (10 * (1073741821 - f2) - (g.timeoutMs | 0 || 5e3)), d = f2 <= e2 ? 0 : e2 + d - f2);
                    if (10 < d) {
                      xi(a, c);
                      a.timeoutHandle = Hd(Jj.bind(null, a), d);
                      break;
                    }
                  }
                  Jj(a);
                  break;
                default:
                  throw Error(u(329));
              }
            Z(a);
            if (a.callbackNode === b)
              return Bj.bind(null, a);
          }
        }
        return null;
      }
      function yj(a) {
        var b = a.lastExpiredTime;
        b = 0 !== b ? b : 1073741823;
        if ((W & (fj | gj)) !== V)
          throw Error(u(327));
        Dj();
        a === T && b === U || Ej(a, b);
        if (null !== X) {
          var c = W;
          W |= fj;
          var d = Fj();
          do
            try {
              Kj();
              break;
            } catch (e2) {
              Hj(a, e2);
            }
          while (1);
          ng();
          W = c;
          cj.current = d;
          if (S === hj)
            throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
          if (null !== X)
            throw Error(u(261));
          a.finishedWork = a.current.alternate;
          a.finishedExpirationTime = b;
          T = null;
          Jj(a);
          Z(a);
        }
        return null;
      }
      function Lj() {
        if (null !== tj) {
          var a = tj;
          tj = null;
          a.forEach(function(a2, c) {
            Cj(c, a2);
            Z(c);
          });
          gg();
        }
      }
      function Mj(a, b) {
        var c = W;
        W |= 1;
        try {
          return a(b);
        } finally {
          W = c, W === V && gg();
        }
      }
      function Nj(a, b) {
        var c = W;
        W &= -2;
        W |= ej;
        try {
          return a(b);
        } finally {
          W = c, W === V && gg();
        }
      }
      function Ej(a, b) {
        a.finishedWork = null;
        a.finishedExpirationTime = 0;
        var c = a.timeoutHandle;
        -1 !== c && (a.timeoutHandle = -1, Id(c));
        if (null !== X)
          for (c = X.return; null !== c; ) {
            var d = c;
            switch (d.tag) {
              case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
              case 3:
                eh();
                H(K);
                H(J);
                break;
              case 5:
                gh(d);
                break;
              case 4:
                eh();
                break;
              case 13:
                H(M);
                break;
              case 19:
                H(M);
                break;
              case 10:
                og(d);
            }
            c = c.return;
          }
        T = a;
        X = Sg(a.current, null);
        U = b;
        S = ti;
        kj = null;
        mj = lj = 1073741823;
        nj = null;
        wi = 0;
        oj = false;
      }
      function Hj(a, b) {
        do {
          try {
            ng();
            jh.current = sh;
            if (mh)
              for (var c = N.memoizedState; null !== c; ) {
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
              }
            lh = 0;
            P = O = N = null;
            mh = false;
            if (null === X || null === X.return)
              return S = hj, kj = b, X = null;
            a: {
              var e2 = a, f2 = X.return, g = X, h = b;
              b = U;
              g.effectTag |= 2048;
              g.firstEffect = g.lastEffect = null;
              if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                var k = h;
                if (0 === (g.mode & 2)) {
                  var l = g.alternate;
                  l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                }
                var m = 0 !== (M.current & 1), p = f2;
                do {
                  var x;
                  if (x = 13 === p.tag) {
                    var z = p.memoizedState;
                    if (null !== z)
                      x = null !== z.dehydrated ? true : false;
                    else {
                      var ca = p.memoizedProps;
                      x = void 0 === ca.fallback ? false : true !== ca.unstable_avoidThisFallback ? true : m ? false : true;
                    }
                  }
                  if (x) {
                    var D = p.updateQueue;
                    if (null === D) {
                      var t2 =  new Set();
                      t2.add(k);
                      p.updateQueue = t2;
                    } else
                      D.add(k);
                    if (0 === (p.mode & 2)) {
                      p.effectTag |= 64;
                      g.effectTag &= -2981;
                      if (1 === g.tag)
                        if (null === g.alternate)
                          g.tag = 17;
                        else {
                          var y = wg(1073741823, null);
                          y.tag = 2;
                          xg(g, y);
                        }
                      g.expirationTime = 1073741823;
                      break a;
                    }
                    h = void 0;
                    g = b;
                    var A = e2.pingCache;
                    null === A ? (A = e2.pingCache = new Wi(), h =  new Set(), A.set(k, h)) : (h = A.get(k), void 0 === h && (h =  new Set(), A.set(k, h)));
                    if (!h.has(g)) {
                      h.add(g);
                      var q = Oj.bind(null, e2, k, g);
                      k.then(q, q);
                    }
                    p.effectTag |= 4096;
                    p.expirationTime = b;
                    break a;
                  }
                  p = p.return;
                } while (null !== p);
                h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
              }
              S !== jj && (S = ij);
              h = Ai(h, g);
              p = f2;
              do {
                switch (p.tag) {
                  case 3:
                    k = h;
                    p.effectTag |= 4096;
                    p.expirationTime = b;
                    var B = Xi(p, k, b);
                    yg(p, B);
                    break a;
                  case 1:
                    k = h;
                    var w = p.type, ub = p.stateNode;
                    if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                      p.effectTag |= 4096;
                      p.expirationTime = b;
                      var vb = $i(p, k, b);
                      yg(p, vb);
                      break a;
                    }
                }
                p = p.return;
              } while (null !== p);
            }
            X = Pj(X);
          } catch (Xc) {
            b = Xc;
            continue;
          }
          break;
        } while (1);
      }
      function Fj() {
        var a = cj.current;
        cj.current = sh;
        return null === a ? sh : a;
      }
      function Ag(a, b) {
        a < lj && 2 < a && (lj = a);
        null !== b && a < mj && 2 < a && (mj = a, nj = b);
      }
      function Bg(a) {
        a > wi && (wi = a);
      }
      function Kj() {
        for (; null !== X; )
          X = Qj(X);
      }
      function Gj() {
        for (; null !== X && !Uf(); )
          X = Qj(X);
      }
      function Qj(a) {
        var b = Rj(a.alternate, a, U);
        a.memoizedProps = a.pendingProps;
        null === b && (b = Pj(a));
        dj.current = null;
        return b;
      }
      function Pj(a) {
        X = a;
        do {
          var b = X.alternate;
          a = X.return;
          if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
              for (var c = 0, d = X.child; null !== d; ) {
                var e2 = d.expirationTime, f2 = d.childExpirationTime;
                e2 > c && (c = e2);
                f2 > c && (c = f2);
                d = d.sibling;
              }
              X.childExpirationTime = c;
            }
            if (null !== b)
              return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
          } else {
            b = zi(X);
            if (null !== b)
              return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
          }
          b = X.sibling;
          if (null !== b)
            return b;
          X = a;
        } while (null !== X);
        S === ti && (S = jj);
        return null;
      }
      function Ij(a) {
        var b = a.expirationTime;
        a = a.childExpirationTime;
        return b > a ? b : a;
      }
      function Jj(a) {
        var b = ag();
        cg(99, Sj.bind(null, a, b));
        return null;
      }
      function Sj(a, b) {
        do
          Dj();
        while (null !== rj);
        if ((W & (fj | gj)) !== V)
          throw Error(u(327));
        var c = a.finishedWork, d = a.finishedExpirationTime;
        if (null === c)
          return null;
        a.finishedWork = null;
        a.finishedExpirationTime = 0;
        if (c === a.current)
          throw Error(u(177));
        a.callbackNode = null;
        a.callbackExpirationTime = 0;
        a.callbackPriority = 90;
        a.nextKnownPendingLevel = 0;
        var e2 = Ij(c);
        a.firstPendingTime = e2;
        d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
        d <= a.lastPingedTime && (a.lastPingedTime = 0);
        d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
        a === T && (X = T = null, U = 0);
        1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e2 = c.firstEffect) : e2 = c : e2 = c.firstEffect;
        if (null !== e2) {
          var f2 = W;
          W |= gj;
          dj.current = null;
          Dd = fd;
          var g = xd();
          if (yd(g)) {
            if ("selectionStart" in g)
              var h = { start: g.selectionStart, end: g.selectionEnd };
            else
              a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                  h = k.anchorNode;
                  var l = k.anchorOffset, m = k.focusNode;
                  k = k.focusOffset;
                  try {
                    h.nodeType, m.nodeType;
                  } catch (wb) {
                    h = null;
                    break a;
                  }
                  var p = 0, x = -1, z = -1, ca = 0, D = 0, t2 = g, y = null;
                  b:
                    for (; ; ) {
                      for (var A; ; ) {
                        t2 !== h || 0 !== l && 3 !== t2.nodeType || (x = p + l);
                        t2 !== m || 0 !== k && 3 !== t2.nodeType || (z = p + k);
                        3 === t2.nodeType && (p += t2.nodeValue.length);
                        if (null === (A = t2.firstChild))
                          break;
                        y = t2;
                        t2 = A;
                      }
                      for (; ; ) {
                        if (t2 === g)
                          break b;
                        y === h && ++ca === l && (x = p);
                        y === m && ++D === k && (z = p);
                        if (null !== (A = t2.nextSibling))
                          break;
                        t2 = y;
                        y = t2.parentNode;
                      }
                      t2 = A;
                    }
                  h = -1 === x || -1 === z ? null : { start: x, end: z };
                } else
                  h = null;
              }
            h = h || { start: 0, end: 0 };
          } else
            h = null;
          Ed = { activeElementDetached: null, focusedElem: g, selectionRange: h };
          fd = false;
          Y = e2;
          do
            try {
              Tj();
            } catch (wb) {
              if (null === Y)
                throw Error(u(330));
              Ei(Y, wb);
              Y = Y.nextEffect;
            }
          while (null !== Y);
          Y = e2;
          do
            try {
              for (g = a, h = b; null !== Y; ) {
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                  var B = Y.alternate;
                  if (null !== B) {
                    var w = B.ref;
                    null !== w && ("function" === typeof w ? w(null) : w.current = null);
                  }
                }
                switch (q & 1038) {
                  case 2:
                    Pi(Y);
                    Y.effectTag &= -3;
                    break;
                  case 6:
                    Pi(Y);
                    Y.effectTag &= -3;
                    Si(Y.alternate, Y);
                    break;
                  case 1024:
                    Y.effectTag &= -1025;
                    break;
                  case 1028:
                    Y.effectTag &= -1025;
                    Si(Y.alternate, Y);
                    break;
                  case 4:
                    Si(Y.alternate, Y);
                    break;
                  case 8:
                    l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
              }
            } catch (wb) {
              if (null === Y)
                throw Error(u(330));
              Ei(Y, wb);
              Y = Y.nextEffect;
            }
          while (null !== Y);
          w = Ed;
          B = xd();
          q = w.focusedElem;
          h = w.selectionRange;
          if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for (w = q; w = w.parentNode; )
              1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
              });
            "function" === typeof q.focus && q.focus();
            for (q = 0; q < B.length; q++)
              w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
          }
          fd = !!Dd;
          Ed = Dd = null;
          a.current = c;
          Y = e2;
          do
            try {
              for (q = a; null !== Y; ) {
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                  B = void 0;
                  var vb = Y.ref;
                  if (null !== vb) {
                    var Xc = Y.stateNode;
                    switch (Y.tag) {
                      case 5:
                        B = Xc;
                        break;
                      default:
                        B = Xc;
                    }
                    "function" === typeof vb ? vb(B) : vb.current = B;
                  }
                }
                Y = Y.nextEffect;
              }
            } catch (wb) {
              if (null === Y)
                throw Error(u(330));
              Ei(Y, wb);
              Y = Y.nextEffect;
            }
          while (null !== Y);
          Y = null;
          Vf();
          W = f2;
        } else
          a.current = c;
        if (qj)
          qj = false, rj = a, sj = b;
        else
          for (Y = e2; null !== Y; )
            b = Y.nextEffect, Y.nextEffect = null, Y = b;
        b = a.firstPendingTime;
        0 === b && (aj = null);
        1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
        "function" === typeof Uj && Uj(c.stateNode, d);
        Z(a);
        if (Yi)
          throw Yi = false, a = Zi, Zi = null, a;
        if ((W & ej) !== V)
          return null;
        gg();
        return null;
      }
      function Tj() {
        for (; null !== Y; ) {
          var a = Y.effectTag;
          0 !== (a & 256) && Gi(Y.alternate, Y);
          0 === (a & 512) || qj || (qj = true, dg(97, function() {
            Dj();
            return null;
          }));
          Y = Y.nextEffect;
        }
      }
      function Dj() {
        if (90 !== sj) {
          var a = 97 < sj ? 97 : sj;
          sj = 90;
          return cg(a, Vj);
        }
      }
      function Vj() {
        if (null === rj)
          return false;
        var a = rj;
        rj = null;
        if ((W & (fj | gj)) !== V)
          throw Error(u(331));
        var b = W;
        W |= gj;
        for (a = a.current.firstEffect; null !== a; ) {
          try {
            var c = a;
            if (0 !== (c.effectTag & 512))
              switch (c.tag) {
                case 0:
                case 11:
                case 15:
                case 22:
                  Hi(5, c), Ii(5, c);
              }
          } catch (d) {
            if (null === a)
              throw Error(u(330));
            Ei(a, d);
          }
          c = a.nextEffect;
          a.nextEffect = null;
          a = c;
        }
        W = b;
        gg();
        return true;
      }
      function Wj(a, b, c) {
        b = Ai(c, b);
        b = Xi(a, b, 1073741823);
        xg(a, b);
        a = xj(a, 1073741823);
        null !== a && Z(a);
      }
      function Ei(a, b) {
        if (3 === a.tag)
          Wj(a, a, b);
        else
          for (var c = a.return; null !== c; ) {
            if (3 === c.tag) {
              Wj(c, a, b);
              break;
            } else if (1 === c.tag) {
              var d = c.stateNode;
              if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
              }
            }
            c = c.return;
          }
      }
      function Oj(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = true : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
      }
      function Vi(a, b) {
        var c = a.stateNode;
        null !== c && c.delete(b);
        b = 0;
        0 === b && (b = Gg(), b = Hg(b, a, null));
        a = xj(a, b);
        null !== a && Z(a);
      }
      var Rj;
      Rj = function(a, b, c) {
        var d = b.expirationTime;
        if (null !== a) {
          var e2 = b.pendingProps;
          if (a.memoizedProps !== e2 || K.current)
            rg = true;
          else {
            if (d < c) {
              rg = false;
              switch (b.tag) {
                case 3:
                  hi(b);
                  Xh();
                  break;
                case 5:
                  fh(b);
                  if (b.mode & 4 && 1 !== c && e2.hidden)
                    return b.expirationTime = b.childExpirationTime = 1, null;
                  break;
                case 1:
                  L(b.type) && Gf(b);
                  break;
                case 4:
                  dh(b, b.stateNode.containerInfo);
                  break;
                case 10:
                  d = b.memoizedProps.value;
                  e2 = b.type._context;
                  I(jg, e2._currentValue);
                  e2._currentValue = d;
                  break;
                case 13:
                  if (null !== b.memoizedState) {
                    d = b.child.childExpirationTime;
                    if (0 !== d && d >= c)
                      return ji(a, b, c);
                    I(M, M.current & 1);
                    b = $h(a, b, c);
                    return null !== b ? b.sibling : null;
                  }
                  I(M, M.current & 1);
                  break;
                case 19:
                  d = b.childExpirationTime >= c;
                  if (0 !== (a.effectTag & 64)) {
                    if (d)
                      return mi(a, b, c);
                    b.effectTag |= 64;
                  }
                  e2 = b.memoizedState;
                  null !== e2 && (e2.rendering = null, e2.tail = null);
                  I(M, M.current);
                  if (!d)
                    return null;
              }
              return $h(a, b, c);
            }
            rg = false;
          }
        } else
          rg = false;
        b.expirationTime = 0;
        switch (b.tag) {
          case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e2 = Cf(b, J.current);
            qg(b, c);
            e2 = oh(
              null,
              b,
              d,
              a,
              e2,
              c
            );
            b.effectTag |= 1;
            if ("object" === typeof e2 && null !== e2 && "function" === typeof e2.render && void 0 === e2.$$typeof) {
              b.tag = 1;
              b.memoizedState = null;
              b.updateQueue = null;
              if (L(d)) {
                var f2 = true;
                Gf(b);
              } else
                f2 = false;
              b.memoizedState = null !== e2.state && void 0 !== e2.state ? e2.state : null;
              ug(b);
              var g = d.getDerivedStateFromProps;
              "function" === typeof g && Fg(b, d, g, a);
              e2.updater = Jg;
              b.stateNode = e2;
              e2._reactInternalFiber = b;
              Ng(b, d, a, c);
              b = gi(null, b, d, true, f2, c);
            } else
              b.tag = 0, R(null, b, e2, c), b = b.child;
            return b;
          case 16:
            a: {
              e2 = b.elementType;
              null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
              a = b.pendingProps;
              ob(e2);
              if (1 !== e2._status)
                throw e2._result;
              e2 = e2._result;
              b.type = e2;
              f2 = b.tag = Xj(e2);
              a = ig(e2, a);
              switch (f2) {
                case 0:
                  b = di(null, b, e2, a, c);
                  break a;
                case 1:
                  b = fi(null, b, e2, a, c);
                  break a;
                case 11:
                  b = Zh(null, b, e2, a, c);
                  break a;
                case 14:
                  b = ai(null, b, e2, ig(e2.type, a), d, c);
                  break a;
              }
              throw Error(u(306, e2, ""));
            }
            return b;
          case 0:
            return d = b.type, e2 = b.pendingProps, e2 = b.elementType === d ? e2 : ig(d, e2), di(a, b, d, e2, c);
          case 1:
            return d = b.type, e2 = b.pendingProps, e2 = b.elementType === d ? e2 : ig(d, e2), fi(a, b, d, e2, c);
          case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d)
              throw Error(u(282));
            d = b.pendingProps;
            e2 = b.memoizedState;
            e2 = null !== e2 ? e2.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e2)
              Xh(), b = $h(a, b, c);
            else {
              if (e2 = b.stateNode.hydrate)
                Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e2 = Qh = true;
              if (e2)
                for (c = Yg(b, null, d, c), b.child = c; c; )
                  c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
              else
                R(a, b, d, c), Xh();
              b = b.child;
            }
            return b;
          case 5:
            return fh(b), null === a && Uh(b), d = b.type, e2 = b.pendingProps, f2 = null !== a ? a.memoizedProps : null, g = e2.children, Gd(d, e2) ? g = null : null !== f2 && Gd(d, f2) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e2.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
          case 6:
            return null === a && Uh(b), null;
          case 13:
            return ji(a, b, c);
          case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
          case 11:
            return d = b.type, e2 = b.pendingProps, e2 = b.elementType === d ? e2 : ig(d, e2), Zh(a, b, d, e2, c);
          case 7:
            return R(a, b, b.pendingProps, c), b.child;
          case 8:
            return R(
              a,
              b,
              b.pendingProps.children,
              c
            ), b.child;
          case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
          case 10:
            a: {
              d = b.type._context;
              e2 = b.pendingProps;
              g = b.memoizedProps;
              f2 = e2.value;
              var h = b.type._context;
              I(jg, h._currentValue);
              h._currentValue = f2;
              if (null !== g)
                if (h = g.value, f2 = $e(h, f2) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f2) : 1073741823) | 0, 0 === f2) {
                  if (g.children === e2.children && !K.current) {
                    b = $h(a, b, c);
                    break a;
                  }
                } else
                  for (h = b.child, null !== h && (h.return = b); null !== h; ) {
                    var k = h.dependencies;
                    if (null !== k) {
                      g = h.child;
                      for (var l = k.firstContext; null !== l; ) {
                        if (l.context === d && 0 !== (l.observedBits & f2)) {
                          1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                          h.expirationTime < c && (h.expirationTime = c);
                          l = h.alternate;
                          null !== l && l.expirationTime < c && (l.expirationTime = c);
                          pg(h.return, c);
                          k.expirationTime < c && (k.expirationTime = c);
                          break;
                        }
                        l = l.next;
                      }
                    } else
                      g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                    if (null !== g)
                      g.return = h;
                    else
                      for (g = h; null !== g; ) {
                        if (g === b) {
                          g = null;
                          break;
                        }
                        h = g.sibling;
                        if (null !== h) {
                          h.return = g.return;
                          g = h;
                          break;
                        }
                        g = g.return;
                      }
                    h = g;
                  }
              R(a, b, e2.children, c);
              b = b.child;
            }
            return b;
          case 9:
            return e2 = b.type, f2 = b.pendingProps, d = f2.children, qg(b, c), e2 = sg(e2, f2.unstable_observedBits), d = d(e2), b.effectTag |= 1, R(a, b, d, c), b.child;
          case 14:
            return e2 = b.type, f2 = ig(e2, b.pendingProps), f2 = ig(e2.type, f2), ai(a, b, e2, f2, d, c);
          case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
          case 17:
            return d = b.type, e2 = b.pendingProps, e2 = b.elementType === d ? e2 : ig(d, e2), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = true, Gf(b)) : a = false, qg(b, c), Lg(b, d, e2), Ng(b, d, e2, c), gi(
              null,
              b,
              d,
              true,
              a,
              c
            );
          case 19:
            return mi(a, b, c);
        }
        throw Error(u(156, b.tag));
      };
      var Uj = null;
      var Li = null;
      function Yj(a) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)
          return false;
        var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (b.isDisabled || !b.supportsFiber)
          return true;
        try {
          var c = b.inject(a);
          Uj = function(a2) {
            try {
              b.onCommitFiberRoot(c, a2, void 0, 64 === (a2.current.effectTag & 64));
            } catch (e2) {
            }
          };
          Li = function(a2) {
            try {
              b.onCommitFiberUnmount(c, a2);
            } catch (e2) {
            }
          };
        } catch (d) {
        }
        return true;
      }
      function Zj(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.effectTag = 0;
        this.lastEffect = this.firstEffect = this.nextEffect = null;
        this.childExpirationTime = this.expirationTime = 0;
        this.alternate = null;
      }
      function Sh(a, b, c, d) {
        return new Zj(a, b, c, d);
      }
      function bi(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
      }
      function Xj(a) {
        if ("function" === typeof a)
          return bi(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
          a = a.$$typeof;
          if (a === gb)
            return 11;
          if (a === jb)
            return 14;
        }
        return 2;
      }
      function Sg(a, b) {
        var c = a.alternate;
        null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
        c.childExpirationTime = a.childExpirationTime;
        c.expirationTime = a.expirationTime;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
          expirationTime: b.expirationTime,
          firstContext: b.firstContext,
          responders: b.responders
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
      }
      function Ug(a, b, c, d, e2, f2) {
        var g = 2;
        d = a;
        if ("function" === typeof a)
          bi(a) && (g = 1);
        else if ("string" === typeof a)
          g = 5;
        else
          a:
            switch (a) {
              case ab:
                return Wg(c.children, e2, f2, b);
              case fb:
                g = 8;
                e2 |= 7;
                break;
              case bb:
                g = 8;
                e2 |= 1;
                break;
              case cb:
                return a = Sh(12, c, b, e2 | 8), a.elementType = cb, a.type = cb, a.expirationTime = f2, a;
              case hb:
                return a = Sh(13, c, b, e2), a.type = hb, a.elementType = hb, a.expirationTime = f2, a;
              case ib:
                return a = Sh(19, c, b, e2), a.elementType = ib, a.expirationTime = f2, a;
              default:
                if ("object" === typeof a && null !== a)
                  switch (a.$$typeof) {
                    case db:
                      g = 10;
                      break a;
                    case eb:
                      g = 9;
                      break a;
                    case gb:
                      g = 11;
                      break a;
                    case jb:
                      g = 14;
                      break a;
                    case kb:
                      g = 16;
                      d = null;
                      break a;
                    case lb:
                      g = 22;
                      break a;
                  }
                throw Error(u(130, null == a ? a : typeof a, ""));
            }
        b = Sh(g, c, b, e2);
        b.elementType = a;
        b.type = d;
        b.expirationTime = f2;
        return b;
      }
      function Wg(a, b, c, d) {
        a = Sh(7, a, d, b);
        a.expirationTime = c;
        return a;
      }
      function Tg(a, b, c) {
        a = Sh(6, a, null, b);
        a.expirationTime = c;
        return a;
      }
      function Vg(a, b, c) {
        b = Sh(4, null !== a.children ? a.children : [], a.key, b);
        b.expirationTime = c;
        b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
        return b;
      }
      function ak(a, b, c) {
        this.tag = b;
        this.current = null;
        this.containerInfo = a;
        this.pingCache = this.pendingChildren = null;
        this.finishedExpirationTime = 0;
        this.finishedWork = null;
        this.timeoutHandle = -1;
        this.pendingContext = this.context = null;
        this.hydrate = c;
        this.callbackNode = null;
        this.callbackPriority = 90;
        this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
      }
      function Aj(a, b) {
        var c = a.firstSuspendedTime;
        a = a.lastSuspendedTime;
        return 0 !== c && c >= b && a <= b;
      }
      function xi(a, b) {
        var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
        c < b && (a.firstSuspendedTime = b);
        if (d > b || 0 === c)
          a.lastSuspendedTime = b;
        b <= a.lastPingedTime && (a.lastPingedTime = 0);
        b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
      }
      function yi(a, b) {
        b > a.firstPendingTime && (a.firstPendingTime = b);
        var c = a.firstSuspendedTime;
        0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
      }
      function Cj(a, b) {
        var c = a.lastExpiredTime;
        if (0 === c || c > b)
          a.lastExpiredTime = b;
      }
      function bk(a, b, c, d) {
        var e2 = b.current, f2 = Gg(), g = Dg.suspense;
        f2 = Hg(f2, e2, g);
        a:
          if (c) {
            c = c._reactInternalFiber;
            b: {
              if (dc(c) !== c || 1 !== c.tag)
                throw Error(u(170));
              var h = c;
              do {
                switch (h.tag) {
                  case 3:
                    h = h.stateNode.context;
                    break b;
                  case 1:
                    if (L(h.type)) {
                      h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                      break b;
                    }
                }
                h = h.return;
              } while (null !== h);
              throw Error(u(171));
            }
            if (1 === c.tag) {
              var k = c.type;
              if (L(k)) {
                c = Ff(c, k, h);
                break a;
              }
            }
            c = h;
          } else
            c = Af;
        null === b.context ? b.context = c : b.pendingContext = c;
        b = wg(f2, g);
        b.payload = { element: a };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        xg(e2, b);
        Ig(e2, f2);
        return f2;
      }
      function ck(a) {
        a = a.current;
        if (!a.child)
          return null;
        switch (a.child.tag) {
          case 5:
            return a.child.stateNode;
          default:
            return a.child.stateNode;
        }
      }
      function dk(a, b) {
        a = a.memoizedState;
        null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
      }
      function ek(a, b) {
        dk(a, b);
        (a = a.alternate) && dk(a, b);
      }
      function fk(a, b, c) {
        c = null != c && true === c.hydrate;
        var d = new ak(a, b, c), e2 = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
        d.current = e2;
        e2.stateNode = d;
        ug(e2);
        a[Od] = d.current;
        c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
        this._internalRoot = d;
      }
      fk.prototype.render = function(a) {
        bk(a, this._internalRoot, null, null);
      };
      fk.prototype.unmount = function() {
        var a = this._internalRoot, b = a.containerInfo;
        bk(null, a, null, function() {
          b[Od] = null;
        });
      };
      function gk(a) {
        return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
      }
      function hk(a, b) {
        b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
        if (!b)
          for (var c; c = a.lastChild; )
            a.removeChild(c);
        return new fk(a, 0, b ? { hydrate: true } : void 0);
      }
      function ik(a, b, c, d, e2) {
        var f2 = c._reactRootContainer;
        if (f2) {
          var g = f2._internalRoot;
          if ("function" === typeof e2) {
            var h = e2;
            e2 = function() {
              var a2 = ck(g);
              h.call(a2);
            };
          }
          bk(b, g, a, e2);
        } else {
          f2 = c._reactRootContainer = hk(c, d);
          g = f2._internalRoot;
          if ("function" === typeof e2) {
            var k = e2;
            e2 = function() {
              var a2 = ck(g);
              k.call(a2);
            };
          }
          Nj(function() {
            bk(b, g, a, e2);
          });
        }
        return ck(g);
      }
      function jk(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return { $$typeof: $a, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
      }
      wc = function(a) {
        if (13 === a.tag) {
          var b = hg(Gg(), 150, 100);
          Ig(a, b);
          ek(a, b);
        }
      };
      xc = function(a) {
        13 === a.tag && (Ig(a, 3), ek(a, 3));
      };
      yc = function(a) {
        if (13 === a.tag) {
          var b = Gg();
          b = Hg(b, a, null);
          Ig(a, b);
          ek(a, b);
        }
      };
      za = function(a, b, c) {
        switch (b) {
          case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
              for (c = a; c.parentNode; )
                c = c.parentNode;
              c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
              for (b = 0; b < c.length; b++) {
                var d = c[b];
                if (d !== a && d.form === a.form) {
                  var e2 = Qd(d);
                  if (!e2)
                    throw Error(u(90));
                  yb(d);
                  Cb(d, e2);
                }
              }
            }
            break;
          case "textarea":
            Kb(a, c);
            break;
          case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, false);
        }
      };
      Fa = Mj;
      Ga = function(a, b, c, d, e2) {
        var f2 = W;
        W |= 4;
        try {
          return cg(98, a.bind(null, b, c, d, e2));
        } finally {
          W = f2, W === V && gg();
        }
      };
      Ha = function() {
        (W & (1 | fj | gj)) === V && (Lj(), Dj());
      };
      Ia = function(a, b) {
        var c = W;
        W |= 2;
        try {
          return a(b);
        } finally {
          W = c, W === V && gg();
        }
      };
      function kk(a, b) {
        var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!gk(b))
          throw Error(u(200));
        return jk(a, b, null, c);
      }
      var lk = { Events: [Nc, Pd, Qd, xa, ta, Xd, function(a) {
        jc(a, Wd);
      }, Da, Ea, id, mc, Dj, { current: false }] };
      (function(a) {
        var b = a.findFiberByHostInstance;
        return Yj(n2({}, a, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Wa.ReactCurrentDispatcher, findHostInstanceByFiber: function(a2) {
          a2 = hc(a2);
          return null === a2 ? null : a2.stateNode;
        }, findFiberByHostInstance: function(a2) {
          return b ? b(a2) : null;
        }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
      })({
        findFiberByHostInstance: tc,
        bundleType: 0,
        version: "16.14.0",
        rendererPackageName: "react-dom"
      });
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
      exports.createPortal = kk;
      exports.findDOMNode = function(a) {
        if (null == a)
          return null;
        if (1 === a.nodeType)
          return a;
        var b = a._reactInternalFiber;
        if (void 0 === b) {
          if ("function" === typeof a.render)
            throw Error(u(188));
          throw Error(u(268, Object.keys(a)));
        }
        a = hc(b);
        a = null === a ? null : a.stateNode;
        return a;
      };
      exports.flushSync = function(a, b) {
        if ((W & (fj | gj)) !== V)
          throw Error(u(187));
        var c = W;
        W |= 1;
        try {
          return cg(99, a.bind(null, b));
        } finally {
          W = c, gg();
        }
      };
      exports.hydrate = function(a, b, c) {
        if (!gk(b))
          throw Error(u(200));
        return ik(null, a, b, true, c);
      };
      exports.render = function(a, b, c) {
        if (!gk(b))
          throw Error(u(200));
        return ik(null, a, b, false, c);
      };
      exports.unmountComponentAtNode = function(a) {
        if (!gk(a))
          throw Error(u(40));
        return a._reactRootContainer ? (Nj(function() {
          ik(null, null, a, false, function() {
            a._reactRootContainer = null;
            a[Od] = null;
          });
        }), true) : false;
      };
      exports.unstable_batchedUpdates = Mj;
      exports.unstable_createPortal = function(a, b) {
        return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
      };
      exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
        if (!gk(c))
          throw Error(u(200));
        if (null == a || void 0 === a._reactInternalFiber)
          throw Error(u(38));
        return ik(a, b, c, false, d);
      };
      exports.version = "16.14.0";
    }
  });

  // node_modules/react-dom/index.js
  var require_react_dom = __commonJS({
    "node_modules/react-dom/index.js"(exports, module) {
      init_react_import();
      function checkDCE() {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
          return;
        }
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
        } catch (err) {
          console.error(err);
        }
      }
      {
        checkDCE();
        module.exports = require_react_dom_production_min();
      }
    }
  });

  // src/entries/cart-custom.tsx
  init_react_import();
  var import_react11 = __toESM(require_react());
  var import_react_dom = __toESM(require_react_dom());

  // src/components/preact/components/Cart/index.tsx
  init_react_import();
  var import_react10 = __toESM(require_react());

  // src/components/preact/components/Cart/CartSection.tsx
  init_react_import();
  var import_react9 = __toESM(require_react());

  // src/components/preact/components/Modal/index.tsx
  init_react_import();

  // node_modules/clsx/dist/clsx.m.js
  init_react_import();
  function toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") {
      str += mix;
    } else if (typeof mix === "object") {
      if (Array.isArray(mix)) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k]) {
            if (y = toVal(mix[k])) {
              str && (str += " ");
              str += y;
            }
          }
        }
      } else {
        for (k in mix) {
          if (mix[k]) {
            str && (str += " ");
            str += k;
          }
        }
      }
    }
    return str;
  }
  function clsx_m_default() {
    var i = 0, tmp, x, str = "";
    while (i < arguments.length) {
      if (tmp = arguments[i++]) {
        if (x = toVal(tmp)) {
          str && (str += " ");
          str += x;
        }
      }
    }
    return str;
  }

  // src/components/preact/components/Modal/index.tsx
  var import_react3 = __toESM(require_react());

  // src/components/preact/components/ModalBackdrop/index.tsx
  init_react_import();
  var import_react2 = __toESM(require_react());
  var ModalBackdrop = ({
    className,
    open,
    onClick,
    onClosed,
    children
  }) => {
    const [isInternalOpen, setInternalOpen] = import_react2.default.useState(open);
    import_react2.default.useEffect(() => {
      if (!open)
        return;
      setInternalOpen(open);
    }, [open]);
    const onInternalClose = import_react2.default.useCallback(() => {
      if (open)
        return;
      setInternalOpen(false);
    }, [open]);
    const handleCloseEnd = import_react2.default.useCallback(() => {
      onInternalClose();
      if (!open) {
        onClosed && onClosed();
      }
    }, [onInternalClose, open, onClosed]);
    const onChildClick = import_react2.default.useCallback((e2) => {
      e2.stopPropagation();
    }, []);
    return isInternalOpen ? /* @__PURE__ */ import_react2.default.createElement("div", {
      className: clsx_m_default(
        "fixed inset-0 z-[1000] bg-[rgba(51,51,51,0.08)] opacity-0",
        {
          "visible fade-in": open,
          "fade-out": !open
        },
        className
      ),
      onClick,
      onAnimationEnd: handleCloseEnd
    }, /* @__PURE__ */ import_react2.default.createElement("div", {
      onClick: onChildClick
    }, children)) : null;
  };

  // src/components/icons/CloseIcon/index.tsx
  init_react_import();
  var CloseIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default("w-6", className),
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M6.34375 17.6565L17.6575 6.34277M6.34375 6.34277L17.6575 17.6565L6.34375 6.34277Z",
      stroke: "#333333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/components/preact/components/Modal/index.tsx
  var useLockBodyScroll = (enabled) => {
    import_react3.default.useEffect(() => {
      if (typeof window === "undefined" || !enabled)
        return;
      document.body.style.overflow = "hidden";
      document.body.style.top = `-${window.scrollY}px`;
      return () => {
        if (typeof window === "undefined")
          return;
        const scrollY = document.body.style.top;
        document.body.style.overflow = "";
        document.body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      };
    }, [enabled]);
  };
  var Modal = ({
    className,
    open,
    disablePadding,
    disableBackdropClose,
    hideCloseButton,
    children,
    onClose
  }) => {
    useLockBodyScroll(open);
    return /* @__PURE__ */ import_react3.default.createElement(ModalBackdrop, {
      open,
      onClick: disableBackdropClose ? void 0 : onClose
    }, /* @__PURE__ */ import_react3.default.createElement("div", {
      className: clsx_m_default(
        className,
        "overflow-x-hidden overflow-y-scroll fixed top-1/2 left-1/2 z-10 bg-white rounded-lg shadow-[0_4px_16px_4px_rgba(0,0,0,0.08)] -translate-x-1/2 -translate-y-1/2",
        {
          "p-10": !disablePadding
        }
      )
    }, !hideCloseButton && /* @__PURE__ */ import_react3.default.createElement("button", {
      className: "block absolute top-4 right-4",
      onClick: onClose
    }, /* @__PURE__ */ import_react3.default.createElement(CloseIcon, null)), children));
  };

  // src/components/preact/components/Cart/GiftForm/index.tsx
  init_react_import();

  // node_modules/@hookform/resolvers/zod/dist/zod.mjs
  init_react_import();

  // node_modules/react-hook-form/dist/index.esm.mjs
  init_react_import();
  var import_react4 = __toESM(require_react(), 1);
  var isCheckBoxInput = (element) => element.type === "checkbox";
  var isDateObject = (value) => value instanceof Date;
  var isNullOrUndefined = (value) => value == null;
  var isObjectType = (value) => typeof value === "object";
  var isObject = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
  var getEventValue = (event) => isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
  var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
  var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
  var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
  var isUndefined = (val) => val === void 0;
  var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
      return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], obj);
    return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
  };
  var EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
  };
  var VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
  };
  var INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
  };
  import_react4.default.createContext(null);
  var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
      Object.defineProperty(result, key, {
        get: () => {
          const _key = key;
          if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
            _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
          }
          localProxyFormState && (localProxyFormState[_key] = true);
          return formState[_key];
        }
      });
    }
    return result;
  };
  var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;
  var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key) => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
  };
  var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
  function useSubscribe(props) {
    const _props = import_react4.default.useRef(props);
    _props.current = props;
    import_react4.default.useEffect(() => {
      const tearDown = (subscription2) => {
        if (subscription2) {
          subscription2.unsubscribe();
        }
      };
      const subscription = !props.disabled && _props.current.subject.subscribe({
        next: _props.current.callback
      });
      return () => tearDown(subscription);
    }, [props.disabled]);
  }
  var isString = (value) => typeof value === "string";
  var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString(names)) {
      isGlobal && _names.watch.add(names);
      return get(formValues, names);
    }
    if (isArray) {
      return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
  };
  var isFunction = (value) => typeof value === "function";
  var objectHasFunction = (data) => {
    for (const key in data) {
      if (isFunction(data[key])) {
        return true;
      }
    }
    return false;
  };
  var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? {
    ...errors[name],
    types: {
      ...errors[name] && errors[name].types ? errors[name].types : {},
      [type]: message || true
    }
  } : {};
  var isKey = (value) => /^\w*$/.test(value);
  var stringToPath = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
  function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
      const key = tempPath[index];
      let newValue = value;
      if (index !== lastIndex) {
        const objValue = object[key];
        newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
      }
      object[key] = newValue;
      object = object[key];
    }
    return object;
  }
  var focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
      const field = get(fields, key);
      if (field) {
        const { _f, ...currentField } = field;
        if (_f && callback(_f.name)) {
          if (_f.ref.focus && isUndefined(_f.ref.focus())) {
            break;
          } else if (_f.refs) {
            _f.refs[0].focus();
            break;
          }
        } else if (isObject(currentField)) {
          focusFieldBy(currentField, callback);
        }
      }
    }
  };
  var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some((watchName) => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
  var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, "root", error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
  };
  var isBoolean = (value) => typeof value === "boolean";
  var isFileInput = (element) => element.type === "file";
  var isMessage = (value) => isString(value) || import_react4.default.isValidElement(value);
  var isRadioInput = (element) => element.type === "radio";
  var isRegex = (value) => value instanceof RegExp;
  var defaultResult = {
    value: false,
    isValid: false
  };
  var validResult = { value: true, isValid: true };
  var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
      if (options.length > 1) {
        const values = options.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
        return { value: values, isValid: !!values.length };
      }
      return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : { value: options[0].value, isValid: true } : validResult : defaultResult;
    }
    return defaultResult;
  };
  var defaultReturn = {
    isValid: false,
    value: null
  };
  var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous, option) => option && option.checked && !option.disabled ? {
    isValid: true,
    value: option.value
  } : previous, defaultReturn) : defaultReturn;
  function getValidateError(result, ref, type = "validate") {
    if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
      return {
        type,
        message: isMessage(result) ? result : "",
        ref
      };
    }
  }
  var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ""
  };
  var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
    if (!mount || disabled) {
      return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
      if (shouldUseNativeValidation && inputRef.reportValidity) {
        inputRef.setCustomValidity(isBoolean(message) ? "" : message || " ");
        inputRef.reportValidity();
      }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox2 = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && !ref.value || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
      const message = exceedMax ? maxLengthMessage : minLengthMessage;
      error[name] = {
        type: exceedMax ? maxType : minType,
        message,
        ref,
        ...appendErrorsCurry(exceedMax ? maxType : minType, message)
      };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox2 && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
      const { value, message } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
      if (value) {
        error[name] = {
          type: INPUT_VALIDATION_RULES.required,
          message,
          ref: inputRef,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(message);
          return error;
        }
      }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
      let exceedMax;
      let exceedMin;
      const maxOutput = getValueAndMessage(max);
      const minOutput = getValueAndMessage(min);
      if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
        const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
        if (!isNullOrUndefined(maxOutput.value)) {
          exceedMax = valueNumber > maxOutput.value;
        }
        if (!isNullOrUndefined(minOutput.value)) {
          exceedMin = valueNumber < minOutput.value;
        }
      } else {
        const valueDate = ref.valueAsDate || new Date(inputValue);
        if (isString(maxOutput.value)) {
          exceedMax = valueDate > new Date(maxOutput.value);
        }
        if (isString(minOutput.value)) {
          exceedMin = valueDate < new Date(minOutput.value);
        }
      }
      if (exceedMax || exceedMin) {
        getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
        if (!validateAllFieldCriteria) {
          setCustomValidity(error[name].message);
          return error;
        }
      }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
      const maxLengthOutput = getValueAndMessage(maxLength);
      const minLengthOutput = getValueAndMessage(minLength);
      const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
      const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
      if (exceedMax || exceedMin) {
        getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
        if (!validateAllFieldCriteria) {
          setCustomValidity(error[name].message);
          return error;
        }
      }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
      const { value: patternValue, message } = getValueAndMessage(pattern);
      if (isRegex(patternValue) && !inputValue.match(patternValue)) {
        error[name] = {
          type: INPUT_VALIDATION_RULES.pattern,
          message,
          ref,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(message);
          return error;
        }
      }
    }
    if (validate) {
      if (isFunction(validate)) {
        const result = await validate(inputValue);
        const validateError = getValidateError(result, inputRef);
        if (validateError) {
          error[name] = {
            ...validateError,
            ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
          };
          if (!validateAllFieldCriteria) {
            setCustomValidity(validateError.message);
            return error;
          }
        }
      } else if (isObject(validate)) {
        let validationResult = {};
        for (const key in validate) {
          if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
            break;
          }
          const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
          if (validateError) {
            validationResult = {
              ...validateError,
              ...appendErrorsCurry(key, validateError.message)
            };
            setCustomValidity(validateError.message);
            if (validateAllFieldCriteria) {
              error[name] = validationResult;
            }
          }
        }
        if (!isEmptyObject(validationResult)) {
          error[name] = {
            ref: inputRef,
            ...validationResult
          };
          if (!validateAllFieldCriteria) {
            return error;
          }
        }
      }
    }
    setCustomValidity(true);
    return error;
  };
  var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
  function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
      copy = new Date(data);
    } else if (data instanceof Set) {
      copy = new Set(data);
    } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
      copy = isArray ? [] : {};
      for (const key in data) {
        if (isFunction(data[key])) {
          copy = data;
          break;
        }
        copy[key] = cloneObject(data[key]);
      }
    } else {
      return data;
    }
    return copy;
  }
  var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  });
  function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
      object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
  }
  function isEmptyArray(obj) {
    for (const key in obj) {
      if (!isUndefined(obj[key])) {
        return false;
      }
    }
    return true;
  }
  function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
      delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
      let index = -1;
      let objectRef;
      const currentPaths = updatePath.slice(0, -(k + 1));
      const currentPathsLength = currentPaths.length - 1;
      if (k > 0) {
        previousObjRef = object;
      }
      while (++index < currentPaths.length) {
        const item = currentPaths[index];
        objectRef = objectRef ? objectRef[item] : object[item];
        if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && isEmptyArray(objectRef))) {
          previousObjRef ? delete previousObjRef[item] : delete object[item];
        }
        previousObjRef = objectRef;
      }
    }
    return object;
  }
  function createSubject() {
    let _observers = [];
    const next = (value) => {
      for (const observer of _observers) {
        observer.next(value);
      }
    };
    const subscribe = (observer) => {
      _observers.push(observer);
      return {
        unsubscribe: () => {
          _observers = _observers.filter((o) => o !== observer);
        }
      };
    };
    const unsubscribe = () => {
      _observers = [];
    };
    return {
      get observers() {
        return _observers;
      },
      next,
      subscribe,
      unsubscribe
    };
  }
  var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
  function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
      return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
      return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      if (!keys2.includes(key)) {
        return false;
      }
      if (key !== "ref") {
        const val2 = object2[key];
        if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
          return false;
        }
      }
    }
    return true;
  }
  var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
  };
  var isMultipleSelect = (element) => element.type === `select-multiple`;
  var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
  var live = (ref) => isHTMLElement(ref) && ref.isConnected;
  function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
      for (const key in data) {
        if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
          fields[key] = Array.isArray(data[key]) ? [] : {};
          markFieldsDirty(data[key], fields[key]);
        } else if (!isNullOrUndefined(data[key])) {
          fields[key] = true;
        }
      }
    }
    return fields;
  }
  function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
      for (const key in data) {
        if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
          if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
            dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : { ...markFieldsDirty(data[key]) };
          } else {
            getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
          }
        } else {
          dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
        }
      }
    }
    return dirtyFieldsFromValues;
  }
  var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
  var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value) ? value : valueAsNumber ? value === "" ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
  function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref2) => ref2.disabled) : ref.disabled) {
      return;
    }
    if (isFileInput(ref)) {
      return ref.files;
    }
    if (isRadioInput(ref)) {
      return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
      return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
  }
  var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
      const field = get(_fields, name);
      field && set(fields, name, field._f);
    }
    return {
      criteriaMode,
      names: [...fieldsNames],
      fields,
      shouldUseNativeValidation
    };
  };
  var getRuleValue = (rule) => isUndefined(rule) ? void 0 : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
  var hasValidation = (options) => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
  function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
      return {
        error,
        name
      };
    }
    const names = name.split(".");
    while (names.length) {
      const fieldName = names.join(".");
      const field = get(_fields, fieldName);
      const foundError = get(errors, fieldName);
      if (field && !Array.isArray(field) && name !== fieldName) {
        return { name };
      }
      if (foundError && foundError.type) {
        return {
          name: fieldName,
          error: foundError
        };
      }
      names.pop();
    }
    return {
      name
    };
  }
  var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
      return false;
    } else if (!isSubmitted && mode.isOnTouch) {
      return !(isTouched || isBlurEvent);
    } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
      return !isBlurEvent;
    } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
      return isBlurEvent;
    }
    return true;
  };
  var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
  var defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
  };
  function createFormControl(props = {}) {
    let _options = {
      ...defaultOptions,
      ...props
    };
    let _formState = {
      isDirty: false,
      isValidating: false,
      dirtyFields: {},
      isSubmitted: false,
      submitCount: 0,
      touchedFields: {},
      isSubmitting: false,
      isSubmitSuccessful: false,
      isValid: false,
      errors: {}
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _stateFlags = {
      action: false,
      mount: false,
      watch: false
    };
    let _names = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
      isDirty: false,
      dirtyFields: false,
      touchedFields: false,
      isValidating: false,
      isValid: false,
      errors: false
    };
    const _subjects = {
      watch: createSubject(),
      array: createSubject(),
      state: createSubject()
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
      clearTimeout(timer);
      timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldSkipRender) => {
      let isValid2 = false;
      if (_proxyFormState.isValid) {
        isValid2 = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
        if (!shouldSkipRender && isValid2 !== _formState.isValid) {
          _formState.isValid = isValid2;
          _subjects.state.next({
            isValid: isValid2
          });
        }
      }
      return isValid2;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
      if (args && method) {
        _stateFlags.action = true;
        if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
          const fieldValues = method(get(_fields, name), args.argA, args.argB);
          shouldSetValues && set(_fields, name, fieldValues);
        }
        if (_proxyFormState.errors && shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
          const errors = method(get(_formState.errors, name), args.argA, args.argB);
          shouldSetValues && set(_formState.errors, name, errors);
          unsetEmptyArray(_formState.errors, name);
        }
        if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
          const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
          shouldSetValues && set(_formState.touchedFields, name, touchedFields);
        }
        if (_proxyFormState.dirtyFields) {
          _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
        }
        _subjects.state.next({
          isDirty: _getDirty(name, values),
          dirtyFields: _formState.dirtyFields,
          errors: _formState.errors,
          isValid: _formState.isValid
        });
      } else {
        set(_formValues, name, values);
      }
    };
    const updateErrors = (name, error) => {
      set(_formState.errors, name, error);
      _subjects.state.next({
        errors: _formState.errors
      });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
      const field = get(_fields, name);
      if (field) {
        const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
        isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
        _stateFlags.mount && _updateValid();
      }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
      let isFieldDirty = false;
      const output = {
        name
      };
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (_proxyFormState.isDirty) {
        const isPreviousFormDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        isFieldDirty = isPreviousFormDirty !== output.isDirty;
      }
      if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
        const isPreviousFieldDirty = get(_formState.dirtyFields, name);
        const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
        isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
        output.dirtyFields = _formState.dirtyFields;
        isFieldDirty = isFieldDirty || isPreviousFieldDirty !== get(_formState.dirtyFields, name);
      }
      if (isBlurEvent && !isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        isFieldDirty = isFieldDirty || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
      isFieldDirty && shouldRender && _subjects.state.next(output);
      return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid2, error, fieldState) => {
      const previousFieldError = get(_formState.errors, name);
      const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid2;
      if (props.delayError && error) {
        delayErrorCallback = debounce(() => updateErrors(name, error));
        delayErrorCallback(props.delayError);
      } else {
        clearTimeout(timer);
        delayErrorCallback = null;
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
      if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
        const updatedFormState = {
          ...fieldState,
          ...shouldUpdateValid ? { isValid: isValid2 } : {},
          errors: _formState.errors,
          name
        };
        _formState = {
          ..._formState,
          ...updatedFormState
        };
        _subjects.state.next(updatedFormState);
      }
      validateFields[name]--;
      if (_proxyFormState.isValidating && !Object.values(validateFields).some((v) => v)) {
        _subjects.state.next({
          isValidating: false
        });
        validateFields = {};
      }
    };
    const _executeSchema = async (name) => _options.resolver ? await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)) : {};
    const executeSchemaAndUpdateState = async (names) => {
      const { errors } = await _executeSchema();
      if (names) {
        for (const name of names) {
          const error = get(errors, name);
          error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
      } else {
        _formState.errors = errors;
      }
      return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
      valid: true
    }) => {
      for (const name in fields) {
        const field = fields[name];
        if (field) {
          const { _f, ...fieldValue } = field;
          if (_f) {
            const isFieldArrayRoot = _names.array.has(_f.name);
            const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
            if (fieldError[_f.name]) {
              context.valid = false;
              if (shouldOnlyCheckValid) {
                break;
              }
            }
            !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
          }
          fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
        }
      }
      return context.valid;
    };
    const _removeUnmounted = () => {
      for (const name of _names.unMount) {
        const field = get(_fields, name);
        field && (field._f.refs ? field._f.refs.every((ref) => !live(ref)) : !live(field._f.ref)) && unregister(name);
      }
      _names.unMount = /* @__PURE__ */ new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
      const fieldValues = {
        ..._stateFlags.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? { [names]: defaultValue } : defaultValue
      };
      return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
      const field = get(_fields, name);
      let fieldValue = value;
      if (field) {
        const fieldReference = field._f;
        if (fieldReference) {
          !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
          fieldValue = isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
          if (isMultipleSelect(fieldReference.ref)) {
            [...fieldReference.ref.options].forEach((selectRef) => selectRef.selected = fieldValue.includes(selectRef.value));
          } else if (fieldReference.refs) {
            if (isCheckBoxInput(fieldReference.ref)) {
              fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data) => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
            } else {
              fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
            }
          } else if (isFileInput(fieldReference.ref)) {
            fieldReference.ref.value = "";
          } else {
            fieldReference.ref.value = fieldValue;
            if (!fieldReference.ref.type) {
              _subjects.watch.next({
                name
              });
            }
          }
        }
      }
      (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
      options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
      for (const fieldKey in value) {
        const fieldValue = value[fieldKey];
        const fieldName = `${name}.${fieldKey}`;
        const field = get(_fields, fieldName);
        (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
      }
    };
    const setValue = (name, value, options = {}) => {
      const field = get(_fields, name);
      const isFieldArray = _names.array.has(name);
      const cloneValue = cloneObject(value);
      set(_formValues, name, cloneValue);
      if (isFieldArray) {
        _subjects.array.next({
          name,
          values: _formValues
        });
        if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
          _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
          _subjects.state.next({
            name,
            dirtyFields: _formState.dirtyFields,
            isDirty: _getDirty(name, cloneValue)
          });
        }
      } else {
        field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
      }
      isWatched(name, _names) && _subjects.state.next({});
      _subjects.watch.next({
        name
      });
    };
    const onChange = async (event) => {
      const target = event.target;
      let name = target.name;
      const field = get(_fields, name);
      if (field) {
        let error;
        let isValid2;
        const fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
        const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
        const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
        const watched = isWatched(name, _names, isBlurEvent);
        set(_formValues, name, fieldValue);
        if (isBlurEvent) {
          field._f.onBlur && field._f.onBlur(event);
          delayErrorCallback && delayErrorCallback(0);
        } else if (field._f.onChange) {
          field._f.onChange(event);
        }
        const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
        const shouldRender = !isEmptyObject(fieldState) || watched;
        !isBlurEvent && _subjects.watch.next({
          name,
          type: event.type
        });
        if (shouldSkipValidation) {
          return shouldRender && _subjects.state.next({ name, ...watched ? {} : fieldState });
        }
        !isBlurEvent && watched && _subjects.state.next({});
        validateFields[name] = validateFields[name] ? 1 : 1;
        _subjects.state.next({
          isValidating: true
        });
        if (_options.resolver) {
          const { errors } = await _executeSchema([name]);
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
          error = errorLookupResult.error;
          name = errorLookupResult.name;
          isValid2 = isEmptyObject(errors);
        } else {
          error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
          isValid2 = await _updateValid(true);
        }
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid2, error, fieldState);
      }
    };
    const trigger = async (name, options = {}) => {
      let isValid2;
      let validationResult;
      const fieldNames = convertToArrayPayload(name);
      _subjects.state.next({
        isValidating: true
      });
      if (_options.resolver) {
        const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
        isValid2 = isEmptyObject(errors);
        validationResult = name ? !fieldNames.some((name2) => get(errors, name2)) : isValid2;
      } else if (name) {
        validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
          const field = get(_fields, fieldName);
          return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
        }))).every(Boolean);
        !(!validationResult && !_formState.isValid) && _updateValid();
      } else {
        validationResult = isValid2 = await executeBuiltInValidation(_fields);
      }
      _subjects.state.next({
        ...!isString(name) || _proxyFormState.isValid && isValid2 !== _formState.isValid ? {} : { name },
        ..._options.resolver ? { isValid: isValid2 } : {},
        errors: _formState.errors,
        isValidating: false
      });
      options.shouldFocus && !validationResult && focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
      return validationResult;
    };
    const getValues = (fieldNames) => {
      const values = {
        ..._defaultValues,
        ..._stateFlags.mount ? _formValues : {}
      };
      return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
      invalid: !!get((formState || _formState).errors, name),
      isDirty: !!get((formState || _formState).dirtyFields, name),
      isTouched: !!get((formState || _formState).touchedFields, name),
      error: get((formState || _formState).errors, name)
    });
    const clearErrors = (name) => {
      name ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName)) : _formState.errors = {};
      _subjects.state.next({
        errors: _formState.errors
      });
    };
    const setError = (name, error, options) => {
      const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
      set(_formState.errors, name, {
        ...error,
        ref
      });
      _subjects.state.next({
        name,
        errors: _formState.errors,
        isValid: false
      });
      options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name) ? _subjects.watch.subscribe({
      next: (info) => name(_getWatch(void 0, defaultValue), info)
    }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
      for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
        _names.mount.delete(fieldName);
        _names.array.delete(fieldName);
        if (get(_fields, fieldName)) {
          if (!options.keepValue) {
            unset(_fields, fieldName);
            unset(_formValues, fieldName);
          }
          !options.keepError && unset(_formState.errors, fieldName);
          !options.keepDirty && unset(_formState.dirtyFields, fieldName);
          !options.keepTouched && unset(_formState.touchedFields, fieldName);
          !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
      }
      _subjects.watch.next({});
      _subjects.state.next({
        ..._formState,
        ...!options.keepDirty ? {} : { isDirty: _getDirty() }
      });
      !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
      let field = get(_fields, name);
      const disabledIsDefined = isBoolean(options.disabled);
      set(_fields, name, {
        ...field || {},
        _f: {
          ...field && field._f ? field._f : { ref: { name } },
          name,
          mount: true,
          ...options
        }
      });
      _names.mount.add(name);
      field ? disabledIsDefined && set(_formValues, name, options.disabled ? void 0 : get(_formValues, name, getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
      return {
        ...disabledIsDefined ? { disabled: options.disabled } : {},
        ..._options.shouldUseNativeValidation ? {
          required: !!options.required,
          min: getRuleValue(options.min),
          max: getRuleValue(options.max),
          minLength: getRuleValue(options.minLength),
          maxLength: getRuleValue(options.maxLength),
          pattern: getRuleValue(options.pattern)
        } : {},
        name,
        onChange,
        onBlur: onChange,
        ref: (ref) => {
          if (ref) {
            register(name, options);
            field = get(_fields, name);
            const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
            const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
            const refs = field._f.refs || [];
            if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
              return;
            }
            set(_fields, name, {
              _f: {
                ...field._f,
                ...radioOrCheckbox ? {
                  refs: [
                    ...refs.filter(live),
                    fieldRef,
                    ...!!Array.isArray(get(_defaultValues, name)) ? [{}] : []
                  ],
                  ref: { type: fieldRef.type, name }
                } : { ref: fieldRef }
              }
            });
            updateValidAndValue(name, false, void 0, fieldRef);
          } else {
            field = get(_fields, name, {});
            if (field._f) {
              field._f.mount = false;
            }
            (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
          }
        }
      };
    };
    const handleSubmit = (onValid, onInvalid) => async (e2) => {
      if (e2) {
        e2.preventDefault && e2.preventDefault();
        e2.persist && e2.persist();
      }
      let hasNoPromiseError = true;
      let fieldValues = cloneObject(_formValues);
      _subjects.state.next({
        isSubmitting: true
      });
      try {
        if (_options.resolver) {
          const { errors, values } = await _executeSchema();
          _formState.errors = errors;
          fieldValues = values;
        } else {
          await executeBuiltInValidation(_fields);
        }
        if (isEmptyObject(_formState.errors)) {
          _subjects.state.next({
            errors: {},
            isSubmitting: true
          });
          await onValid(fieldValues, e2);
        } else {
          if (onInvalid) {
            await onInvalid({ ..._formState.errors }, e2);
          }
          _options.shouldFocusError && focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
        }
      } catch (err) {
        hasNoPromiseError = false;
        throw err;
      } finally {
        _formState.isSubmitted = true;
        _subjects.state.next({
          isSubmitted: true,
          isSubmitting: false,
          isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
          submitCount: _formState.submitCount + 1,
          errors: _formState.errors
        });
      }
    };
    const resetField = (name, options = {}) => {
      if (get(_fields, name)) {
        if (isUndefined(options.defaultValue)) {
          setValue(name, get(_defaultValues, name));
        } else {
          setValue(name, options.defaultValue);
          set(_defaultValues, name, options.defaultValue);
        }
        if (!options.keepTouched) {
          unset(_formState.touchedFields, name);
        }
        if (!options.keepDirty) {
          unset(_formState.dirtyFields, name);
          _formState.isDirty = options.defaultValue ? _getDirty(name, get(_defaultValues, name)) : _getDirty();
        }
        if (!options.keepError) {
          unset(_formState.errors, name);
          _proxyFormState.isValid && _updateValid();
        }
        _subjects.state.next({ ..._formState });
      }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
      const updatedValues = formValues || _defaultValues;
      const cloneUpdatedValues = cloneObject(updatedValues);
      const values = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
      if (!keepStateOptions.keepDefaultValues) {
        _defaultValues = updatedValues;
      }
      if (!keepStateOptions.keepValues) {
        if (keepStateOptions.keepDirtyValues) {
          for (const fieldName of _names.mount) {
            get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
          }
        } else {
          if (isWeb && isUndefined(formValues)) {
            for (const name of _names.mount) {
              const field = get(_fields, name);
              if (field && field._f) {
                const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                try {
                  if (isHTMLElement(fieldReference)) {
                    fieldReference.closest("form").reset();
                    break;
                  }
                } catch (_a3) {
                }
              }
            }
          }
          _fields = {};
        }
        _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneUpdatedValues;
        _subjects.array.next({
          values
        });
        _subjects.watch.next({
          values
        });
      }
      _names = {
        mount: /* @__PURE__ */ new Set(),
        unMount: /* @__PURE__ */ new Set(),
        array: /* @__PURE__ */ new Set(),
        watch: /* @__PURE__ */ new Set(),
        watchAll: false,
        focus: ""
      };
      _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
      _stateFlags.watch = !!props.shouldUnregister;
      _subjects.state.next({
        submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
        isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
        isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
        dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
        touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
        errors: keepStateOptions.keepErrors ? _formState.errors : {},
        isSubmitting: false,
        isSubmitSuccessful: false
      });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
      const field = get(_fields, name);
      const fieldReference = field && field._f;
      if (fieldReference) {
        const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    };
    return {
      control: {
        register,
        unregister,
        getFieldState,
        _executeSchema,
        _getWatch,
        _getDirty,
        _updateValid,
        _removeUnmounted,
        _updateFieldArray,
        _getFieldArray,
        _subjects,
        _proxyFormState,
        get _fields() {
          return _fields;
        },
        get _formValues() {
          return _formValues;
        },
        get _stateFlags() {
          return _stateFlags;
        },
        set _stateFlags(value) {
          _stateFlags = value;
        },
        get _defaultValues() {
          return _defaultValues;
        },
        get _names() {
          return _names;
        },
        set _names(value) {
          _names = value;
        },
        get _formState() {
          return _formState;
        },
        set _formState(value) {
          _formState = value;
        },
        get _options() {
          return _options;
        },
        set _options(value) {
          _options = {
            ..._options,
            ...value
          };
        }
      },
      trigger,
      register,
      handleSubmit,
      watch,
      setValue,
      getValues,
      reset,
      resetField,
      clearErrors,
      unregister,
      setError,
      setFocus,
      getFieldState
    };
  }
  function useForm(props = {}) {
    const _formControl = import_react4.default.useRef();
    const [formState, updateFormState] = import_react4.default.useState({
      isDirty: false,
      isValidating: false,
      dirtyFields: {},
      isSubmitted: false,
      submitCount: 0,
      touchedFields: {},
      isSubmitting: false,
      isSubmitSuccessful: false,
      isValid: false,
      errors: {}
    });
    if (_formControl.current) {
      _formControl.current.control._options = props;
    } else {
      _formControl.current = {
        ...createFormControl(props),
        formState
      };
    }
    const control = _formControl.current.control;
    const callback = import_react4.default.useCallback((value) => {
      if (shouldRenderFormState(value, control._proxyFormState, true)) {
        control._formState = {
          ...control._formState,
          ...value
        };
        updateFormState({ ...control._formState });
      }
    }, [control]);
    useSubscribe({
      subject: control._subjects.state,
      callback
    });
    import_react4.default.useEffect(() => {
      if (!control._stateFlags.mount) {
        control._proxyFormState.isValid && control._updateValid();
        control._stateFlags.mount = true;
      }
      if (control._stateFlags.watch) {
        control._stateFlags.watch = false;
        control._subjects.state.next({});
      }
      control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
  }

  // node_modules/@hookform/resolvers/dist/resolvers.mjs
  init_react_import();
  var e = function(i, e2, t2) {
    if (i && "reportValidity" in i) {
      var f2 = get(t2, e2);
      i.setCustomValidity(f2 && f2.message || ""), i.reportValidity();
    }
  };
  var t = function(r, i) {
    var t2 = function(t3) {
      var f3 = i.fields[t3];
      f3 && f3.ref && "reportValidity" in f3.ref ? e(f3.ref, t3, r) : f3.refs && f3.refs.forEach(function(i2) {
        return e(i2, t3, r);
      });
    };
    for (var f2 in i.fields)
      t2(f2);
  };
  var f = function(e2, f2) {
    f2.shouldUseNativeValidation && t(e2, f2);
    var o = {};
    for (var a in e2) {
      var n2 = get(f2.fields, a);
      set(o, a, Object.assign(e2[a], { ref: n2 && n2.ref }));
    }
    return o;
  };

  // node_modules/@hookform/resolvers/zod/dist/zod.mjs
  var n = function(e2, o) {
    for (var n2 = {}; e2.length; ) {
      var s2 = e2[0], t2 = s2.code, i = s2.message, a = s2.path.join(".");
      if (!n2[a])
        if ("unionErrors" in s2) {
          var u = s2.unionErrors[0].errors[0];
          n2[a] = { message: u.message, type: u.code };
        } else
          n2[a] = { message: i, type: t2 };
      if ("unionErrors" in s2 && s2.unionErrors.forEach(function(r) {
        return r.errors.forEach(function(r2) {
          return e2.push(r2);
        });
      }), o) {
        var c = n2[a].types, f2 = c && c[s2.code];
        n2[a] = appendErrors(a, o, n2, t2, f2 ? [].concat(f2, s2.message) : s2.message);
      }
      e2.shift();
    }
    return n2;
  };
  var s = function(r, s2, t2) {
    return void 0 === t2 && (t2 = {}), function(i, a, u) {
      try {
        return Promise.resolve(function(o, n2) {
          try {
            var a2 = Promise.resolve(r["sync" === t2.mode ? "parse" : "parseAsync"](i, s2)).then(function(r2) {
              return u.shouldUseNativeValidation && t({}, u), { errors: {}, values: t2.rawValues ? i : r2 };
            });
          } catch (r2) {
            return n2(r2);
          }
          return a2 && a2.then ? a2.then(void 0, n2) : a2;
        }(0, function(r2) {
          return { values: {}, errors: r2.isEmpty ? {} : f(n(r2.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u) };
        }));
      } catch (r2) {
        return Promise.reject(r2);
      }
    };
  };

  // src/components/preact/components/Cart/GiftForm/index.tsx
  var import_react7 = __toESM(require_react());

  // src/components/preact/components/Cart/utils.ts
  init_react_import();

  // src/core/cart/index.ts
  init_react_import();

  // src/core/cart/types.ts
  init_react_import();

  // node_modules/zod/lib/index.mjs
  init_react_import();
  var util;
  (function(util2) {
    util2.assertEqual = (val) => val;
    function assertIs(_arg) {
    }
    util2.assertIs = assertIs;
    function assertNever(_x) {
      throw new Error();
    }
    util2.assertNever = assertNever;
    util2.arrayToEnum = (items) => {
      const obj = {};
      for (const item of items) {
        obj[item] = item;
      }
      return obj;
    };
    util2.getValidEnumValues = (obj) => {
      const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
      const filtered = {};
      for (const k of validKeys) {
        filtered[k] = obj[k];
      }
      return util2.objectValues(filtered);
    };
    util2.objectValues = (obj) => {
      return util2.objectKeys(obj).map(function(e2) {
        return obj[e2];
      });
    };
    util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
      const keys = [];
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          keys.push(key);
        }
      }
      return keys;
    };
    util2.find = (arr, checker) => {
      for (const item of arr) {
        if (checker(item))
          return item;
      }
      return void 0;
    };
    util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
      return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util2.joinValues = joinValues;
    util2.jsonStringifyReplacer = (_, value) => {
      if (typeof value === "bigint") {
        return value.toString();
      }
      return value;
    };
  })(util || (util = {}));
  var ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]);
  var getParsedType = (data) => {
    const t2 = typeof data;
    switch (t2) {
      case "undefined":
        return ZodParsedType.undefined;
      case "string":
        return ZodParsedType.string;
      case "number":
        return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
      case "boolean":
        return ZodParsedType.boolean;
      case "function":
        return ZodParsedType.function;
      case "bigint":
        return ZodParsedType.bigint;
      case "symbol":
        return ZodParsedType.symbol;
      case "object":
        if (Array.isArray(data)) {
          return ZodParsedType.array;
        }
        if (data === null) {
          return ZodParsedType.null;
        }
        if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
          return ZodParsedType.promise;
        }
        if (typeof Map !== "undefined" && data instanceof Map) {
          return ZodParsedType.map;
        }
        if (typeof Set !== "undefined" && data instanceof Set) {
          return ZodParsedType.set;
        }
        if (typeof Date !== "undefined" && data instanceof Date) {
          return ZodParsedType.date;
        }
        return ZodParsedType.object;
      default:
        return ZodParsedType.unknown;
    }
  };
  var ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
  ]);
  var quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
  };
  var ZodError = class extends Error {
    constructor(issues) {
      super();
      this.issues = [];
      this.addIssue = (sub) => {
        this.issues = [...this.issues, sub];
      };
      this.addIssues = (subs = []) => {
        this.issues = [...this.issues, ...subs];
      };
      const actualProto = new.target.prototype;
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(this, actualProto);
      } else {
        this.__proto__ = actualProto;
      }
      this.name = "ZodError";
      this.issues = issues;
    }
    get errors() {
      return this.issues;
    }
    format(_mapper) {
      const mapper = _mapper || function(issue) {
        return issue.message;
      };
      const fieldErrors = { _errors: [] };
      const processError = (error) => {
        for (const issue of error.issues) {
          if (issue.code === "invalid_union") {
            issue.unionErrors.map(processError);
          } else if (issue.code === "invalid_return_type") {
            processError(issue.returnTypeError);
          } else if (issue.code === "invalid_arguments") {
            processError(issue.argumentsError);
          } else if (issue.path.length === 0) {
            fieldErrors._errors.push(mapper(issue));
          } else {
            let curr = fieldErrors;
            let i = 0;
            while (i < issue.path.length) {
              const el = issue.path[i];
              const terminal = i === issue.path.length - 1;
              if (!terminal) {
                curr[el] = curr[el] || { _errors: [] };
              } else {
                curr[el] = curr[el] || { _errors: [] };
                curr[el]._errors.push(mapper(issue));
              }
              curr = curr[el];
              i++;
            }
          }
        }
      };
      processError(this);
      return fieldErrors;
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
      const fieldErrors = {};
      const formErrors = [];
      for (const sub of this.issues) {
        if (sub.path.length > 0) {
          fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
          fieldErrors[sub.path[0]].push(mapper(sub));
        } else {
          formErrors.push(mapper(sub));
        }
      }
      return { formErrors, fieldErrors };
    }
    get formErrors() {
      return this.flatten();
    }
  };
  ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
  };
  var errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
      case ZodIssueCode.invalid_type:
        if (issue.received === ZodParsedType.undefined) {
          message = "Required";
        } else {
          message = `Expected ${issue.expected}, received ${issue.received}`;
        }
        break;
      case ZodIssueCode.invalid_literal:
        message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
        break;
      case ZodIssueCode.unrecognized_keys:
        message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
        break;
      case ZodIssueCode.invalid_union:
        message = `Invalid input`;
        break;
      case ZodIssueCode.invalid_union_discriminator:
        message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
        break;
      case ZodIssueCode.invalid_enum_value:
        message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
        break;
      case ZodIssueCode.invalid_arguments:
        message = `Invalid function arguments`;
        break;
      case ZodIssueCode.invalid_return_type:
        message = `Invalid function return type`;
        break;
      case ZodIssueCode.invalid_date:
        message = `Invalid date`;
        break;
      case ZodIssueCode.invalid_string:
        if (typeof issue.validation === "object") {
          if ("startsWith" in issue.validation) {
            message = `Invalid input: must start with "${issue.validation.startsWith}"`;
          } else if ("endsWith" in issue.validation) {
            message = `Invalid input: must end with "${issue.validation.endsWith}"`;
          } else {
            util.assertNever(issue.validation);
          }
        } else if (issue.validation !== "regex") {
          message = `Invalid ${issue.validation}`;
        } else {
          message = "Invalid";
        }
        break;
      case ZodIssueCode.too_small:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(issue.minimum)}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode.too_big:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(issue.maximum)}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode.custom:
        message = `Invalid input`;
        break;
      case ZodIssueCode.invalid_intersection_types:
        message = `Intersection results could not be merged`;
        break;
      case ZodIssueCode.not_multiple_of:
        message = `Number must be a multiple of ${issue.multipleOf}`;
        break;
      case ZodIssueCode.not_finite:
        message = "Number must be finite";
        break;
      default:
        message = _ctx.defaultError;
        util.assertNever(issue);
    }
    return { message };
  };
  var overrideErrorMap = errorMap;
  function setErrorMap(map) {
    overrideErrorMap = map;
  }
  function getErrorMap() {
    return overrideErrorMap;
  }
  var makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...issueData.path || []];
    const fullIssue = {
      ...issueData,
      path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m) => !!m).slice().reverse();
    for (const map of maps) {
      errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message || errorMessage
    };
  };
  var EMPTY_PATH = [];
  function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
      issueData,
      data: ctx.data,
      path: ctx.path,
      errorMaps: [
        ctx.common.contextualErrorMap,
        ctx.schemaErrorMap,
        getErrorMap(),
        errorMap
      ].filter((x) => !!x)
    });
    ctx.common.issues.push(issue);
  }
  var ParseStatus = class {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      if (this.value === "valid")
        this.value = "dirty";
    }
    abort() {
      if (this.value !== "aborted")
        this.value = "aborted";
    }
    static mergeArray(status, results) {
      const arrayValue = [];
      for (const s2 of results) {
        if (s2.status === "aborted")
          return INVALID;
        if (s2.status === "dirty")
          status.dirty();
        arrayValue.push(s2.value);
      }
      return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
      const syncPairs = [];
      for (const pair of pairs) {
        syncPairs.push({
          key: await pair.key,
          value: await pair.value
        });
      }
      return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
      const finalObject = {};
      for (const pair of pairs) {
        const { key, value } = pair;
        if (key.status === "aborted")
          return INVALID;
        if (value.status === "aborted")
          return INVALID;
        if (key.status === "dirty")
          status.dirty();
        if (value.status === "dirty")
          status.dirty();
        if (typeof value.value !== "undefined" || pair.alwaysSet) {
          finalObject[key.value] = value.value;
        }
      }
      return { status: status.value, value: finalObject };
    }
  };
  var INVALID = Object.freeze({
    status: "aborted"
  });
  var DIRTY = (value) => ({ status: "dirty", value });
  var OK = (value) => ({ status: "valid", value });
  var isAborted = (x) => x.status === "aborted";
  var isDirty = (x) => x.status === "dirty";
  var isValid = (x) => x.status === "valid";
  var isAsync = (x) => typeof Promise !== void 0 && x instanceof Promise;
  var errorUtil;
  (function(errorUtil2) {
    errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
  })(errorUtil || (errorUtil = {}));
  var ParseInputLazyPath = class {
    constructor(parent, value, path, key) {
      this.parent = parent;
      this.data = value;
      this._path = path;
      this._key = key;
    }
    get path() {
      return this._path.concat(this._key);
    }
  };
  var handleResult = (ctx, result) => {
    if (isValid(result)) {
      return { success: true, data: result.value };
    } else {
      if (!ctx.common.issues.length) {
        throw new Error("Validation failed but no issues detected.");
      }
      const error = new ZodError(ctx.common.issues);
      return { success: false, error };
    }
  };
  function processCreateParams(params) {
    if (!params)
      return {};
    const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
    if (errorMap2 && (invalid_type_error || required_error)) {
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap2)
      return { errorMap: errorMap2, description };
    const customMap = (iss, ctx) => {
      if (iss.code !== "invalid_type")
        return { message: ctx.defaultError };
      if (typeof ctx.data === "undefined") {
        return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
      }
      return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
  }
  var ZodType = class {
    constructor(def) {
      this.spa = this.safeParseAsync;
      this._def = def;
      this.parse = this.parse.bind(this);
      this.safeParse = this.safeParse.bind(this);
      this.parseAsync = this.parseAsync.bind(this);
      this.safeParseAsync = this.safeParseAsync.bind(this);
      this.spa = this.spa.bind(this);
      this.refine = this.refine.bind(this);
      this.refinement = this.refinement.bind(this);
      this.superRefine = this.superRefine.bind(this);
      this.optional = this.optional.bind(this);
      this.nullable = this.nullable.bind(this);
      this.nullish = this.nullish.bind(this);
      this.array = this.array.bind(this);
      this.promise = this.promise.bind(this);
      this.or = this.or.bind(this);
      this.and = this.and.bind(this);
      this.transform = this.transform.bind(this);
      this.brand = this.brand.bind(this);
      this.default = this.default.bind(this);
      this.catch = this.catch.bind(this);
      this.describe = this.describe.bind(this);
      this.pipe = this.pipe.bind(this);
      this.isNullable = this.isNullable.bind(this);
      this.isOptional = this.isOptional.bind(this);
    }
    get description() {
      return this._def.description;
    }
    _getType(input) {
      return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
    _processInputParams(input) {
      return {
        status: new ParseStatus(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
    _parseSync(input) {
      const result = this._parse(input);
      if (isAsync(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }
      return result;
    }
    _parseAsync(input) {
      const result = this._parse(input);
      return Promise.resolve(result);
    }
    parse(data, params) {
      const result = this.safeParse(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    safeParse(data, params) {
      var _a3;
      const ctx = {
        common: {
          issues: [],
          async: (_a3 = params === null || params === void 0 ? void 0 : params.async) !== null && _a3 !== void 0 ? _a3 : false,
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const result = this._parseSync({ data, path: ctx.path, parent: ctx });
      return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
      const result = await this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    async safeParseAsync(data, params) {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
          async: true
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
      return handleResult(ctx, result);
    }
    refine(check, message) {
      const getIssueProperties = (val) => {
        if (typeof message === "string" || typeof message === "undefined") {
          return { message };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };
      return this._refinement((val, ctx) => {
        const result = check(val);
        const setError = () => ctx.addIssue({
          code: ZodIssueCode.custom,
          ...getIssueProperties(val)
        });
        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then((data) => {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }
        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
    refinement(check, refinementData) {
      return this._refinement((val, ctx) => {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
    _refinement(refinement) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: { type: "refinement", refinement }
      });
    }
    superRefine(refinement) {
      return this._refinement(refinement);
    }
    optional() {
      return ZodOptional.create(this);
    }
    nullable() {
      return ZodNullable.create(this);
    }
    nullish() {
      return this.optional().nullable();
    }
    array() {
      return ZodArray.create(this);
    }
    promise() {
      return ZodPromise.create(this);
    }
    or(option) {
      return ZodUnion.create([this, option]);
    }
    and(incoming) {
      return ZodIntersection.create(this, incoming);
    }
    transform(transform) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: { type: "transform", transform }
      });
    }
    default(def) {
      const defaultValueFunc = typeof def === "function" ? def : () => def;
      return new ZodDefault({
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodDefault
      });
    }
    brand() {
      return new ZodBranded({
        typeName: ZodFirstPartyTypeKind.ZodBranded,
        type: this,
        ...processCreateParams(void 0)
      });
    }
    catch(def) {
      const defaultValueFunc = typeof def === "function" ? def : () => def;
      return new ZodCatch({
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodCatch
      });
    }
    describe(description) {
      const This = this.constructor;
      return new This({
        ...this._def,
        description
      });
    }
    pipe(target) {
      return ZodPipeline.create(this, target);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  };
  var cuidRegex = /^c[^\s-]{8,}$/i;
  var uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
  var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  var datetimeRegex = (args) => {
    if (args.precision) {
      if (args.offset) {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}:\\d{2})|Z)$`);
      } else {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
      }
    } else if (args.precision === 0) {
      if (args.offset) {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}:\\d{2})|Z)$`);
      } else {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
      }
    } else {
      if (args.offset) {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}:\\d{2})|Z)$`);
      } else {
        return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
      }
    }
  };
  var ZodString = class extends ZodType {
    constructor() {
      super(...arguments);
      this._regex = (regex, validation, message) => this.refinement((data) => regex.test(data), {
        validation,
        code: ZodIssueCode.invalid_string,
        ...errorUtil.errToObj(message)
      });
      this.nonempty = (message) => this.min(1, errorUtil.errToObj(message));
      this.trim = () => new ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      });
    }
    _parse(input) {
      if (this._def.coerce) {
        input.data = String(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.string) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(
          ctx2,
          {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.string,
            received: ctx2.parsedType
          }
        );
        return INVALID;
      }
      const status = new ParseStatus();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.length < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.length > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "length") {
          const tooBig = input.data.length > check.value;
          const tooSmall = input.data.length < check.value;
          if (tooBig || tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            if (tooBig) {
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            } else if (tooSmall) {
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            }
            status.dirty();
          }
        } else if (check.kind === "email") {
          if (!emailRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "email",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "uuid") {
          if (!uuidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "uuid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cuid") {
          if (!cuidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "cuid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "url") {
          try {
            new URL(input.data);
          } catch (_a3) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "url",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "regex") {
          check.regex.lastIndex = 0;
          const testResult = check.regex.test(input.data);
          if (!testResult) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "regex",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "trim") {
          input.data = input.data.trim();
        } else if (check.kind === "startsWith") {
          if (!input.data.startsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: { startsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "endsWith") {
          if (!input.data.endsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: { endsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "datetime") {
          const regex = datetimeRegex(check);
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: "datetime",
              message: check.message
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    _addCheck(check) {
      return new ZodString({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    email(message) {
      return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
      return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
      return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
      return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    datetime(options) {
      var _a3;
      if (typeof options === "string") {
        return this._addCheck({
          kind: "datetime",
          precision: null,
          offset: false,
          message: options
        });
      }
      return this._addCheck({
        kind: "datetime",
        precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
        offset: (_a3 = options === null || options === void 0 ? void 0 : options.offset) !== null && _a3 !== void 0 ? _a3 : false,
        ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
      });
    }
    regex(regex, message) {
      return this._addCheck({
        kind: "regex",
        regex,
        ...errorUtil.errToObj(message)
      });
    }
    startsWith(value, message) {
      return this._addCheck({
        kind: "startsWith",
        value,
        ...errorUtil.errToObj(message)
      });
    }
    endsWith(value, message) {
      return this._addCheck({
        kind: "endsWith",
        value,
        ...errorUtil.errToObj(message)
      });
    }
    min(minLength, message) {
      return this._addCheck({
        kind: "min",
        value: minLength,
        ...errorUtil.errToObj(message)
      });
    }
    max(maxLength, message) {
      return this._addCheck({
        kind: "max",
        value: maxLength,
        ...errorUtil.errToObj(message)
      });
    }
    length(len, message) {
      return this._addCheck({
        kind: "length",
        value: len,
        ...errorUtil.errToObj(message)
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
      return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isUUID() {
      return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
      return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get minLength() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxLength() {
      let max = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max === null || ch.value < max)
            max = ch.value;
        }
      }
      return max;
    }
  };
  ZodString.create = (params) => {
    var _a3;
    return new ZodString({
      checks: [],
      typeName: ZodFirstPartyTypeKind.ZodString,
      coerce: (_a3 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a3 !== void 0 ? _a3 : false,
      ...processCreateParams(params)
    });
  };
  function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
  }
  var ZodNumber = class extends ZodType {
    constructor() {
      super(...arguments);
      this.min = this.gte;
      this.max = this.lte;
      this.step = this.multipleOf;
    }
    _parse(input) {
      if (this._def.coerce) {
        input.data = Number(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.number) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.number,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      let ctx = void 0;
      const status = new ParseStatus();
      for (const check of this._def.checks) {
        if (check.kind === "int") {
          if (!util.isInteger(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_type,
              expected: "integer",
              received: "float",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "min") {
          const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
          if (tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
          if (tooBig) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "multipleOf") {
          if (floatSafeRemainder(input.data, check.value) !== 0) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.not_multiple_of,
              multipleOf: check.value,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "finite") {
          if (!Number.isFinite(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.not_finite,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
      return new ZodNumber({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind,
            value,
            inclusive,
            message: errorUtil.toString(message)
          }
        ]
      });
    }
    _addCheck(check) {
      return new ZodNumber({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil.toString(message)
      });
    }
    positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value,
        message: errorUtil.toString(message)
      });
    }
    finite(message) {
      return this._addCheck({
        kind: "finite",
        message: errorUtil.toString(message)
      });
    }
    get minValue() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxValue() {
      let max = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max === null || ch.value < max)
            max = ch.value;
        }
      }
      return max;
    }
    get isInt() {
      return !!this._def.checks.find((ch) => ch.kind === "int");
    }
  };
  ZodNumber.create = (params) => {
    return new ZodNumber({
      checks: [],
      typeName: ZodFirstPartyTypeKind.ZodNumber,
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      ...processCreateParams(params)
    });
  };
  var ZodBigInt = class extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = BigInt(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.bigint) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.bigint,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodBigInt.create = (params) => {
    var _a3;
    return new ZodBigInt({
      typeName: ZodFirstPartyTypeKind.ZodBigInt,
      coerce: (_a3 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a3 !== void 0 ? _a3 : false,
      ...processCreateParams(params)
    });
  };
  var ZodBoolean = class extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = Boolean(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.boolean) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.boolean,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodBoolean.create = (params) => {
    return new ZodBoolean({
      typeName: ZodFirstPartyTypeKind.ZodBoolean,
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      ...processCreateParams(params)
    });
  };
  var ZodDate = class extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = new Date(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.date) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.date,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      if (isNaN(input.data.getTime())) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_date
        });
        return INVALID;
      }
      const status = new ParseStatus();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.getTime() < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              message: check.message,
              inclusive: true,
              exact: false,
              minimum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.getTime() > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              message: check.message,
              inclusive: true,
              exact: false,
              maximum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return {
        status: status.value,
        value: new Date(input.data.getTime())
      };
    }
    _addCheck(check) {
      return new ZodDate({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    min(minDate, message) {
      return this._addCheck({
        kind: "min",
        value: minDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
    max(maxDate, message) {
      return this._addCheck({
        kind: "max",
        value: maxDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
    get minDate() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min != null ? new Date(min) : null;
    }
    get maxDate() {
      let max = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max === null || ch.value < max)
            max = ch.value;
        }
      }
      return max != null ? new Date(max) : null;
    }
  };
  ZodDate.create = (params) => {
    return new ZodDate({
      checks: [],
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      typeName: ZodFirstPartyTypeKind.ZodDate,
      ...processCreateParams(params)
    });
  };
  var ZodSymbol = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.symbol) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.symbol,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodSymbol.create = (params) => {
    return new ZodSymbol({
      typeName: ZodFirstPartyTypeKind.ZodSymbol,
      ...processCreateParams(params)
    });
  };
  var ZodUndefined = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.undefined,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodUndefined.create = (params) => {
    return new ZodUndefined({
      typeName: ZodFirstPartyTypeKind.ZodUndefined,
      ...processCreateParams(params)
    });
  };
  var ZodNull = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.null) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.null,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodNull.create = (params) => {
    return new ZodNull({
      typeName: ZodFirstPartyTypeKind.ZodNull,
      ...processCreateParams(params)
    });
  };
  var ZodAny = class extends ZodType {
    constructor() {
      super(...arguments);
      this._any = true;
    }
    _parse(input) {
      return OK(input.data);
    }
  };
  ZodAny.create = (params) => {
    return new ZodAny({
      typeName: ZodFirstPartyTypeKind.ZodAny,
      ...processCreateParams(params)
    });
  };
  var ZodUnknown = class extends ZodType {
    constructor() {
      super(...arguments);
      this._unknown = true;
    }
    _parse(input) {
      return OK(input.data);
    }
  };
  ZodUnknown.create = (params) => {
    return new ZodUnknown({
      typeName: ZodFirstPartyTypeKind.ZodUnknown,
      ...processCreateParams(params)
    });
  };
  var ZodNever = class extends ZodType {
    _parse(input) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.never,
        received: ctx.parsedType
      });
      return INVALID;
    }
  };
  ZodNever.create = (params) => {
    return new ZodNever({
      typeName: ZodFirstPartyTypeKind.ZodNever,
      ...processCreateParams(params)
    });
  };
  var ZodVoid = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.void,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodVoid.create = (params) => {
    return new ZodVoid({
      typeName: ZodFirstPartyTypeKind.ZodVoid,
      ...processCreateParams(params)
    });
  };
  var ZodArray = class extends ZodType {
    _parse(input) {
      const { ctx, status } = this._processInputParams(input);
      const def = this._def;
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (def.exactLength !== null) {
        const tooBig = ctx.data.length > def.exactLength.value;
        const tooSmall = ctx.data.length < def.exactLength.value;
        if (tooBig || tooSmall) {
          addIssueToContext(ctx, {
            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
            minimum: tooSmall ? def.exactLength.value : void 0,
            maximum: tooBig ? def.exactLength.value : void 0,
            type: "array",
            inclusive: true,
            exact: true,
            message: def.exactLength.message
          });
          status.dirty();
        }
      }
      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.minLength.message
          });
          status.dirty();
        }
      }
      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }
      if (ctx.common.async) {
        return Promise.all(ctx.data.map((item, i) => {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result2) => {
          return ParseStatus.mergeArray(status, result2);
        });
      }
      const result = ctx.data.map((item, i) => {
        return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });
      return ParseStatus.mergeArray(status, result);
    }
    get element() {
      return this._def.type;
    }
    min(minLength, message) {
      return new ZodArray({
        ...this._def,
        minLength: { value: minLength, message: errorUtil.toString(message) }
      });
    }
    max(maxLength, message) {
      return new ZodArray({
        ...this._def,
        maxLength: { value: maxLength, message: errorUtil.toString(message) }
      });
    }
    length(len, message) {
      return new ZodArray({
        ...this._def,
        exactLength: { value: len, message: errorUtil.toString(message) }
      });
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodArray.create = (schema, params) => {
    return new ZodArray({
      type: schema,
      minLength: null,
      maxLength: null,
      exactLength: null,
      typeName: ZodFirstPartyTypeKind.ZodArray,
      ...processCreateParams(params)
    });
  };
  var objectUtil;
  (function(objectUtil2) {
    objectUtil2.mergeShapes = (first, second) => {
      return {
        ...first,
        ...second
      };
    };
  })(objectUtil || (objectUtil = {}));
  var AugmentFactory = (def) => (augmentation) => {
    return new ZodObject({
      ...def,
      shape: () => ({
        ...def.shape(),
        ...augmentation
      })
    });
  };
  function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
      const newShape = {};
      for (const key in schema.shape) {
        const fieldSchema = schema.shape[key];
        newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
      }
      return new ZodObject({
        ...schema._def,
        shape: () => newShape
      });
    } else if (schema instanceof ZodArray) {
      return ZodArray.create(deepPartialify(schema.element));
    } else if (schema instanceof ZodOptional) {
      return ZodOptional.create(deepPartialify(schema.unwrap()));
    } else if (schema instanceof ZodNullable) {
      return ZodNullable.create(deepPartialify(schema.unwrap()));
    } else if (schema instanceof ZodTuple) {
      return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    } else {
      return schema;
    }
  }
  var ZodObject = class extends ZodType {
    constructor() {
      super(...arguments);
      this._cached = null;
      this.nonstrict = this.passthrough;
      this.augment = AugmentFactory(this._def);
      this.extend = AugmentFactory(this._def);
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const shape = this._def.shape();
      const keys = util.objectKeys(shape);
      return this._cached = { shape, keys };
    }
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.object) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      const { status, ctx } = this._processInputParams(input);
      const { shape, keys: shapeKeys } = this._getCached();
      const extraKeys = [];
      if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
        for (const key in ctx.data) {
          if (!shapeKeys.includes(key)) {
            extraKeys.push(key);
          }
        }
      }
      const pairs = [];
      for (const key of shapeKeys) {
        const keyValidator = shape[key];
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
      if (this._def.catchall instanceof ZodNever) {
        const unknownKeys = this._def.unknownKeys;
        if (unknownKeys === "passthrough") {
          for (const key of extraKeys) {
            pairs.push({
              key: { status: "valid", value: key },
              value: { status: "valid", value: ctx.data[key] }
            });
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip")
          ;
        else {
          throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        }
      } else {
        const catchall = this._def.catchall;
        for (const key of extraKeys) {
          const value = ctx.data[key];
          pairs.push({
            key: { status: "valid", value: key },
            value: catchall._parse(
              new ParseInputLazyPath(ctx, value, ctx.path, key)
            ),
            alwaysSet: key in ctx.data
          });
        }
      }
      if (ctx.common.async) {
        return Promise.resolve().then(async () => {
          const syncPairs = [];
          for (const pair of pairs) {
            const key = await pair.key;
            syncPairs.push({
              key,
              value: await pair.value,
              alwaysSet: pair.alwaysSet
            });
          }
          return syncPairs;
        }).then((syncPairs) => {
          return ParseStatus.mergeObjectSync(status, syncPairs);
        });
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
    get shape() {
      return this._def.shape();
    }
    strict(message) {
      errorUtil.errToObj;
      return new ZodObject({
        ...this._def,
        unknownKeys: "strict",
        ...message !== void 0 ? {
          errorMap: (issue, ctx) => {
            var _a3, _b2, _c2, _d;
            const defaultError = (_c2 = (_b2 = (_a3 = this._def).errorMap) === null || _b2 === void 0 ? void 0 : _b2.call(_a3, issue, ctx).message) !== null && _c2 !== void 0 ? _c2 : ctx.defaultError;
            if (issue.code === "unrecognized_keys")
              return {
                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
              };
            return {
              message: defaultError
            };
          }
        } : {}
      });
    }
    strip() {
      return new ZodObject({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new ZodObject({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    setKey(key, schema) {
      return this.augment({ [key]: schema });
    }
    merge(merging) {
      const merged = new ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: () => objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
        typeName: ZodFirstPartyTypeKind.ZodObject
      });
      return merged;
    }
    catchall(index) {
      return new ZodObject({
        ...this._def,
        catchall: index
      });
    }
    pick(mask) {
      const shape = {};
      util.objectKeys(mask).map((key) => {
        if (this.shape[key])
          shape[key] = this.shape[key];
      });
      return new ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    omit(mask) {
      const shape = {};
      util.objectKeys(this.shape).map((key) => {
        if (util.objectKeys(mask).indexOf(key) === -1) {
          shape[key] = this.shape[key];
        }
      });
      return new ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    deepPartial() {
      return deepPartialify(this);
    }
    partial(mask) {
      const newShape = {};
      if (mask) {
        util.objectKeys(this.shape).map((key) => {
          if (util.objectKeys(mask).indexOf(key) === -1) {
            newShape[key] = this.shape[key];
          } else {
            newShape[key] = this.shape[key].optional();
          }
        });
        return new ZodObject({
          ...this._def,
          shape: () => newShape
        });
      } else {
        for (const key in this.shape) {
          const fieldSchema = this.shape[key];
          newShape[key] = fieldSchema.optional();
        }
      }
      return new ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    required(mask) {
      const newShape = {};
      if (mask) {
        util.objectKeys(this.shape).map((key) => {
          if (util.objectKeys(mask).indexOf(key) === -1) {
            newShape[key] = this.shape[key];
          } else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while (newField instanceof ZodOptional) {
              newField = newField._def.innerType;
            }
            newShape[key] = newField;
          }
        });
      } else {
        for (const key in this.shape) {
          const fieldSchema = this.shape[key];
          let newField = fieldSchema;
          while (newField instanceof ZodOptional) {
            newField = newField._def.innerType;
          }
          newShape[key] = newField;
        }
      }
      return new ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    keyof() {
      return createZodEnum(util.objectKeys(this.shape));
    }
  };
  ZodObject.create = (shape, params) => {
    return new ZodObject({
      shape: () => shape,
      unknownKeys: "strip",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
      shape: () => shape,
      unknownKeys: "strict",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
      shape,
      unknownKeys: "strip",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  var ZodUnion = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const options = this._def.options;
      function handleResults(results) {
        for (const result of results) {
          if (result.result.status === "valid") {
            return result.result;
          }
        }
        for (const result of results) {
          if (result.result.status === "dirty") {
            ctx.common.issues.push(...result.ctx.common.issues);
            return result.result;
          }
        }
        const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return Promise.all(options.map(async (option) => {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await option._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            }),
            ctx: childCtx
          };
        })).then(handleResults);
      } else {
        let dirty = void 0;
        const issues = [];
        for (const option of options) {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          const result = option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          });
          if (result.status === "valid") {
            return result;
          } else if (result.status === "dirty" && !dirty) {
            dirty = { result, ctx: childCtx };
          }
          if (childCtx.common.issues.length) {
            issues.push(childCtx.common.issues);
          }
        }
        if (dirty) {
          ctx.common.issues.push(...dirty.ctx.common.issues);
          return dirty.result;
        }
        const unionErrors = issues.map((issues2) => new ZodError(issues2));
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors
        });
        return INVALID;
      }
    }
    get options() {
      return this._def.options;
    }
  };
  ZodUnion.create = (types, params) => {
    return new ZodUnion({
      options: types,
      typeName: ZodFirstPartyTypeKind.ZodUnion,
      ...processCreateParams(params)
    });
  };
  var getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
      return getDiscriminator(type.schema);
    } else if (type instanceof ZodEffects) {
      return getDiscriminator(type.innerType());
    } else if (type instanceof ZodLiteral) {
      return [type.value];
    } else if (type instanceof ZodEnum) {
      return type.options;
    } else if (type instanceof ZodNativeEnum) {
      return Object.keys(type.enum);
    } else if (type instanceof ZodDefault) {
      return getDiscriminator(type._def.innerType);
    } else if (type instanceof ZodUndefined) {
      return [void 0];
    } else if (type instanceof ZodNull) {
      return [null];
    } else {
      return null;
    }
  };
  var ZodDiscriminatedUnion = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const discriminator = this.discriminator;
      const discriminatorValue = ctx.data[discriminator];
      const option = this.optionsMap.get(discriminatorValue);
      if (!option) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union_discriminator,
          options: Array.from(this.optionsMap.keys()),
          path: [discriminator]
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    static create(discriminator, options, params) {
      const optionsMap = /* @__PURE__ */ new Map();
      for (const type of options) {
        const discriminatorValues = getDiscriminator(type.shape[discriminator]);
        if (!discriminatorValues) {
          throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
        }
        for (const value of discriminatorValues) {
          if (optionsMap.has(value)) {
            throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
          }
          optionsMap.set(value, type);
        }
      }
      return new ZodDiscriminatedUnion({
        typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
        discriminator,
        options,
        optionsMap,
        ...processCreateParams(params)
      });
    }
  };
  function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
      return { valid: true, data: a };
    } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
      const bKeys = util.objectKeys(b);
      const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
      const newObj = { ...a, ...b };
      for (const key of sharedKeys) {
        const sharedValue = mergeValues(a[key], b[key]);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newObj[key] = sharedValue.data;
      }
      return { valid: true, data: newObj };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
      if (a.length !== b.length) {
        return { valid: false };
      }
      const newArray = [];
      for (let index = 0; index < a.length; index++) {
        const itemA = a[index];
        const itemB = b[index];
        const sharedValue = mergeValues(itemA, itemB);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newArray.push(sharedValue.data);
      }
      return { valid: true, data: newArray };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
      return { valid: true, data: a };
    } else {
      return { valid: false };
    }
  }
  var ZodIntersection = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const handleParsed = (parsedLeft, parsedRight) => {
        if (isAborted(parsedLeft) || isAborted(parsedRight)) {
          return INVALID;
        }
        const merged = mergeValues(parsedLeft.value, parsedRight.value);
        if (!merged.valid) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_intersection_types
          });
          return INVALID;
        }
        if (isDirty(parsedLeft) || isDirty(parsedRight)) {
          status.dirty();
        }
        return { status: status.value, value: merged.data };
      };
      if (ctx.common.async) {
        return Promise.all([
          this._def.left._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }),
          this._def.right._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          })
        ]).then(([left, right]) => handleParsed(left, right));
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  };
  ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
      left,
      right,
      typeName: ZodFirstPartyTypeKind.ZodIntersection,
      ...processCreateParams(params)
    });
  };
  var ZodTuple = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (ctx.data.length < this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        return INVALID;
      }
      const rest = this._def.rest;
      if (!rest && ctx.data.length > this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        status.dirty();
      }
      const items = ctx.data.map((item, itemIndex) => {
        const schema = this._def.items[itemIndex] || this._def.rest;
        if (!schema)
          return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      }).filter((x) => !!x);
      if (ctx.common.async) {
        return Promise.all(items).then((results) => {
          return ParseStatus.mergeArray(status, results);
        });
      } else {
        return ParseStatus.mergeArray(status, items);
      }
    }
    get items() {
      return this._def.items;
    }
    rest(rest) {
      return new ZodTuple({
        ...this._def,
        rest
      });
    }
  };
  ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
      items: schemas,
      typeName: ZodFirstPartyTypeKind.ZodTuple,
      rest: null,
      ...processCreateParams(params)
    });
  };
  var ZodRecord = class extends ZodType {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const pairs = [];
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      for (const key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
      }
      if (ctx.common.async) {
        return ParseStatus.mergeObjectAsync(status, pairs);
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
    get element() {
      return this._def.valueType;
    }
    static create(first, second, third) {
      if (second instanceof ZodType) {
        return new ZodRecord({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind.ZodRecord,
          ...processCreateParams(third)
        });
      }
      return new ZodRecord({
        keyType: ZodString.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(second)
      });
    }
  };
  var ZodMap = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.map) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.map,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      const pairs = [...ctx.data.entries()].map(([key, value], index) => {
        return {
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
          value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
        };
      });
      if (ctx.common.async) {
        const finalMap = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID;
            }
            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }
            finalMap.set(key.value, value.value);
          }
          return { status: status.value, value: finalMap };
        });
      } else {
        const finalMap = /* @__PURE__ */ new Map();
        for (const pair of pairs) {
          const key = pair.key;
          const value = pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }
    }
  };
  ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
      valueType,
      keyType,
      typeName: ZodFirstPartyTypeKind.ZodMap,
      ...processCreateParams(params)
    });
  };
  var ZodSet = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.set) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.set,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const def = this._def;
      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.minSize.message
          });
          status.dirty();
        }
      }
      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }
      const valueType = this._def.valueType;
      function finalizeSet(elements2) {
        const parsedSet = /* @__PURE__ */ new Set();
        for (const element of elements2) {
          if (element.status === "aborted")
            return INVALID;
          if (element.status === "dirty")
            status.dirty();
          parsedSet.add(element.value);
        }
        return { status: status.value, value: parsedSet };
      }
      const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
      if (ctx.common.async) {
        return Promise.all(elements).then((elements2) => finalizeSet(elements2));
      } else {
        return finalizeSet(elements);
      }
    }
    min(minSize, message) {
      return new ZodSet({
        ...this._def,
        minSize: { value: minSize, message: errorUtil.toString(message) }
      });
    }
    max(maxSize, message) {
      return new ZodSet({
        ...this._def,
        maxSize: { value: maxSize, message: errorUtil.toString(message) }
      });
    }
    size(size, message) {
      return this.min(size, message).max(size, message);
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodSet.create = (valueType, params) => {
    return new ZodSet({
      valueType,
      minSize: null,
      maxSize: null,
      typeName: ZodFirstPartyTypeKind.ZodSet,
      ...processCreateParams(params)
    });
  };
  var ZodFunction = class extends ZodType {
    constructor() {
      super(...arguments);
      this.validate = this.implement;
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.function) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.function,
          received: ctx.parsedType
        });
        return INVALID;
      }
      function makeArgsIssue(args, error) {
        return makeIssue({
          data: args,
          path: ctx.path,
          errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
          ].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode.invalid_arguments,
            argumentsError: error
          }
        });
      }
      function makeReturnsIssue(returns, error) {
        return makeIssue({
          data: returns,
          path: ctx.path,
          errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
          ].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode.invalid_return_type,
            returnTypeError: error
          }
        });
      }
      const params = { errorMap: ctx.common.contextualErrorMap };
      const fn = ctx.data;
      if (this._def.returns instanceof ZodPromise) {
        return OK(async (...args) => {
          const error = new ZodError([]);
          const parsedArgs = await this._def.args.parseAsync(args, params).catch((e2) => {
            error.addIssue(makeArgsIssue(args, e2));
            throw error;
          });
          const result = await fn(...parsedArgs);
          const parsedReturns = await this._def.returns._def.type.parseAsync(result, params).catch((e2) => {
            error.addIssue(makeReturnsIssue(result, e2));
            throw error;
          });
          return parsedReturns;
        });
      } else {
        return OK((...args) => {
          const parsedArgs = this._def.args.safeParse(args, params);
          if (!parsedArgs.success) {
            throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
          }
          const result = fn(...parsedArgs.data);
          const parsedReturns = this._def.returns.safeParse(result, params);
          if (!parsedReturns.success) {
            throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
          }
          return parsedReturns.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...items) {
      return new ZodFunction({
        ...this._def,
        args: ZodTuple.create(items).rest(ZodUnknown.create())
      });
    }
    returns(returnType) {
      return new ZodFunction({
        ...this._def,
        returns: returnType
      });
    }
    implement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    strictImplement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    static create(args, returns, params) {
      return new ZodFunction({
        args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
        returns: returns || ZodUnknown.create(),
        typeName: ZodFirstPartyTypeKind.ZodFunction,
        ...processCreateParams(params)
      });
    }
  };
  var ZodLazy = class extends ZodType {
    get schema() {
      return this._def.getter();
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const lazySchema = this._def.getter();
      return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
  };
  ZodLazy.create = (getter, params) => {
    return new ZodLazy({
      getter,
      typeName: ZodFirstPartyTypeKind.ZodLazy,
      ...processCreateParams(params)
    });
  };
  var ZodLiteral = class extends ZodType {
    _parse(input) {
      if (input.data !== this._def.value) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_literal,
          expected: this._def.value
        });
        return INVALID;
      }
      return { status: "valid", value: input.data };
    }
    get value() {
      return this._def.value;
    }
  };
  ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
      value,
      typeName: ZodFirstPartyTypeKind.ZodLiteral,
      ...processCreateParams(params)
    });
  };
  function createZodEnum(values, params) {
    return new ZodEnum({
      values,
      typeName: ZodFirstPartyTypeKind.ZodEnum,
      ...processCreateParams(params)
    });
  }
  var ZodEnum = class extends ZodType {
    _parse(input) {
      if (typeof input.data !== "string") {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (this._def.values.indexOf(input.data) === -1) {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: expectedValues
        });
        return INVALID;
      }
      return OK(input.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Values() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
  };
  ZodEnum.create = createZodEnum;
  var ZodNativeEnum = class extends ZodType {
    _parse(input) {
      const nativeEnumValues = util.getValidEnumValues(this._def.values);
      const ctx = this._getOrReturnCtx(input);
      if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
        const expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (nativeEnumValues.indexOf(input.data) === -1) {
        const expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: expectedValues
        });
        return INVALID;
      }
      return OK(input.data);
    }
    get enum() {
      return this._def.values;
    }
  };
  ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
      values,
      typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
      ...processCreateParams(params)
    });
  };
  var ZodPromise = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.promise,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
      return OK(promisified.then((data) => {
        return this._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  };
  ZodPromise.create = (schema, params) => {
    return new ZodPromise({
      type: schema,
      typeName: ZodFirstPartyTypeKind.ZodPromise,
      ...processCreateParams(params)
    });
  };
  var ZodEffects = class extends ZodType {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const effect = this._def.effect || null;
      if (effect.type === "preprocess") {
        const processed = effect.transform(ctx.data);
        if (ctx.common.async) {
          return Promise.resolve(processed).then((processed2) => {
            return this._def.schema._parseAsync({
              data: processed2,
              path: ctx.path,
              parent: ctx
            });
          });
        } else {
          return this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });
        }
      }
      const checkCtx = {
        addIssue: (arg) => {
          addIssueToContext(ctx, arg);
          if (arg.fatal) {
            status.abort();
          } else {
            status.dirty();
          }
        },
        get path() {
          return ctx.path;
        }
      };
      checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
      if (effect.type === "refinement") {
        const executeRefinement = (acc) => {
          const result = effect.refinement(acc, checkCtx);
          if (ctx.common.async) {
            return Promise.resolve(result);
          }
          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }
          return acc;
        };
        if (ctx.common.async === false) {
          const inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          executeRefinement(inner.value);
          return { status: status.value, value: inner.value };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
            if (inner.status === "aborted")
              return INVALID;
            if (inner.status === "dirty")
              status.dirty();
            return executeRefinement(inner.value).then(() => {
              return { status: status.value, value: inner.value };
            });
          });
        }
      }
      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          const base = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (!isValid(base))
            return base;
          const result = effect.transform(base.value, checkCtx);
          if (result instanceof Promise) {
            throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
          }
          return { status: status.value, value: result };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
            if (!isValid(base))
              return base;
            return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
          });
        }
      }
      util.assertNever(effect);
    }
  };
  ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
      schema,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect,
      ...processCreateParams(params)
    });
  };
  ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
      schema,
      effect: { type: "preprocess", transform: preprocess },
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      ...processCreateParams(params)
    });
  };
  var ZodOptional = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType.undefined) {
        return OK(void 0);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodOptional.create = (type, params) => {
    return new ZodOptional({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodOptional,
      ...processCreateParams(params)
    });
  };
  var ZodNullable = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType.null) {
        return OK(null);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodNullable.create = (type, params) => {
    return new ZodNullable({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodNullable,
      ...processCreateParams(params)
    });
  };
  var ZodDefault = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      let data = ctx.data;
      if (ctx.parsedType === ZodParsedType.undefined) {
        data = this._def.defaultValue();
      }
      return this._def.innerType._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  };
  ZodDefault.create = (type, params) => {
    return new ZodDefault({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodDefault,
      defaultValue: typeof params.default === "function" ? params.default : () => params.default,
      ...processCreateParams(params)
    });
  };
  var ZodCatch = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const result = this._def.innerType._parse({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (isAsync(result)) {
        return result.then((result2) => {
          return {
            status: "valid",
            value: result2.status === "valid" ? result2.value : this._def.defaultValue()
          };
        });
      } else {
        return {
          status: "valid",
          value: result.status === "valid" ? result.value : this._def.defaultValue()
        };
      }
    }
    removeDefault() {
      return this._def.innerType;
    }
  };
  ZodCatch.create = (type, params) => {
    return new ZodCatch({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodCatch,
      defaultValue: typeof params.default === "function" ? params.default : () => params.default,
      ...processCreateParams(params)
    });
  };
  var ZodNaN = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.nan) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.nan,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return { status: "valid", value: input.data };
    }
  };
  ZodNaN.create = (params) => {
    return new ZodNaN({
      typeName: ZodFirstPartyTypeKind.ZodNaN,
      ...processCreateParams(params)
    });
  };
  var BRAND = Symbol("zod_brand");
  var ZodBranded = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const data = ctx.data;
      return this._def.type._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    unwrap() {
      return this._def.type;
    }
  };
  var ZodPipeline = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.common.async) {
        const handleAsync = async () => {
          const inResult = await this._def.in._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inResult.status === "aborted")
            return INVALID;
          if (inResult.status === "dirty") {
            status.dirty();
            return DIRTY(inResult.value);
          } else {
            return this._def.out._parseAsync({
              data: inResult.value,
              path: ctx.path,
              parent: ctx
            });
          }
        };
        return handleAsync();
      } else {
        const inResult = this._def.in._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return {
            status: "dirty",
            value: inResult.value
          };
        } else {
          return this._def.out._parseSync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      }
    }
    static create(a, b) {
      return new ZodPipeline({
        in: a,
        out: b,
        typeName: ZodFirstPartyTypeKind.ZodPipeline
      });
    }
  };
  var custom = (check, params = {}, fatal) => {
    if (check)
      return ZodAny.create().superRefine((data, ctx) => {
        if (!check(data)) {
          const p = typeof params === "function" ? params(data) : params;
          const p2 = typeof p === "string" ? { message: p } : p;
          ctx.addIssue({ code: "custom", ...p2, fatal });
        }
      });
    return ZodAny.create();
  };
  var late = {
    object: ZodObject.lazycreate
  };
  var ZodFirstPartyTypeKind;
  (function(ZodFirstPartyTypeKind2) {
    ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  })(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
  var instanceOfType = (cls, params = {
    message: `Input not instance of ${cls.name}`
  }) => custom((data) => data instanceof cls, params, true);
  var stringType = ZodString.create;
  var numberType = ZodNumber.create;
  var nanType = ZodNaN.create;
  var bigIntType = ZodBigInt.create;
  var booleanType = ZodBoolean.create;
  var dateType = ZodDate.create;
  var symbolType = ZodSymbol.create;
  var undefinedType = ZodUndefined.create;
  var nullType = ZodNull.create;
  var anyType = ZodAny.create;
  var unknownType = ZodUnknown.create;
  var neverType = ZodNever.create;
  var voidType = ZodVoid.create;
  var arrayType = ZodArray.create;
  var objectType = ZodObject.create;
  var strictObjectType = ZodObject.strictCreate;
  var unionType = ZodUnion.create;
  var discriminatedUnionType = ZodDiscriminatedUnion.create;
  var intersectionType = ZodIntersection.create;
  var tupleType = ZodTuple.create;
  var recordType = ZodRecord.create;
  var mapType = ZodMap.create;
  var setType = ZodSet.create;
  var functionType = ZodFunction.create;
  var lazyType = ZodLazy.create;
  var literalType = ZodLiteral.create;
  var enumType = ZodEnum.create;
  var nativeEnumType = ZodNativeEnum.create;
  var promiseType = ZodPromise.create;
  var effectsType = ZodEffects.create;
  var optionalType = ZodOptional.create;
  var nullableType = ZodNullable.create;
  var preprocessType = ZodEffects.createWithPreprocess;
  var pipelineType = ZodPipeline.create;
  var ostring = () => stringType().optional();
  var onumber = () => numberType().optional();
  var oboolean = () => booleanType().optional();
  var coerce = {
    string: (arg) => ZodString.create({ ...arg, coerce: true }),
    number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
    boolean: (arg) => ZodBoolean.create({ ...arg, coerce: true }),
    bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
    date: (arg) => ZodDate.create({ ...arg, coerce: true })
  };
  var NEVER = INVALID;
  var mod = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap,
    getErrorMap,
    makeIssue,
    EMPTY_PATH,
    addIssueToContext,
    ParseStatus,
    INVALID,
    DIRTY,
    OK,
    isAborted,
    isDirty,
    isValid,
    isAsync,
    get util() {
      return util;
    },
    ZodParsedType,
    getParsedType,
    ZodType,
    ZodString,
    ZodNumber,
    ZodBigInt,
    ZodBoolean,
    ZodDate,
    ZodSymbol,
    ZodUndefined,
    ZodNull,
    ZodAny,
    ZodUnknown,
    ZodNever,
    ZodVoid,
    ZodArray,
    get objectUtil() {
      return objectUtil;
    },
    ZodObject,
    ZodUnion,
    ZodDiscriminatedUnion,
    ZodIntersection,
    ZodTuple,
    ZodRecord,
    ZodMap,
    ZodSet,
    ZodFunction,
    ZodLazy,
    ZodLiteral,
    ZodEnum,
    ZodNativeEnum,
    ZodPromise,
    ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional,
    ZodNullable,
    ZodDefault,
    ZodCatch,
    ZodNaN,
    BRAND,
    ZodBranded,
    ZodPipeline,
    custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late,
    get ZodFirstPartyTypeKind() {
      return ZodFirstPartyTypeKind;
    },
    coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    "enum": enumType,
    "function": functionType,
    "instanceof": instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    "null": nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean,
    onumber,
    optional: optionalType,
    ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    "undefined": undefinedType,
    union: unionType,
    unknown: unknownType,
    "void": voidType,
    NEVER,
    ZodIssueCode,
    quotelessJson,
    ZodError
  });

  // src/core/cart/types.ts
  var get2byteLength = (str) => {
    let count = 0;
    for (let i = 0, len = str.length; i < len; i++) {
      const c = str.charCodeAt(i);
      if (!str[i].match(/\r?\n/g)) {
        if (c >= 0 && c <= 127) {
          count += 0.5;
        } else {
          count += 1;
        }
      }
    }
    return count;
  };
  var contentValidationMessage = `\u300C&\u300D\u300C"\u300D\u300C'\u300D\u306F\u4F7F\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002`;
  var textSchema = mod.string().nullable().refine(
    (s2) => {
      if (s2 === null)
        return true;
      const specialCharacters = ["&", `'`, `"`];
      for (const character of specialCharacters) {
        if (s2.includes(character)) {
          return false;
        }
      }
      return true;
    },
    { message: contentValidationMessage }
  );
  var giftFormSchema = mod.object({
    noshi: mod.boolean(),
    noshi_type: mod.enum([
      "\u7121\u5730",
      "\u5FA1\u793C",
      "\u5FA1\u4E2D\u5143",
      "\u5FA1\u6B73\u66AE",
      "\u5FA1\u5E74\u8CC0",
      "\u5BD2\u4E2D\u898B\u821E",
      "\u5185\u795D(\u7D05\u767D\u8776\u7D50\u3073)",
      "\u5185\u795D(\u7D05\u767D10\u672C\u7D50\u3073\u5207\u308A)"
    ]).nullable(),
    noshi_name: textSchema,
    message: mod.boolean(),
    message_type: mod.number().nullable(),
    message_content: textSchema
  }).refine((v) => v.message ? v.message_type !== null : true, {
    message: "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u7A2E\u985E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    path: ["message_type"]
  }).refine(
    (v) => {
      if (!v.message)
        return true;
      if (!v.message_content || v.message_content.length === 0)
        return false;
      return true;
    },
    {
      message: "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u672C\u6587\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
      path: ["message_content"]
    }
  ).refine(
    (v) => {
      if (!v.message)
        return true;
      if (!v.message_content || v.message_content.length === 0)
        return false;
      const content = v.message_content.replace("/\r\n/g", "\n");
      return (content.match(/\r\n|\n/g) ?? []).length < 5;
    },
    {
      message: "5\u884C\u307E\u3067\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      path: ["message_content"]
    }
  ).refine(
    (v) => {
      if (!v.message)
        return true;
      if (!v.message_content || v.message_content.length === 0)
        return false;
      const content = v.message_content.replace("/\r\n/g", "\n");
      const linesArray = content.split("\n");
      return linesArray.every((line) => get2byteLength(line) <= 15);
    },
    {
      message: "1\u884C\u5168\u89D215\u6587\u5B57\u307E\u3067\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
      path: ["message_content"]
    }
  ).refine(
    (v) => {
      return v.noshi === true ? v.noshi_type !== null : true;
    },
    {
      message: "\u71A8\u6597\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
      path: ["noshi_type"]
    }
  ).transform((v) => ({
    ...v,
    noshi_type: v.noshi ? v.noshi_type : null,
    noshi_name: v.noshi ? v.noshi_name : null,
    message_type: v.message ? v.message_type : null,
    message_content: v.message ? v.message_content : null
  }));
  mod.object({
    attributes: mod.object({
      gift: mod.string()
    })
  });

  // src/core/cart/cart.ts
  init_react_import();

  // src/utils/shopify/index.ts
  init_react_import();

  // src/utils/shopify/apiClient.ts
  init_react_import();
  var updateCartAttributes = async (data) => {
    if (data.attributes.gift && typeof data.attributes.gift === "object") {
      data.attributes.gift = JSON.stringify(data.attributes.gift);
    }
    return await fetchShopify("/cart/update.js", data);
  };
  var fetchCart = async () => {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    return await res.json();
  };
  var clearAndAddItems = async (data) => {
    await fetchShopify("/cart/clear.js", null);
    return await fetchShopify("/cart/add.js", data);
  };
  var fetchShopify = async (url, data) => {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: data ? JSON.stringify(data) : void 0
      });
      const json = await res.json();
      return json;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  // src/utils/shopify/index.ts
  var formatPrice = (price) => {
    return (price / 100).toLocaleString("ja-JP", {
      style: "currency",
      currency: "JPY"
    });
  };

  // src/core/cart/cart.ts
  var getCart = () => {
    var _a3, _b2;
    const cart = window.eataly.cart;
    if ((_a3 = cart.attributes) == null ? void 0 : _a3.gift) {
      cart.attributes.gift = (_b2 = cart.attributes.gift) == null ? void 0 : _b2.replace(/&quot;/g, '"');
    }
    return window.eataly.cart;
  };
  var setCartGlobal = (cart) => {
    window.eataly.cart = cart;
  };
  var invalidateOldCartAttributes = async (cart) => {
    var _a3, _b2;
    const giftSettings = getGiftSettings(cart);
    const giftIds = giftSettings.map(({ gift_id }) => String(gift_id));
    let hasLostSetting = false;
    for (const item of cart.items) {
      if (((_a3 = item.properties) == null ? void 0 : _a3.gift_id) !== void 0 && !giftIds.includes(String(item.properties.gift_id))) {
        hasLostSetting = true;
        (_b2 = item.properties) == null ? true : delete _b2.gift_id;
      }
    }
    if (hasLostSetting) {
      await clearAndAddItems({
        items: cart.items.map((i) => ({
          id: i.id,
          quantity: i.quantity,
          properties: i.properties
        }))
      });
    }
    const activeSettings = giftSettings.filter(
      (setting) => cart.items.some(
        (item) => {
          var _a4;
          return String((_a4 = item.properties) == null ? void 0 : _a4.gift_id) === String(setting.gift_id);
        }
      )
    );
    let updatedCart = null;
    const hasLostAttribute = activeSettings.length !== giftSettings.length;
    if (hasLostAttribute) {
      updatedCart = await updateCartAttributes({
        attributes: {
          ...cart.attributes,
          gift: JSON.stringify(activeSettings)
        }
      });
    }
    if (hasLostAttribute || hasLostSetting) {
      updatedCart = updatedCart ?? await fetchCart();
      window.dispatchEvent(
        new CustomEvent("cart:update", { detail: updatedCart })
      );
    }
  };
  var getGiftSettings = (cart) => {
    if (!cart.attributes.gift)
      return [];
    cart.attributes.gift = cart.attributes.gift.replace(/\u0026/g, "");
    cart.attributes.gift = cart.attributes.gift.replace(/amp;/g, "");
    cart.attributes.gift = cart.attributes.gift.replace(/quot;/g, '"');
    cart.attributes.gift = cart.attributes.gift.replace(/\r\n/g, "\\n");
    return JSON.parse(cart.attributes.gift);
  };
  var mapBundledItemsInventory = (cartItems) => {
    return cartItems.map((item) => {
      if (!isBundleParentItem(item))
        return item;
      const { meta, ...rest } = item;
      if (!meta)
        return item;
      const inventoryQuantity = (() => {
        const max = cartItems.reduce((acc, cur) => {
          var _a3, _b2;
          if (((_a3 = cur.meta) == null ? void 0 : _a3.inventoryQuantity) === void 0)
            return acc;
          if (cur.meta.inventoryPolicy === "continue")
            return acc;
          if (((_b2 = cur.properties) == null ? void 0 : _b2._bundle_product_id) === item.product_id) {
            if (cur.meta) {
              acc.push(cur.meta.inventoryQuantity);
            }
          }
          return acc;
        }, []).reduce((a, c) => a > c ? c : a, Infinity);
        return max === Infinity ? 0 : max;
      })();
      return {
        ...rest,
        meta: {
          ...meta,
          inventoryQuantity
        }
      };
    });
  };
  var filterBundledItems = (item) => {
    var _a3;
    return ((_a3 = item.properties) == null ? void 0 : _a3._bundle_product_id) === void 0;
  };
  var isBundleParentItem = (item) => {
    var _a3;
    return ((_a3 = item.properties) == null ? void 0 : _a3._bundle_1) !== void 0;
  };

  // src/components/preact/components/Cart/utils.ts
  var ERROR_MESSAGE = {
    SIZE: "\u30AE\u30D5\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u5165\u308B\u30B5\u30A4\u30BA\u3092\u8D85\u3048\u3066\u3044\u308B\u305F\u3081\u3001\u5546\u54C1\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002\u5225\u3067\u30AE\u30D5\u30C8\u30DC\u30C3\u30AF\u30B9\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  };
  var getDefaultGiftBoxProduct = () => window.giftBoxProduct;
  var getGiftBoxOptionVariantId = () => window.giftBoxVariantId;
  var isNotGiftBox = (item) => item.product_type !== "\u30AE\u30D5\u30C8\u7528BOX";
  var isGiftBox = (item) => !isNotGiftBox(item);
  var updateQuantity = (line, quantity) => {
    const $cartItems = document.querySelector("cart-items");
    $cartItems.updateQuantity(line, quantity);
  };
  var getGiftBoxItem = (item) => {
    var _a3;
    return ((_a3 = item.meta) == null ? void 0 : _a3.overrideGiftProduct) ? item.meta.overrideGiftProduct : getDefaultGiftBoxProduct();
  };
  var updateBundleQuantity = (data) => {
    const $cartItems = document.querySelector("cart-items");
    $cartItems.updateBundleQuantity(data);
  };
  var deleteGiftSetting = async (giftId) => {
    var _a3, _b2, _c2, _d;
    const cart = getCart();
    const giftSettings = JSON.parse(cart.attributes.gift ?? "[]");
    const cartItems = cart.items.filter(
      (item) => {
        var _a4;
        return !(((_a4 = item.properties) == null ? void 0 : _a4.gift_id) == giftId && isGiftBox(item));
      }
    );
    for (const item of cartItems) {
      if (String((_a3 = item.properties) == null ? void 0 : _a3.gift_id) == String(giftId)) {
        (_b2 = item.properties) == null ? true : delete _b2.gift_id;
      }
      if (((_c2 = item.properties) == null ? void 0 : _c2.gift_id) && Number((_d = item.properties) == null ? void 0 : _d.gift_id) > giftId) {
        item.properties.gift_id = Number(item.properties.gift_id) - 1;
      }
    }
    await clearAndAddItems({
      items: cartItems
    });
    return await updateCartAttributes({
      attributes: {
        ...cart.attributes,
        gift: giftSettings.filter((g) => String(g.gift_id) !== String(giftId)).map((g) => ({
          ...g,
          gift_id: g.gift_id > giftId ? g.gift_id - 1 : g.gift_id
        }))
      }
    });
  };
  var isValidSize = (variantIds, quantitiesByVariantId, items) => {
    const sum = items.reduce((acc, item) => {
      var _a3;
      if (variantIds.includes(item.variant_id)) {
        acc += quantitiesByVariantId[item.variant_id] * (((_a3 = item == null ? void 0 : item.meta) == null ? void 0 : _a3.sizeStandardValue) ? Number(item.meta.sizeStandardValue) : 0);
      }
      return acc;
    }, 0);
    return sum <= 2;
  };

  // src/components/preact/components/Cart/GiftForm/GiftBoxProduct.tsx
  init_react_import();
  var GiftBoxProduct2 = ({
    giftBoxProduct,
    isSelectedBundleGift
  }) => {
    return /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col gap-y-2 justify-center items-start p-4 bg-typography-white"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-row gap-x-4 justify-center items-start"
    }, /* @__PURE__ */ import_react.default.createElement("img", {
      className: "object-cover max-w-[100px] max-h-20 lg:min-w-[140px] lg:min-h-[112px]",
      src: giftBoxProduct.featuredImage,
      alt: giftBoxProduct.title
    }), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col gap-y-2 justify-center items-start"
    }, /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-sm font-medium tracking-[1px] leading-6 text-typography-gray"
    }, giftBoxProduct.title), /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-base font-medium tracking-[1px] text-secondary-orange01"
    }, isSelectedBundleGift ? `\u7121\u6599` : `${giftBoxProduct.price.toLocaleString("ja-JP", {
    style: "currency",
    currency: "JPY"
  })}\uFF08\u7A0E\u8FBC\uFF09`))), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "text-xs font-normal tracking-[0.6px] text-surface-gray05"
    }, "\u3053\u3061\u3089\u306E\u30AE\u30D5\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u5546\u54C1\u3092\u5165\u308C\u3066\u304A\u5C4A\u3051\u3044\u305F\u3057\u307E\u3059\u3002"));
  };

  // src/components/preact/components/Cart/GiftForm/utils.ts
  init_react_import();
  var getBundleItemsToUpdate = (cartItems, selectedFirstGiftItem, quantitiesByVariantId, gift_id) => {
    const result = [];
    cartItems.filter(
      (item) => {
        var _a3, _b2;
        return item.properties.gift_id === void 0 && ((_a3 = item.properties) == null ? void 0 : _a3._bundle_product_id) && ((_b2 = item.properties) == null ? void 0 : _b2._bundle_product_id) === selectedFirstGiftItem.product_id;
      }
    ).forEach((item) => {
      result.push({
        id: item.variant_id,
        quantity: quantitiesByVariantId[selectedFirstGiftItem.id],
        properties: {
          ...item.properties,
          gift_id
        }
      });
      const diff = item.quantity - quantitiesByVariantId[selectedFirstGiftItem.id];
      if (diff > 0) {
        result.push({
          id: item.variant_id,
          quantity: diff,
          properties: {
            ...item.properties
          }
        });
      }
    });
    return result;
  };
  var getBundleChildVariantIds = (properties) => {
    return Object.keys(properties).filter((key) => key.startsWith("_bundle_")).map((key) => Number(properties[key]));
  };

  // src/components/icons/ArrowIcon/index.tsx
  init_react_import();
  var ArrowIcon = ({ className, ...rest }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default(className ?? "w-4"),
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...rest
    }, /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M6.66797 4L10.668 8L6.66797 12",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/components/icons/LoadingSpinner.tsx
  init_react_import();
  var LoadingSpinner = ({ width, height }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      role: "presentation",
      viewBox: "0 0 66 66",
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height
    }, /* @__PURE__ */ import_react.default.createElement("circle", {
      className: "path",
      fill: "none",
      strokeWidth: "6",
      cx: "33",
      cy: "33",
      r: "30"
    }));
  };

  // src/components/preact/components/snippets/Button/index.tsx
  init_react_import();
  var Button = ({
    className: classNameProp,
    size = "md",
    variant = "primary",
    href,
    disabled,
    children,
    type = "button",
    form,
    ...rest
  }) => {
    const className = clsx_m_default(
      "btn",
      classNameProp,
      {
        "py-2.5 px-8 h-11 text-sm font-medium": size === "sm",
        "py-3.5 px-14 h-[52px] text-base font-medium": size === "md"
      },
      disabled && "disabled",
      variant === "primary" ? "btn-primary" : variant === "secondary" ? "btn-secondary" : variant === "primary-outlined" ? "btn-primary-outlined" : variant === "secondary-outlined" ? "btn-secondary-outlined" : ""
    );
    return href ? /* @__PURE__ */ import_react.default.createElement("a", {
      className,
      href,
      ...rest
    }, children) : /* @__PURE__ */ import_react.default.createElement("button", {
      className,
      type,
      form,
      ...rest
    }, children);
  };

  // src/components/preact/components/snippets/Checkbox/index.tsx
  init_react_import();

  // src/components/icons/CheckDisabledIcon/index.tsx
  init_react_import();
  var CheckDisabledIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default("w-6", className),
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("rect", {
      x: "0.5",
      width: "24",
      height: "24",
      rx: "4",
      fill: "#F8F8F8"
    }), /* @__PURE__ */ import_react.default.createElement("rect", {
      x: "1",
      y: "0.5",
      width: "23",
      height: "23",
      rx: "3.5",
      stroke: "#D8D8D8"
    }));
  };

  // src/components/icons/CheckedIcon/index.tsx
  init_react_import();
  var CheckedIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default("w-6", className),
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("rect", {
      width: "24",
      height: "24",
      rx: "4",
      fill: "#8AAA33"
    }), /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M5 12.3333L9.44444 16.7777L19.2222 7",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/components/icons/UncheckedIcon/index.tsx
  init_react_import();
  var UncheckedIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default("w-6", className),
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "23",
      height: "23",
      rx: "3.5",
      stroke: "#739EC9"
    }));
  };

  // src/components/preact/components/snippets/Checkbox/index.tsx
  var Checkbox = ({
    className,
    id,
    name,
    label,
    disabled = false,
    checked = false,
    onChange
  }) => {
    return /* @__PURE__ */ import_react.default.createElement("label", {
      htmlFor: id,
      className: clsx_m_default(className, "flex cursor-pointer", {
        "cursor-default": disabled
      })
    }, /* @__PURE__ */ import_react.default.createElement("input", {
      className: "invisible p-0 m-[-1px] w-[1px] h-[1px]",
      type: "checkbox",
      id,
      name,
      checked,
      disabled,
      onChange: (e2) => {
        onChange == null ? void 0 : onChange(e2.target.checked);
      }
    }), disabled ? /* @__PURE__ */ import_react.default.createElement(CheckDisabledIcon, null) : /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(UncheckedIcon, {
      className: clsx_m_default({
        hidden: checked,
        block: !checked
      })
    }), /* @__PURE__ */ import_react.default.createElement(CheckedIcon, {
      className: clsx_m_default({
        block: checked,
        hidden: !checked
      })
    })), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "ml-2"
    }, label));
  };

  // src/components/preact/components/snippets/CounterInput/index.tsx
  init_react_import();

  // src/components/icons/MinusIcon/index.tsx
  init_react_import();
  var MinusIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default(className ?? "w-16"),
      viewBox: "0 0 17 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M13.8337 8H3.16699",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/components/icons/PlusIcon/index.tsx
  init_react_import();
  var PlusIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default(className ?? "w-[22px]"),
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M11.0013 3.66699V18.3337M18.3346 11.0003H3.66797H18.3346Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/hooks/useDebounce.ts
  init_react_import();
  var import_react5 = __toESM(require_react());
  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, import_react5.useState)(value);
    (0, import_react5.useEffect)(() => {
      let timer = null;
      if (delay === 0) {
        setDebouncedValue(value);
      } else {
        timer = setTimeout(() => setDebouncedValue(value), delay || 500);
      }
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }, [value, delay]);
    return debouncedValue;
  }
  var useDebounce_default = useDebounce;

  // src/hooks/useDidUpdateEffect.ts
  init_react_import();
  var import_react6 = __toESM(require_react());
  function useDidUpdateEffect(fn, deps) {
    const didMountRef = (0, import_react6.useRef)(false);
    (0, import_react6.useEffect)(() => {
      if (!didMountRef.current) {
        didMountRef.current = true;
      } else {
        fn();
      }
    }, deps);
  }

  // src/components/preact/components/snippets/CounterInput/index.tsx
  var CounterInput = ({
    value,
    disabled = false,
    max = 1,
    onUpdate,
    onDebouncedUpdate,
    debounceDelay = 300
  }) => {
    const debouncedQuantity = useDebounce_default(value, debounceDelay);
    const handleIncrement = () => {
      if (value < max) {
        onUpdate(value + 1);
      }
    };
    const handleDecrement = () => {
      if (value > 1) {
        onUpdate(value - 1);
      }
    };
    useDidUpdateEffect(() => {
      if (onDebouncedUpdate)
        onDebouncedUpdate(debouncedQuantity);
    }, [debouncedQuantity]);
    return /* @__PURE__ */ import_react.default.createElement("div", {
      className: "inline-flex justify-between items-center h-11 text-base leading-[44px] text-center text-typography-white bg-primary-orange rounded-full text-medium"
    }, /* @__PURE__ */ import_react.default.createElement("button", {
      type: "button",
      disabled,
      className: "relative ml-0.5 w-10 h-10 bg-[#F2CC6C] rounded-full",
      onClick: handleDecrement
    }, /* @__PURE__ */ import_react.default.createElement(MinusIcon, {
      className: "absolute top-3 left-3 w-4 text-typography-white"
    })), /* @__PURE__ */ import_react.default.createElement("input", {
      type: "number",
      className: "w-10 text-center bg-inherit focus:outline-none no-spin-button",
      name: "updates[]",
      min: "0",
      max,
      value: value ?? value,
      readOnly: true,
      onInput: (e2) => {
        const value2 = parseInt(e2.currentTarget.value);
        if (value2 > max) {
          onUpdate(max);
        } else if (value2 < 1) {
          onUpdate(1);
        } else {
          onUpdate(value2);
        }
      }
    }), /* @__PURE__ */ import_react.default.createElement("button", {
      type: "button",
      disabled,
      className: "relative mr-0.5 w-10 h-10 bg-typography-white rounded-full",
      onClick: handleIncrement
    }, /* @__PURE__ */ import_react.default.createElement(PlusIcon, {
      className: "absolute top-3 left-3 w-4 text-primary-orange"
    })));
  };

  // src/components/preact/components/Cart/GiftForm/index.tsx
  var MessageType = {
    1: "1. Buon compleanno\uFF08\u8A95\u751F\u65E5\u304A\u3081\u3067\u3068\u3046\uFF09",
    2: "2. Grazie\uFF08\u3042\u308A\u304C\u3068\u3046\uFF09",
    3: "3. Auguri\uFF08\u304A\u3081\u3067\u3068\u3046\uFF09"
  };
  var GiftFormWrapper = ({
    Form,
    SubmitButton
  }) => {
    return /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col w-full h-full"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "overflow-y-auto p-5 h-full lg:p-10"
    }, Form), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-wrap gap-y-4 justify-center items-center py-4 px-8 bg-surface-gray01 lg:justify-between"
    }, /* @__PURE__ */ import_react.default.createElement("div", null, "\u9078\u629E\u3057\u305F\u5546\u54C1\u3092\uFF11\u3064\u306E\u30AE\u30D5\u30C8\u3068\u3057\u3066\u307E\u3068\u3081\u308B"), SubmitButton));
  };
  var GiftForm = ({
    className,
    cartItems,
    giftBoxPrice,
    giftId,
    closeGiftForm
  }) => {
    const currentGiftSetting = getGiftSettings(getCart()).find((setting) => {
      return setting.gift_id === giftId;
    });
    const editableItemsByVariantId = cartItems.reduce((acc, item) => {
      var _a3, _b2;
      if (!((_a3 = item.properties) == null ? void 0 : _a3.gift_id) || String((_b2 = item.properties) == null ? void 0 : _b2.gift_id) === String(giftId)) {
        if (acc[item.variant_id]) {
          acc[item.variant_id].quantity += item.quantity;
        } else {
          acc[item.variant_id] = { ...item };
        }
      }
      return acc;
    }, {});
    const editableItems = Object.keys(editableItemsByVariantId).map(
      (key) => editableItemsByVariantId[Number(key)]
    );
    const hasGiftBoxedProduct = editableItems.some(
      (item) => {
        var _a3;
        return ((_a3 = item == null ? void 0 : item.meta) == null ? void 0 : _a3.isWrappingDisabled) === true;
      }
    );
    const [selectedCartItemVariantIds, setSelectedCartItemVariants] = (0, import_react7.useState)(
      cartItems.filter(
        (item) => {
          var _a3;
          return ((_a3 = item.properties) == null ? void 0 : _a3.gift_id) === giftId && isNotGiftBox(item);
        }
      ).map((item) => item.variant_id)
    );
    const selectedFirstItem = editableItemsByVariantId[selectedCartItemVariantIds[0]];
    const isGiftProductSelected = selectedCartItemVariantIds.some(
      (variantId) => {
        var _a3, _b2;
        return (_b2 = (_a3 = editableItemsByVariantId[variantId]) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.isGiftBoxProduct;
      }
    );
    const isSelectedBundleGift = selectedCartItemVariantIds.some(
      (variantId) => {
        var _a3, _b2;
        return (_b2 = (_a3 = editableItemsByVariantId[variantId]) == null ? void 0 : _a3.meta) == null ? void 0 : _b2.tags.includes("bundle-gift");
      }
    );
    const initialQuantities = editableItems.reduce((acc, item) => {
      var _a3;
      return {
        ...acc,
        [item.variant_id]: ((_a3 = item.meta) == null ? void 0 : _a3.tags.includes("bundle-gift")) ? 1 : item.quantity
      };
    }, {});
    for (const { variant_id, quantity, properties } of cartItems) {
      if ((properties == null ? void 0 : properties.gift_id) === giftId) {
        initialQuantities[variant_id] = quantity;
      }
    }
    const [quantitiesByVariantId, setQuantitiesByVariantId] = (0, import_react7.useState)(initialQuantities);
    const cartItemSelected = selectedCartItemVariantIds.length > 0;
    const {
      handleSubmit,
      formState: { errors, isSubmitting, isSubmitted },
      watch,
      setValue,
      register
    } = useForm({
      mode: "onSubmit",
      reValidateMode: "onChange",
      defaultValues: {
        noshi: (currentGiftSetting == null ? void 0 : currentGiftSetting.noshi) ?? false,
        noshi_type: (currentGiftSetting == null ? void 0 : currentGiftSetting.noshi_type) ?? null,
        noshi_name: (currentGiftSetting == null ? void 0 : currentGiftSetting.noshi_name) ?? null,
        message: (currentGiftSetting == null ? void 0 : currentGiftSetting.message) ?? false,
        message_type: (currentGiftSetting == null ? void 0 : currentGiftSetting.message_type) ?? null,
        message_content: (currentGiftSetting == null ? void 0 : currentGiftSetting.message_content) ?? null
      },
      resolver: s(giftFormSchema),
      context: void 0,
      criteriaMode: "firstError",
      shouldFocusError: true,
      shouldUnregister: false,
      shouldUseNativeValidation: false,
      delayError: void 0
    });
    const onSubmit = async (data) => {
      var _a3, _b2;
      if (selectedCartItemVariantIds.every(
        (variantId) => quantitiesByVariantId[variantId] === 0
      ) || selectedCartItemVariantIds.length === 0) {
        alert("\u30AE\u30D5\u30C8\u306B\u8A2D\u5B9A\u3059\u308B\u5546\u54C1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
        return;
      }
      const itemsToUpdate = [];
      selectedCartItemVariantIds.forEach((variantId) => {
        itemsToUpdate.push({
          id: variantId,
          quantity: quantitiesByVariantId[variantId],
          properties: {
            ...editableItemsByVariantId[variantId].properties,
            gift_id: giftId
          }
        });
        const diff = editableItemsByVariantId[variantId].quantity - quantitiesByVariantId[variantId];
        if (diff > 0) {
          itemsToUpdate.push({
            id: variantId,
            quantity: diff,
            properties: editableItemsByVariantId[variantId].properties
          });
        }
      });
      const cart = getCart();
      const isBundleSelected = Boolean((_a3 = selectedFirstItem.properties) == null ? void 0 : _a3._bundle_1);
      if (isBundleSelected) {
        const bundleItemsToUpdate = getBundleItemsToUpdate(
          cart.items,
          selectedFirstItem,
          quantitiesByVariantId,
          giftId
        );
        itemsToUpdate.push(...bundleItemsToUpdate);
      }
      const giftBoxVariantId = getGiftBoxOptionVariantId();
      const existingGiftSettings = getGiftSettings(cart);
      const selectedBundleChildVariantIds = !isBundleSelected || !selectedFirstItem.properties ? [] : getBundleChildVariantIds(selectedFirstItem.properties);
      await clearAndAddItems({
        items: [
          ...itemsToUpdate,
          ...cart.items.filter((item) => {
            var _a4;
            const isNotSelected = !selectedCartItemVariantIds.includes(
              item.variant_id
            );
            if (isNotSelected) {
              if (isGiftBox(item)) {
                return false;
              }
              if (selectedBundleChildVariantIds.includes(item.variant_id) && item.properties._bundle_product_id !== void 0 && item.properties.gift_id === void 0) {
                return false;
              }
              return true;
            }
            return ((_a4 = item.properties) == null ? void 0 : _a4.gift_id) !== void 0 && String(item.properties.gift_id) !== String(giftId);
          }),
          ...[
            ...existingGiftSettings.map(
              ({ gift_id, box_title: _, box_variant_id }) => ({
                id: box_variant_id,
                quantity: 1,
                properties: { gift_id }
              })
            ),
            !isGiftProductSelected ? {
              id: ((_b2 = selectedFirstItem.meta) == null ? void 0 : _b2.overrideGiftProduct) ? selectedFirstItem.meta.overrideGiftProduct.variantId : giftBoxVariantId,
              quantity: 1,
              properties: { gift_id: giftId }
            } : null
          ].filter(Boolean)
        ]
      });
      const giftBoxProduct = getGiftBoxItem(selectedFirstItem);
      const newAttributes = [
        ...existingGiftSettings.filter((setting) => setting.gift_id !== giftId),
        {
          gift_id: giftId,
          paid_box: !isGiftProductSelected,
          box_title: giftBoxProduct.title,
          box_variant_id: giftBoxProduct.variantId,
          ...data
        }
      ];
      const newCartState = await updateCartAttributes({
        attributes: {
          ...cart.attributes,
          gift: JSON.stringify(newAttributes)
        }
      });
      window.dispatchEvent(
        new CustomEvent("cart:update", { detail: newCartState })
      );
      closeGiftForm();
    };
    const [noshiChecked, setNoshiChecked] = [
      watch("noshi"),
      (v) => setValue("noshi", v)
    ];
    const [messageChecked, setMessageChecked] = [
      watch("message"),
      (v) => setValue("message", v)
    ];
    const isSelectable = (item) => {
      var _a3, _b2, _c2, _d;
      if (isCurrentSelected(item))
        return true;
      return !(isGiftProductSelected || ((_a3 = item.meta) == null ? void 0 : _a3.isGiftBoxProduct) !== true && ((_b2 = item == null ? void 0 : item.meta) == null ? void 0 : _b2.isWrappingDisabled) === true || isSelectedBundleGift || Boolean(selectedCartItemVariantIds.length) && ((_c2 = item.meta) == null ? void 0 : _c2.tags.includes("bundle-gift")) || Boolean(selectedCartItemVariantIds.length) && ((_d = item.meta) == null ? void 0 : _d.isGiftBoxProduct));
    };
    const isCurrentSelected = (item) => {
      return selectedCartItemVariantIds.includes(item.variant_id);
    };
    return /* @__PURE__ */ import_react.default.createElement(GiftFormWrapper, {
      Form: /* @__PURE__ */ import_react.default.createElement("form", {
        action: "",
        id: "GiftForm",
        method: "post",
        className: clsx_m_default(className, "w-full"),
        onSubmit: handleSubmit(onSubmit)
      }, /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-6"
      }, /* @__PURE__ */ import_react.default.createElement("h2", {
        className: "font-NotoSerif text-lg font-bold tracking-[1px] leading-[34px] text-typography-gray lg:text-xl"
      }, "\u30AE\u30D5\u30C8\u8A2D\u5B9A"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-4 justify-center items-start lg:gap-y-6"
      }, /* @__PURE__ */ import_react.default.createElement("h3", {
        className: "font-NotoSerif text-base font-bold tracking-[1px] text-typography-gray"
      }, "\u30AE\u30D5\u30C8\u5305\u88C5\u3059\u308B\u5546\u54C1\u3092\u9078\u3076"), hasGiftBoxedProduct && /* @__PURE__ */ import_react.default.createElement("p", {
        className: "text-xs font-normal tracking-[0.6px] leading-[18px] text-surface-gray05"
      }, "\u901A\u5E38\u5546\u54C1\u3068\u30AE\u30D5\u30C8\u5546\u54C1\u306F\u3001\u540C\u3058\u30AE\u30D5\u30C8\u30DC\u30C3\u30AF\u30B9\u306B\u5165\u308C\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002\u305D\u308C\u305E\u308C\u8A2D\u5B9A\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"), /* @__PURE__ */ import_react.default.createElement("ul", {
        className: "flex flex-col gap-y-4 justify-center items-start w-full lg:gap-y-6"
      }, editableItems.filter(isNotGiftBox).map((item) => {
        var _a3, _b2, _c2;
        return /* @__PURE__ */ import_react.default.createElement("li", {
          className: "flex flex-col gap-y-2 justify-center items-end w-full lg:flex-row lg:gap-x-10 lg:justify-between lg:items-center",
          key: item.variant_id
        }, /* @__PURE__ */ import_react.default.createElement(Checkbox, {
          className: "w-full",
          checked: selectedCartItemVariantIds.includes(
            item.variant_id
          ),
          disabled: !isSelectable(item),
          id: `cart-item-${item.variant_id}`,
          name: item.key,
          label: /* @__PURE__ */ import_react.default.createElement("div", {
            className: "flex flex-row gap-x-4 justify-center items-center lg:gap-x-10"
          }, /* @__PURE__ */ import_react.default.createElement("img", {
            className: "aspect-square object-cover w-[100px] lg:w-[120px]",
            src: item.featured_image.url,
            alt: item.title
          }), /* @__PURE__ */ import_react.default.createElement("div", {
            className: clsx_m_default(
              "font-NotoSerif text-base font-bold tracking-[1px] leading-[30px] text-justify text-typography-gray whitespace-normal",
              {
                "text-surface-gray03": false
              }
            )
          }, item.product_title)),
          onChange: (checked) => {
            setSelectedCartItemVariants((varints) => {
              if (checked) {
                const newState = [...varints, item.variant_id];
                if (!isValidSize(
                  newState,
                  quantitiesByVariantId,
                  editableItems
                )) {
                  alert(ERROR_MESSAGE.SIZE);
                  return varints;
                }
                return newState;
              } else {
                return varints.filter((v) => v !== item.variant_id);
              }
            });
          }
        }), !isSelectable(item) && ((_a3 = item.meta) == null ? void 0 : _a3.isGiftBoxProduct) !== true && /* @__PURE__ */ import_react.default.createElement("div", {
          className: "min-w-fit font-NotoSerif text-sm text-justify text-surface-gray05"
        }, "\u30E9\u30C3\u30D4\u30F3\u30B0\u4E0D\u53EF"), isSelectable(item) && /* @__PURE__ */ import_react.default.createElement("div", {
          className: "flex flex-row gap-x-4 items-center min-w-fit"
        }, /* @__PURE__ */ import_react.default.createElement("div", {
          className: clsx_m_default(
            "text-sm font-medium tracking-[1px] leading-6 text-typography-gray",
            {
              "text-surface-gray03": false
            }
          )
        }, "\u30AE\u30D5\u30C8\u672A\u8A2D\u5B9A", editableItemsByVariantId[item.variant_id].quantity, "\u500B"), /* @__PURE__ */ import_react.default.createElement(CounterInput, {
          disabled: ((_b2 = item.meta) == null ? void 0 : _b2.isWrappingDisabled) === true,
          value: quantitiesByVariantId[item.variant_id],
          max: ((_c2 = item.meta) == null ? void 0 : _c2.tags.includes("bundle-gift")) ? 1 : editableItemsByVariantId[item.variant_id].quantity,
          debounceDelay: 0,
          onUpdate: (quantity) => {
            const newState = {
              ...quantitiesByVariantId,
              [item.variant_id]: quantity
            };
            if (!isValidSize(
              selectedCartItemVariantIds,
              newState,
              editableItems
            )) {
              alert(ERROR_MESSAGE.SIZE);
              return;
            }
            setQuantitiesByVariantId(newState);
          }
        })));
      }))), cartItemSelected && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "p-4 bg-surface-gray01"
      }, /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-6"
      }, !isGiftProductSelected && /* @__PURE__ */ import_react.default.createElement(GiftBoxProduct2, {
        giftBoxProduct: getGiftBoxItem(selectedFirstItem),
        isSelectedBundleGift
      }), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-4 justify-center items-start w-full"
      }, /* @__PURE__ */ import_react.default.createElement("h3", {
        className: "font-NotoSerif text-sm font-bold tracking-[1px] leading-6 text-typography-gray"
      }, "\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "grid grid-cols-1 gap-y-4 pb-4 w-full border-b border-surface-gray02 lg:gap-x-6"
      }, /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-2 justify-start items-start"
      }, /* @__PURE__ */ import_react.default.createElement(Checkbox, {
        id: "wrapping-option",
        name: "wrapping-option",
        label: /* @__PURE__ */ import_react.default.createElement("div", {
          className: "text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray"
        }, "\u71A8\u6597\u3092\u3064\u3051\u308B"),
        checked: noshiChecked,
        onChange: setNoshiChecked
      }), /* @__PURE__ */ import_react.default.createElement("span", {
        className: "text-base font-medium tracking-[1px] text-secondary-orange01"
      }, "\u7121\u6599")), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-row gap-x-4 justify-start items-center"
      }, /* @__PURE__ */ import_react.default.createElement("label", {
        className: "min-w-[90px] text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray",
        htmlFor: "noshi_type"
      }, "\u71A8\u6597\u306E\u7A2E\u985E"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "relative"
      }, /* @__PURE__ */ import_react.default.createElement("select", {
        id: "noshi_type",
        className: clsx_m_default(
          "py-3 pr-8 pl-2 w-full text-base font-normal tracking-[0.8px] text-typography-gray bg-surface-gray02 rounded-sm border-none focus:outline-none cursor-pointer lg:min-w-[320px] hide-selectbox-arrow",
          !noshiChecked && "cursor-not-allowed"
        ),
        disabled: !noshiChecked,
        ...register("noshi_type")
      }, /* @__PURE__ */ import_react.default.createElement("option", {
        value: "placeholder",
        disabled: true,
        selected: true,
        className: "hidden"
      }, "\u9078\u629E\u3059\u308B"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u7121\u5730"
      }, "\u7121\u5730"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5FA1\u793C"
      }, "\u5FA1\u793C"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5FA1\u4E2D\u5143"
      }, "\u5FA1\u4E2D\u5143"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5FA1\u6B73\u66AE"
      }, "\u5FA1\u6B73\u66AE"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5FA1\u5E74\u8CC0"
      }, "\u5FA1\u5E74\u8CC0"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5BD2\u4E2D\u898B\u821E"
      }, "\u5BD2\u4E2D\u898B\u821E"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5185\u795D(\u7D05\u767D\u8776\u7D50\u3073)"
      }, "\u5185\u795D(\u7D05\u767D\u8776\u7D50\u3073)"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "\u5185\u795D(\u7D05\u767D10\u672C\u7D50\u3073\u5207\u308A)"
      }, "\u5185\u795D(\u7D05\u767D10\u672C\u7D50\u3073\u5207\u308A)")), /* @__PURE__ */ import_react.default.createElement(ArrowIcon, {
        className: "absolute top-1/2 right-2 w-6 text-typography-gray rotate-90 -translate-y-1/2 pointer-events-none"
      }))), errors.noshi_type && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "text-xs font-normal tracking-[0.6px] text-secondary-red"
      }, "\u71A8\u6597\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-row gap-x-4 justify-start items-center"
      }, /* @__PURE__ */ import_react.default.createElement("label", {
        className: "min-w-[90px] text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray",
        htmlFor: "noshi_name"
      }, "\u71A8\u6597\u306E\u540D\u5165\u308C"), /* @__PURE__ */ import_react.default.createElement("input", {
        id: "noshi_name",
        type: "text",
        maxLength: 75,
        placeholder: "",
        disabled: !noshiChecked,
        className: "py-3 px-2 w-full max-w-[320px] text-base font-normal tracking-[0.8px] text-typography-gray placeholder:text-surface-gray04 bg-surface-gray02 rounded-sm border-none focus:outline-none lg:min-w-[320px]",
        ...register("noshi_name")
      })), !errors.noshi_name && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "text-xs font-normal tracking-[0.6px] text-surface-gray04"
      }, contentValidationMessage), errors.noshi_name && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "text-xs font-normal tracking-[0.6px] text-secondary-red"
      }, errors.noshi_name.message)), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-row gap-x-4 justify-start items-start"
      }, /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-2 justify-start items-start"
      }, /* @__PURE__ */ import_react.default.createElement(Checkbox, {
        id: "message-option",
        name: "message-option",
        label: /* @__PURE__ */ import_react.default.createElement("div", {
          className: "text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray"
        }, "\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9\u3092\u3064\u3051\u308B"),
        checked: messageChecked,
        onChange: setMessageChecked
      }), /* @__PURE__ */ import_react.default.createElement("span", {
        className: "text-base font-medium tracking-[1px] text-secondary-orange01"
      }, "\u7121\u6599"))), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-row gap-x-4 justify-start items-center"
      }, /* @__PURE__ */ import_react.default.createElement("label", {
        className: "min-w-[90px] text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray",
        htmlFor: "message_type"
      }, "\u7A2E\u985E"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "relative"
      }, /* @__PURE__ */ import_react.default.createElement("select", {
        id: "message_type",
        className: clsx_m_default(
          "py-3 pr-8 pl-2 w-full text-base font-normal tracking-[0.8px] text-typography-gray bg-surface-gray02 rounded-sm border-none focus:outline-none cursor-pointer lg:min-w-[320px] hide-selectbox-arrow",
          !messageChecked && "cursor-not-allowed"
        ),
        disabled: !messageChecked,
        ...register("message_type", { valueAsNumber: true })
      }, /* @__PURE__ */ import_react.default.createElement("option", {
        value: "placeholder",
        disabled: true,
        selected: true,
        className: "hidden"
      }, "\u9078\u629E\u3059\u308B"), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "1"
      }, MessageType[1]), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "2"
      }, MessageType[2]), /* @__PURE__ */ import_react.default.createElement("option", {
        value: "3"
      }, MessageType[3])), /* @__PURE__ */ import_react.default.createElement(ArrowIcon, {
        className: "absolute top-1/2 right-2 w-6 text-typography-gray rotate-90 -translate-y-1/2 pointer-events-none"
      }))), errors.message_type && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "text-xs font-normal tracking-[0.6px] text-secondary-red"
      }, "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-wrap gap-[10px] justify-start items-center"
      }, /* @__PURE__ */ import_react.default.createElement("img", {
        className: "w-[150px] h-auto",
        src: "https://cdn.shopify.com/s/files/1/0551/0037/5124/files/card_option_back.png?v=1665088826",
        alt: "\u88CF\u9762"
      }), /* @__PURE__ */ import_react.default.createElement("img", {
        className: "w-[150px] h-auto",
        src: "https://cdn.shopify.com/s/files/1/0551/0037/5124/files/card_option_1.png?v=1665088826",
        alt: "1. Buon compleanno\uFF08\u8A95\u751F\u65E5\u304A\u3081\u3067\u3068\u3046\uFF09"
      }), /* @__PURE__ */ import_react.default.createElement("img", {
        className: "w-[150px] h-auto",
        src: "https://cdn.shopify.com/s/files/1/0551/0037/5124/files/card_option_2.png?v=1665088826",
        alt: "2. Auguri\uFF08\u304A\u3081\u3067\u3068\u3046\uFF09"
      }), /* @__PURE__ */ import_react.default.createElement("img", {
        className: "w-[150px] h-auto",
        src: "https://cdn.shopify.com/s/files/1/0551/0037/5124/files/card_option_3.png?v=1665088826",
        alt: "3. Grazie\uFF08\u3042\u308A\u304C\u3068\u3046\uFF09"
      })), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "flex flex-col gap-y-2 justify-start items-start w-full lg:flex-row lg:gap-x-4"
      }, /* @__PURE__ */ import_react.default.createElement("label", {
        htmlFor: "message_content",
        className: "min-w-[90px] text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray"
      }, "\u30E1\u30C3\u30BB\u30FC\u30B8"), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "w-full"
      }, /* @__PURE__ */ import_react.default.createElement("textarea", {
        id: "message_content",
        placeholder: "",
        rows: 5,
        cols: 15,
        wrap: "hard",
        maxLength: 75 + 4,
        disabled: !messageChecked,
        className: "p-4 w-full text-base font-normal tracking-[0.8px] text-typography-gray placeholder:text-surface-gray04 bg-surface-gray02 rounded-sm focus:outline-none resize-none",
        ...register("message_content")
      }), errors.message_content && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "mt-2 text-xs font-normal tracking-[0.6px] text-secondary-red"
      }, errors.message_content.message), /* @__PURE__ */ import_react.default.createElement("div", {
        className: "mt-2 text-xs font-normal tracking-[0.6px] text-surface-gray05"
      }, /* @__PURE__ */ import_react.default.createElement("span", {
        className: "block"
      }, "\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u6587\u5B57\u6570\u5236\u9650\u306F1\u884C\u5168\u89D215\u6587\u5B57\u30015\u884C\u307E\u3067\u3067\u3059\u3002"), /* @__PURE__ */ import_react.default.createElement("span", {
        className: "block"
      }, contentValidationMessage), /* @__PURE__ */ import_react.default.createElement("span", {
        className: "block"
      }, "\u203B\u7279\u6B8A\u6587\u5B57\u30FB\u7D75\u6587\u5B57\u4E0D\u53EF"), /* @__PURE__ */ import_react.default.createElement("span", {
        className: "block"
      }, "\u203B\u7A7A\u884C\u4E0D\u53EF"))))))), isSubmitted && errors && /* @__PURE__ */ import_react.default.createElement("div", {
        className: "mt-8"
      }, /* @__PURE__ */ import_react.default.createElement("div", {
        className: "text-xs font-normal tracking-[0.6px] text-secondary-red"
      }, "\u5165\u529B\u5185\u5BB9\u306B\u4E0D\u5099\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u5185\u5BB9\u3092\u78BA\u8A8D\u306E\u3046\u3048\u518D\u5EA6\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044")))),
      SubmitButton: /* @__PURE__ */ import_react.default.createElement(Button, {
        type: "submit",
        variant: "secondary",
        size: "sm",
        form: "GiftForm"
      }, !isSubmitting && /* @__PURE__ */ import_react.default.createElement("span", null, "\u3053\u306E\u5185\u5BB9\u3067\u8A2D\u5B9A"), isSubmitting && /* @__PURE__ */ import_react.default.createElement("span", null, /* @__PURE__ */ import_react.default.createElement("span", {
        className: "mr-1"
      }, "\u8A2D\u5B9A\u4E2D"), /* @__PURE__ */ import_react.default.createElement(LoadingSpinner, {
        width: 20
      })))
    });
  };

  // src/components/preact/components/Cart/CartEmpty.tsx
  init_react_import();
  var CartEmpty = () => {
    return /* @__PURE__ */ import_react.default.createElement("div", {
      className: "text-center"
    }, /* @__PURE__ */ import_react.default.createElement("h1", {
      className: "text-base"
    }, "\u30AB\u30FC\u30C8\u306B\u306F\u307E\u3060\u4F55\u3082\u5165\u3063\u3066\u3044\u307E\u305B\u3093"), /* @__PURE__ */ import_react.default.createElement("a", {
      className: "block mt-4 underline underline-offset-4",
      href: "/collections/all"
    }, "\u8CB7\u3044\u7269\u3092\u7D9A\u3051\u308B"));
  };

  // src/components/preact/components/Cart/CartItems.tsx
  init_react_import();

  // src/components/preact/components/Cart/CartLineItemList.tsx
  init_react_import();
  var import_react8 = __toESM(require_react());

  // src/components/preact/components/snippets/DeleteButton/index.tsx
  init_react_import();

  // src/components/icons/CancelIcon/index.tsx
  init_react_import();
  var CancelIcon = ({ className }) => {
    return /* @__PURE__ */ import_react.default.createElement("svg", {
      className: clsx_m_default("w-[18px]", className),
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M11.6514 6.34766L6.34814 11.651M11.6514 11.651L6.34814 6.34766L11.6514 11.651Z",
      stroke: "#9B9B9B",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ import_react.default.createElement("path", {
      d: "M3.6967 14.3033C0.767767 11.3744 0.767767 6.62563 3.6967 3.6967C6.62563 0.767767 11.3744 0.767767 14.3033 3.6967C17.2322 6.62563 17.2322 11.3744 14.3033 14.3033C11.3744 17.2322 6.62563 17.2322 3.6967 14.3033Z",
      stroke: "#9B9B9B",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // src/components/preact/components/snippets/DeleteButton/index.tsx
  var DeleteButton = ({ className, onClick }) => {
    return /* @__PURE__ */ import_react.default.createElement("button", {
      type: "button",
      className: clsx_m_default(className, "flex flex-row gap-x-2 items-center"),
      onClick
    }, /* @__PURE__ */ import_react.default.createElement(CancelIcon, null), /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-sm font-normal leading-6 text-surface-gray05"
    }, "\u524A\u9664"));
  };

  // src/core/delivery-date/index.ts
  init_react_import();

  // src/core/delivery-date/types.ts
  init_react_import();

  // src/core/delivery-date/made-to-order.ts
  init_react_import();

  // src/core/delivery-date/delivery-date.ts
  init_react_import();

  // src/utils/date.ts
  init_react_import();
  var getYMD = (date) => {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };

  // src/core/delivery-date/delivery-date.ts
  function getLineItems() {
    return window.lineItems || [];
  }
  function getHolidaysSync() {
    return window.holidays || [];
  }
  function hasMadeToOrder(lineItems) {
    return lineItems.some((lineItem) => Boolean(lineItem.madeToOrder));
  }

  // src/core/delivery-date/made-to-order.ts
  var dayOfWeek = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
  };
  function getNextDayOfWeek(date, dayOfWeek2) {
    const d = new Date(date.getTime());
    d.setDate(date.getDate() + (7 + dayOfWeek2 - date.getDay()) % 7);
    return d;
  }
  function getNextOrderDeadline(date, dayOfWeek2) {
    const d = getNextDayOfWeek(date, dayOfWeek2);
    if (date.getDay() === dayOfWeek2 && date.getHours() >= 12) {
      d.setDate(d.getDate() + 7);
    }
    return d;
  }
  function getNextMadeToOrderShippingDate() {
    const orderDeadline = getNextOrderDeadline(new Date(), dayOfWeek.Wed);
    const d = new Date(orderDeadline);
    d.setDate(orderDeadline.getDate() + 7);
    const date = getNextDayOfWeek(d, dayOfWeek.Fri);
    if (getHolidaysSync().includes(getYMD(date))) {
      date.setDate(date.getDate() - 1);
      return date;
    }
    return getNextDayOfWeek(d, dayOfWeek.Fri);
  }
  function formatDate(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}\u5E74${month}\u6708${day}\u65E5`;
  }

  // src/components/preact/components/Cart/CartLineItemList.tsx
  var CartLineItemList = ({ cartItems }) => {
    const cartItemsToShow = mapBundledItemsInventory(cartItems).filter(filterBundledItems);
    return /* @__PURE__ */ import_react.default.createElement("ul", {
      className: "flex flex-col gap-y-8"
    }, cartItemsToShow.map((item, index) => /* @__PURE__ */ import_react.default.createElement(CartLineItem, {
      key: index,
      item,
      line: cartItems.findIndex((i) => i.id === item.id) + 1
    })));
  };
  var CartLineItem = ({ item, line }) => {
    var _a3, _b2, _c2, _d, _e;
    const handleDelete = () => {
      if (isBundleParentItem(item)) {
        const data = getCart().items.reduce(
          (acc, cur) => {
            if (cur.properties._bundle_product_id === item.product_id && cur.properties.gift_id === void 0) {
              acc[cur.key] = 0;
            }
            return acc;
          },
          { [item.key]: 0 }
        );
        updateBundleQuantity(data);
      } else {
        updateQuantity(line, 0);
      }
    };
    const cartItems = getCart().items;
    return /* @__PURE__ */ import_react.default.createElement("li", {
      key: item.id,
      className: "flex flex-col gap-y-2 items-end lg:flex-row lg:gap-x-4 lg:items-center"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-row gap-x-4 items-center w-full lg:gap-x-10"
    }, /* @__PURE__ */ import_react.default.createElement("a", {
      href: item.url
    }, /* @__PURE__ */ import_react.default.createElement("img", {
      className: "object-cover max-w-[100px] lg:max-w-[140px]",
      src: item.featured_image.url,
      alt: item.title
    })), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col gap-y-2 items-start w-full lg:flex-row lg:justify-between lg:items-center"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: ""
    }, /* @__PURE__ */ import_react.default.createElement("a", {
      href: item.url,
      className: "font-NotoSerif text-base font-bold tracking-[1px] leading-[30px] text-typography-gray lg:text-lg"
    }, item.product_title), item.selling_plan_allocation && /* @__PURE__ */ import_react.default.createElement("div", {
      className: "font-NotoSerif text-xs text-surface-gray05 lg:text-sm"
    }, item.selling_plan_allocation.selling_plan.name), (((_a3 = item.meta) == null ? void 0 : _a3.madeToOrder) || ((_b2 = item.meta) == null ? void 0 : _b2.minShippingDate) && new Date(item.meta.minShippingDate).getTime() > new Date().getTime()) && /* @__PURE__ */ import_react.default.createElement("div", {
      className: "font-NotoSerif text-xs text-surface-gray05 lg:text-sm"
    }, "\u51FA\u8377\u4E88\u5B9A\u65E5:", " ", ((_c2 = item.meta) == null ? void 0 : _c2.madeToOrder) && formatDate(getNextMadeToOrderShippingDate()), ((_d = item.meta) == null ? void 0 : _d.minShippingDate) && formatDate(new Date(item.meta.minShippingDate))), ((_e = item.properties) == null ? void 0 : _e._bundle_1) && /* @__PURE__ */ import_react.default.createElement("div", {
      className: "font-NotoSerif text-xs text-surface-gray05 lg:text-sm"
    }, /* @__PURE__ */ import_react.default.createElement("div", null, "\u30BB\u30C3\u30C8\u5546\u54C1"), cartItems.filter(
      (i) => i.properties._bundle_product_id === item.product_id
    ).filter(
      (elm, index, self) => self.findIndex((e2) => e2.product_id === elm.product_id) === index
    ).map((bundleItem) => /* @__PURE__ */ import_react.default.createElement("div", {
      key: bundleItem.key,
      className: "text-2xs"
    }, "\u30FB", bundleItem.title))), !item.product_has_only_default_variant && /* @__PURE__ */ import_react.default.createElement("div", {
      className: "font-NotoSerif text-xs text-surface-gray05 lg:text-sm"
    }, item.options_with_values.map(({ name, value }) => /* @__PURE__ */ import_react.default.createElement("div", {
      key: name
    }, name, " ", value)))), /* @__PURE__ */ import_react.default.createElement("span", {
      className: clsx_m_default("text-base font-medium tracking-[1px]", {
        "text-primary-orange": item.original_price === item.final_price,
        "text-secondary-red": item.original_price !== item.final_price
      })
    }, formatPrice(item.final_price), " (\u7A0E\u8FBC)"))), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-row gap-x-4 items-center min-w-[196px]"
    }, /* @__PURE__ */ import_react.default.createElement(CartQuantityInput, {
      key: `${item.id}-${item.quantity}`,
      item,
      line
    }), /* @__PURE__ */ import_react.default.createElement(DeleteButton, {
      onClick: () => handleDelete()
    })));
  };
  var CartQuantityInput = ({
    item,
    line
  }) => {
    var _a3;
    const handleUpdateQuantity = (quantity2) => {
      if (isBundleParentItem(item)) {
        const data = getCart().items.reduce(
          (acc, cur) => {
            if (cur.properties._bundle_product_id === item.product_id) {
              acc[cur.key] = quantity2;
            }
            return acc;
          },
          { [item.key]: quantity2 }
        );
        updateBundleQuantity(data);
      } else {
        updateQuantity(line, quantity2);
      }
    };
    const [quantity, setQuantity] = (0, import_react8.useState)(item.quantity);
    const max = ((_a3 = item == null ? void 0 : item.meta) == null ? void 0 : _a3.inventoryQuantity) ?? 1;
    return /* @__PURE__ */ import_react.default.createElement(CounterInput, {
      key: `${item.id}-${item.quantity}`,
      value: quantity,
      max,
      onUpdate: setQuantity,
      onDebouncedUpdate: handleUpdateQuantity
    });
  };

  // src/components/preact/components/Cart/GiftLineItemListGroup.tsx
  init_react_import();
  var GiftLineItemListGroup = ({
    giftConfiguredItems,
    giftSettings,
    openGiftForm
  }) => {
    const giftItemsByGiftId = giftConfiguredItems.reduce((acc, item) => {
      var _a3;
      const giftId = (_a3 = item.properties) == null ? void 0 : _a3.gift_id;
      if (!giftId)
        return acc;
      if (!acc[giftId])
        acc[giftId] = [];
      acc[giftId].push(item);
      return acc;
    }, {});
    return /* @__PURE__ */ import_react.default.createElement("ul", {
      className: "flex flex-col gap-y-8"
    }, giftSettings.map((setting, index) => /* @__PURE__ */ import_react.default.createElement("li", {
      key: setting.gift_id,
      className: "p-6 mt-8 bg-surface-gray01 border-2 border-surface-gray02"
    }, /* @__PURE__ */ import_react.default.createElement("span", {
      className: "py-1.5 px-3 text-sm font-medium tracking-[1px] leading-6 text-typography-white bg-surface-gray04 rounded-sm"
    }, "\u30AE\u30D5\u30C8", index + 1, "\u3064\u76EE"), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col gap-y-6 items-center mt-4 lg:items-end"
    }, /* @__PURE__ */ import_react.default.createElement("ul", {
      className: "flex flex-col gap-y-6 w-full"
    }, (giftItemsByGiftId[setting.gift_id] ?? []).filter(isNotGiftBox).filter(filterBundledItems).map((item, index2) => /* @__PURE__ */ import_react.default.createElement(GiftLineItem, {
      key: index2,
      item
    }))), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "p-6 w-full bg-typography-white"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "text-sm font-normal tracking-[0.8px] leading-6 text-typography-gray"
    }, setting.paid_box && /* @__PURE__ */ import_react.default.createElement("div", null, /* @__PURE__ */ import_react.default.createElement("span", null, "\u30AE\u30D5\u30C8\u30DC\u30C3\u30AF\u30B9\uFF1A\u3042\u308A"), /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-primary-orange"
    }, (giftItemsByGiftId[setting.gift_id] ?? []).some(
      (i) => {
        var _a3;
        return (_a3 = i.meta) == null ? void 0 : _a3.tags.includes("bundle-gift");
      }
    ) ? `\u7121\u6599` : `\xA5550\u5186\uFF08\u7A0E\u8FBC\uFF09`)), /* @__PURE__ */ import_react.default.createElement("div", null, "\u71A8\u6597\uFF1A", !setting.noshi ? "\u306A\u3057" : /* @__PURE__ */ import_react.default.createElement("span", null, "\u3042\u308A\uFF08", setting.noshi_type, "\uFF0F", setting.noshi_name ?? "\u8A18\u540D\u306A\u3057", "\uFF09"), /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-primary-orange"
    }, "\u7121\u6599")), /* @__PURE__ */ import_react.default.createElement("div", null, "\u30E1\u30C3\u30BB\u30FC\u30B8\u30AB\u30FC\u30C9\uFF1A", !setting.message ? "\u306A\u3057" : /* @__PURE__ */ import_react.default.createElement("span", null, "\u3042\u308A\uFF08", MessageType[setting.message_type], "\uFF0F", setting.message_content, "\uFF09", /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-primary-orange"
    }, "\u7121\u6599"))))), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex gap-x-6"
    }, /* @__PURE__ */ import_react.default.createElement("button", {
      type: "button",
      onClick: async () => {
        if (!confirm("\u30AE\u30D5\u30C8\u8A2D\u5B9A\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"))
          return;
        const cart = await deleteGiftSetting(setting.gift_id);
        window.dispatchEvent(
          new CustomEvent("cart:update", { detail: cart })
        );
      }
    }, /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-sm font-normal leading-6 text-surface-gray05 underline underline-offset-4"
    }, "\u524A\u9664\u3059\u308B")), /* @__PURE__ */ import_react.default.createElement(Button, {
      variant: "secondary-outlined",
      size: "sm",
      type: "button",
      onClick: () => openGiftForm(setting.gift_id)
    }, "\u30AE\u30D5\u30C8\u3092\u7DE8\u96C6"))))));
  };
  var GiftLineItem = ({ item }) => {
    const isSale = item.original_line_price > item.final_line_price;
    return /* @__PURE__ */ import_react.default.createElement("li", {
      className: "flex flex-row gap-x-4 items-center lg:gap-x-10"
    }, /* @__PURE__ */ import_react.default.createElement("img", {
      className: "object-cover max-w-[100px] lg:max-w-[140px]",
      src: item.featured_image.url
    }), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-col gap-y-2 items-start w-full lg:flex-row lg:justify-between lg:items-center"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "font-NotoSerif text-base font-bold tracking-[1px] leading-[30px] text-typography-gray lg:text-lg"
    }, item.product_title), /* @__PURE__ */ import_react.default.createElement("div", {
      className: "flex flex-row gap-x-2 justify-between items-center w-full lg:gap-x-4 lg:w-auto"
    }, /* @__PURE__ */ import_react.default.createElement("span", {
      className: clsx_m_default("text-base font-medium tracking-[1px]", {
        "text-primary-orange": !isSale,
        "text-secondary-red": isSale
      })
    }, formatPrice(item.final_price), "\uFF08\u7A0E\u8FBC\uFF09"), /* @__PURE__ */ import_react.default.createElement("span", {
      className: "text-base font-medium tracking-[1px] text-typography-gray"
    }, "x ", item.quantity))));
  };

  // src/components/preact/components/Cart/CartItems.tsx
  var CartItems = ({
    cartItems,
    giftConfiguredItems,
    giftSettings,
    openGiftForm
  }) => {
    const cartItemsWithoutGift = cartItems.filter(
      (item) => {
        var _a3;
        return ((_a3 = item.properties) == null ? void 0 : _a3.gift_id) === void 0;
      }
    );
    return /* @__PURE__ */ import_react.default.createElement("section", {
      className: "w-full container-base"
    }, /* @__PURE__ */ import_react.default.createElement("div", {
      className: "py-8 border-y border-surface-gray03"
    }, /* @__PURE__ */ import_react.default.createElement(CartLineItemList, {
      cartItems: cartItemsWithoutGift
    }), /* @__PURE__ */ import_react.default.createElement(GiftLineItemListGroup, {
      giftConfiguredItems,
      giftSettings,
      openGiftForm
    })));
  };

  // src/components/preact/components/Cart/CartSection.tsx
  var CartSection = ({ cart, giftBoxPrice }) => {
    const initialGiftConfiguredItems = cart.items.filter(
      (item) => {
        var _a3;
        return ((_a3 = item.properties) == null ? void 0 : _a3.gift_id) !== void 0;
      }
    );
    const [giftFormId, setGiftFormId] = (0, import_react9.useState)(null);
    const openGiftForm = (giftId) => setGiftFormId(giftId);
    const onCloseGiftForm = () => setGiftFormId(null);
    const hasCartItem = cart.items.length > 0;
    const giftConfiguredItems = initialGiftConfiguredItems;
    const giftSettings = getGiftSettings(cart);
    (0, import_react9.useEffect)(() => {
      const handler = () => openGiftForm(giftSettings.length + 1);
      window.addEventListener("giftform:new", handler);
      return () => {
        window.removeEventListener("giftform:new", handler);
      };
    }, [giftSettings]);
    return /* @__PURE__ */ import_react.default.createElement("div", null, !hasCartItem && /* @__PURE__ */ import_react.default.createElement(CartEmpty, null), hasCartItem && /* @__PURE__ */ import_react.default.createElement("cart-items", null, /* @__PURE__ */ import_react.default.createElement(CartItems, {
      cartItems: cart.items,
      giftConfiguredItems,
      giftSettings,
      openGiftForm,
      onCloseGiftForm
    })), hasCartItem && /* @__PURE__ */ import_react.default.createElement(Modal, {
      open: giftFormId !== null,
      onClose: onCloseGiftForm,
      disablePadding: true,
      className: "w-screen h-screen rounded-none lg:max-w-[990px] lg:max-h-[740px] lg:rounded-lg"
    }, giftFormId && /* @__PURE__ */ import_react.default.createElement(GiftForm, {
      cartItems: cart.items.filter(filterBundledItems),
      giftBoxPrice,
      giftId: giftFormId,
      closeGiftForm: onCloseGiftForm
    })));
  };

  // src/components/preact/components/Cart/index.tsx
  var Cart = () => {
    const [cart, setCart] = (0, import_react10.useState)(getCart());
    (0, import_react10.useEffect)(() => {
      const handleCartUpdate = async (e2) => {
        var _a3, _b2;
        const cartJson = await fetchCart();
        const updatedCart = {
          ...cartJson,
          attributes: {
            ...cartJson.attributes,
            gift: (_b2 = (_a3 = cartJson.attributes) == null ? void 0 : _a3.gift) == null ? void 0 : _b2.replace(/&quot;/g, '"')
          },
          items: cartJson.items.map((item) => {
            var _a4;
            return {
              ...item,
              meta: (_a4 = cart.items.find(
                ({ variant_id }) => item.variant_id === variant_id
              )) == null ? void 0 : _a4.meta
            };
          })
        };
        setCartGlobal({ ...updatedCart });
        setCart({ ...updatedCart });
      };
      window.addEventListener(
        "cart:update",
        handleCartUpdate
      );
      return () => {
        window.removeEventListener(
          "cart:update",
          handleCartUpdate
        );
      };
    }, []);
    return /* @__PURE__ */ import_react.default.createElement(CartSection, {
      cart,
      giftBoxPrice: 550
    });
  };

  // src/entries/cart-custom.tsx
  var _a, _b, _c;
  if (!hasMadeToOrder(getLineItems()) && ((_b = (_a = window.eataly) == null ? void 0 : _a.attributes) == null ? void 0 : _b.shipping_date)) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          ...(_c = window.eataly) == null ? void 0 : _c.attributes,
          shipping_date: ""
        }
      })
    });
  }
  var _a2;
  (_a2 = document.getElementById("open-gift-wrapping")) == null ? void 0 : _a2.addEventListener("click", () => {
    window.dispatchEvent(new CustomEvent("giftform:new"));
  });
  (async () => {
    await invalidateOldCartAttributes(getCart());
    (0, import_react_dom.render)(
      /* @__PURE__ */ import_react11.default.createElement("div", null, /* @__PURE__ */ import_react11.default.createElement("h1", {
        className: "mb-14 font-NotoSerif text-2xl text-center"
      }, "\u30AB\u30FC\u30C8"), /* @__PURE__ */ import_react11.default.createElement(Cart, null)),
      document.getElementById("cart-items")
    );
  })();
  var export_React = import_react11.default;
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /** @license React v0.19.1
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  /** @license React v16.14.0
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  /** @license React v16.14.0
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  exports.React = export_React;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
